!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define("react-jsx-parser", ["react"], e) : "object" == typeof exports ? exports["react-jsx-parser"] = e(require("react")) : t["react-jsx-parser"] = e(t.react);
}(this, function (t) {
  return (() => {
    var e = {
        977: (t, e, i) => {
          "use strict";

          const s = i(325),
            r = /^[\da-fA-F]+$/,
            a = /^\d+$/,
            n = new WeakMap();
          function o(t) {
            t = t.Parser.acorn || t;
            let e = n.get(t);
            if (!e) {
              const i = t.tokTypes,
                s = t.TokContext,
                r = t.TokenType,
                a = new s("<tag", !1),
                o = new s("</tag", !1),
                h = new s("<tag>...</tag>", !0, !0),
                p = {
                  tc_oTag: a,
                  tc_cTag: o,
                  tc_expr: h
                },
                c = {
                  jsxName: new r("jsxName"),
                  jsxText: new r("jsxText", {
                    beforeExpr: !0
                  }),
                  jsxTagStart: new r("jsxTagStart", {
                    startsExpr: !0
                  }),
                  jsxTagEnd: new r("jsxTagEnd")
                };
              c.jsxTagStart.updateContext = function () {
                this.context.push(h), this.context.push(a), this.exprAllowed = !1;
              }, c.jsxTagEnd.updateContext = function (t) {
                let e = this.context.pop();
                e === a && t === i.slash || e === o ? (this.context.pop(), this.exprAllowed = this.curContext() === h) : this.exprAllowed = !0;
              }, e = {
                tokContexts: p,
                tokTypes: c
              }, n.set(t, e);
            }
            return e;
          }
          function h(t) {
            return t ? "JSXIdentifier" === t.type ? t.name : "JSXNamespacedName" === t.type ? t.namespace.name + ":" + t.name.name : "JSXMemberExpression" === t.type ? h(t.object) + "." + h(t.property) : void 0 : t;
          }
          t.exports = function (t) {
            return t = t || {}, function (e) {
              return function (t, e) {
                const n = e.acorn || i(234),
                  p = o(n),
                  c = n.tokTypes,
                  l = p.tokTypes,
                  u = n.tokContexts,
                  d = p.tokContexts.tc_oTag,
                  f = p.tokContexts.tc_cTag,
                  m = p.tokContexts.tc_expr,
                  g = n.isNewLine,
                  x = n.isIdentifierStart,
                  y = n.isIdentifierChar;
                return class extends e {
                  static get acornJsx() {
                    return p;
                  }
                  jsx_readToken() {
                    let t = "",
                      e = this.pos;
                    for (;;) {
                      this.pos >= this.input.length && this.raise(this.start, "Unterminated JSX contents");
                      let i = this.input.charCodeAt(this.pos);
                      switch (i) {
                        case 60:
                        case 123:
                          return this.pos === this.start ? 60 === i && this.exprAllowed ? (++this.pos, this.finishToken(l.jsxTagStart)) : this.getTokenFromCode(i) : (t += this.input.slice(e, this.pos), this.finishToken(l.jsxText, t));
                        case 38:
                          t += this.input.slice(e, this.pos), t += this.jsx_readEntity(), e = this.pos;
                          break;
                        case 62:
                        case 125:
                          this.raise(this.pos, "Unexpected token `" + this.input[this.pos] + "`. Did you mean `" + (62 === i ? "&gt;" : "&rbrace;") + '` or `{"' + this.input[this.pos] + '"}`?');
                        default:
                          g(i) ? (t += this.input.slice(e, this.pos), t += this.jsx_readNewLine(!0), e = this.pos) : ++this.pos;
                      }
                    }
                  }
                  jsx_readNewLine(t) {
                    let e,
                      i = this.input.charCodeAt(this.pos);
                    return ++this.pos, 13 === i && 10 === this.input.charCodeAt(this.pos) ? (++this.pos, e = t ? "\n" : "\r\n") : e = String.fromCharCode(i), this.options.locations && (++this.curLine, this.lineStart = this.pos), e;
                  }
                  jsx_readString(t) {
                    let e = "",
                      i = ++this.pos;
                    for (;;) {
                      this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
                      let s = this.input.charCodeAt(this.pos);
                      if (s === t) break;
                      38 === s ? (e += this.input.slice(i, this.pos), e += this.jsx_readEntity(), i = this.pos) : g(s) ? (e += this.input.slice(i, this.pos), e += this.jsx_readNewLine(!1), i = this.pos) : ++this.pos;
                    }
                    return e += this.input.slice(i, this.pos++), this.finishToken(c.string, e);
                  }
                  jsx_readEntity() {
                    let t,
                      e = "",
                      i = 0,
                      n = this.input[this.pos];
                    "&" !== n && this.raise(this.pos, "Entity must start with an ampersand");
                    let o = ++this.pos;
                    for (; this.pos < this.input.length && i++ < 10;) {
                      if (n = this.input[this.pos++], ";" === n) {
                        "#" === e[0] ? "x" === e[1] ? (e = e.substr(2), r.test(e) && (t = String.fromCharCode(parseInt(e, 16)))) : (e = e.substr(1), a.test(e) && (t = String.fromCharCode(parseInt(e, 10)))) : t = s[e];
                        break;
                      }
                      e += n;
                    }
                    return t || (this.pos = o, "&");
                  }
                  jsx_readWord() {
                    let t,
                      e = this.pos;
                    do {
                      t = this.input.charCodeAt(++this.pos);
                    } while (y(t) || 45 === t);
                    return this.finishToken(l.jsxName, this.input.slice(e, this.pos));
                  }
                  jsx_parseIdentifier() {
                    let t = this.startNode();
                    return this.type === l.jsxName ? t.name = this.value : this.type.keyword ? t.name = this.type.keyword : this.unexpected(), this.next(), this.finishNode(t, "JSXIdentifier");
                  }
                  jsx_parseNamespacedName() {
                    let e = this.start,
                      i = this.startLoc,
                      s = this.jsx_parseIdentifier();
                    if (!t.allowNamespaces || !this.eat(c.colon)) return s;
                    var r = this.startNodeAt(e, i);
                    return r.namespace = s, r.name = this.jsx_parseIdentifier(), this.finishNode(r, "JSXNamespacedName");
                  }
                  jsx_parseElementName() {
                    if (this.type === l.jsxTagEnd) return "";
                    let e = this.start,
                      i = this.startLoc,
                      s = this.jsx_parseNamespacedName();
                    for (this.type !== c.dot || "JSXNamespacedName" !== s.type || t.allowNamespacedObjects || this.unexpected(); this.eat(c.dot);) {
                      let t = this.startNodeAt(e, i);
                      t.object = s, t.property = this.jsx_parseIdentifier(), s = this.finishNode(t, "JSXMemberExpression");
                    }
                    return s;
                  }
                  jsx_parseAttributeValue() {
                    switch (this.type) {
                      case c.braceL:
                        let t = this.jsx_parseExpressionContainer();
                        return "JSXEmptyExpression" === t.expression.type && this.raise(t.start, "JSX attributes must only be assigned a non-empty expression"), t;
                      case l.jsxTagStart:
                      case c.string:
                        return this.parseExprAtom();
                      default:
                        this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
                    }
                  }
                  jsx_parseEmptyExpression() {
                    let t = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
                    return this.finishNodeAt(t, "JSXEmptyExpression", this.start, this.startLoc);
                  }
                  jsx_parseExpressionContainer() {
                    let t = this.startNode();
                    return this.next(), t.expression = this.type === c.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression(), this.expect(c.braceR), this.finishNode(t, "JSXExpressionContainer");
                  }
                  jsx_parseAttribute() {
                    let t = this.startNode();
                    return this.eat(c.braceL) ? (this.expect(c.ellipsis), t.argument = this.parseMaybeAssign(), this.expect(c.braceR), this.finishNode(t, "JSXSpreadAttribute")) : (t.name = this.jsx_parseNamespacedName(), t.value = this.eat(c.eq) ? this.jsx_parseAttributeValue() : null, this.finishNode(t, "JSXAttribute"));
                  }
                  jsx_parseOpeningElementAt(e, i) {
                    let s = this.startNodeAt(e, i);
                    s.attributes = [];
                    let r = this.jsx_parseElementName();
                    for (r && (s.name = r); this.type !== c.slash && this.type !== l.jsxTagEnd;) s.attributes.push(this.jsx_parseAttribute());
                    s.selfClosing = this.eat(c.slash), this.expect(l.jsxTagEnd);
                    const a = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"];
                    return t.autoCloseVoidElements && r && a.includes(r.name) && (s.selfClosing = !0), this.finishNode(s, r ? "JSXOpeningElement" : "JSXOpeningFragment");
                  }
                  jsx_parseClosingElementAt(t, e) {
                    let i = this.startNodeAt(t, e),
                      s = this.jsx_parseElementName();
                    return s && (i.name = s), this.expect(l.jsxTagEnd), this.finishNode(i, s ? "JSXClosingElement" : "JSXClosingFragment");
                  }
                  jsx_parseElementAt(t, e) {
                    let i = this.startNodeAt(t, e),
                      s = [],
                      r = this.jsx_parseOpeningElementAt(t, e),
                      a = null;
                    if (!r.selfClosing) {
                      t: for (;;) switch (this.type) {
                        case l.jsxTagStart:
                          if (t = this.start, e = this.startLoc, this.next(), this.eat(c.slash)) {
                            a = this.jsx_parseClosingElementAt(t, e);
                            break t;
                          }
                          s.push(this.jsx_parseElementAt(t, e));
                          break;
                        case l.jsxText:
                          s.push(this.parseExprAtom());
                          break;
                        case c.braceL:
                          s.push(this.jsx_parseExpressionContainer());
                          break;
                        default:
                          this.unexpected();
                      }
                      h(a.name) !== h(r.name) && this.raise(a.start, "Expected corresponding JSX closing tag for <" + h(r.name) + ">");
                    }
                    let n = r.name ? "Element" : "Fragment";
                    return i["opening" + n] = r, i["closing" + n] = a, i.children = s, this.type === c.relational && "<" === this.value && this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag"), this.finishNode(i, "JSX" + n);
                  }
                  jsx_parseText() {
                    let t = this.parseLiteral(this.value);
                    return t.type = "JSXText", t;
                  }
                  jsx_parseElement() {
                    let t = this.start,
                      e = this.startLoc;
                    return this.next(), this.jsx_parseElementAt(t, e);
                  }
                  parseExprAtom(t) {
                    return this.type === l.jsxText ? this.jsx_parseText() : this.type === l.jsxTagStart ? this.jsx_parseElement() : super.parseExprAtom(t);
                  }
                  readToken(t) {
                    let e = this.curContext();
                    if (e === m) return this.jsx_readToken();
                    if (e === d || e === f) {
                      if (x(t)) return this.jsx_readWord();
                      if (62 == t) return ++this.pos, this.finishToken(l.jsxTagEnd);
                      if ((34 === t || 39 === t) && e == d) return this.jsx_readString(t);
                    }
                    return 60 === t && this.exprAllowed && 33 !== this.input.charCodeAt(this.pos + 1) ? (++this.pos, this.finishToken(l.jsxTagStart)) : super.readToken(t);
                  }
                  updateContext(t) {
                    if (this.type == c.braceL) {
                      var e = this.curContext();
                      e == d ? this.context.push(u.b_expr) : e == m ? this.context.push(u.b_tmpl) : super.updateContext(t), this.exprAllowed = !0;
                    } else {
                      if (this.type !== c.slash || t !== l.jsxTagStart) return super.updateContext(t);
                      this.context.length -= 2, this.context.push(f), this.exprAllowed = !1;
                    }
                  }
                };
              }({
                allowNamespaces: !1 !== t.allowNamespaces,
                allowNamespacedObjects: !!t.allowNamespacedObjects,
                autoCloseVoidElements: !!t.autoCloseVoidElements
              }, e);
            };
          }, Object.defineProperty(t.exports, "tokTypes", {
            get: function () {
              return o(i(234)).tokTypes;
            },
            configurable: !0,
            enumerable: !0
          });
        },
        325: t => {
          t.exports = {
            quot: '"',
            amp: "&",
            apos: "'",
            lt: "<",
            gt: ">",
            nbsp: " ",
            iexcl: "¡",
            cent: "¢",
            pound: "£",
            curren: "¤",
            yen: "¥",
            brvbar: "¦",
            sect: "§",
            uml: "¨",
            copy: "©",
            ordf: "ª",
            laquo: "«",
            not: "¬",
            shy: "­",
            reg: "®",
            macr: "¯",
            deg: "°",
            plusmn: "±",
            sup2: "²",
            sup3: "³",
            acute: "´",
            micro: "µ",
            para: "¶",
            middot: "·",
            cedil: "¸",
            sup1: "¹",
            ordm: "º",
            raquo: "»",
            frac14: "¼",
            frac12: "½",
            frac34: "¾",
            iquest: "¿",
            Agrave: "À",
            Aacute: "Á",
            Acirc: "Â",
            Atilde: "Ã",
            Auml: "Ä",
            Aring: "Å",
            AElig: "Æ",
            Ccedil: "Ç",
            Egrave: "È",
            Eacute: "É",
            Ecirc: "Ê",
            Euml: "Ë",
            Igrave: "Ì",
            Iacute: "Í",
            Icirc: "Î",
            Iuml: "Ï",
            ETH: "Ð",
            Ntilde: "Ñ",
            Ograve: "Ò",
            Oacute: "Ó",
            Ocirc: "Ô",
            Otilde: "Õ",
            Ouml: "Ö",
            times: "×",
            Oslash: "Ø",
            Ugrave: "Ù",
            Uacute: "Ú",
            Ucirc: "Û",
            Uuml: "Ü",
            Yacute: "Ý",
            THORN: "Þ",
            szlig: "ß",
            agrave: "à",
            aacute: "á",
            acirc: "â",
            atilde: "ã",
            auml: "ä",
            aring: "å",
            aelig: "æ",
            ccedil: "ç",
            egrave: "è",
            eacute: "é",
            ecirc: "ê",
            euml: "ë",
            igrave: "ì",
            iacute: "í",
            icirc: "î",
            iuml: "ï",
            eth: "ð",
            ntilde: "ñ",
            ograve: "ò",
            oacute: "ó",
            ocirc: "ô",
            otilde: "õ",
            ouml: "ö",
            divide: "÷",
            oslash: "ø",
            ugrave: "ù",
            uacute: "ú",
            ucirc: "û",
            uuml: "ü",
            yacute: "ý",
            thorn: "þ",
            yuml: "ÿ",
            OElig: "Œ",
            oelig: "œ",
            Scaron: "Š",
            scaron: "š",
            Yuml: "Ÿ",
            fnof: "ƒ",
            circ: "ˆ",
            tilde: "˜",
            Alpha: "Α",
            Beta: "Β",
            Gamma: "Γ",
            Delta: "Δ",
            Epsilon: "Ε",
            Zeta: "Ζ",
            Eta: "Η",
            Theta: "Θ",
            Iota: "Ι",
            Kappa: "Κ",
            Lambda: "Λ",
            Mu: "Μ",
            Nu: "Ν",
            Xi: "Ξ",
            Omicron: "Ο",
            Pi: "Π",
            Rho: "Ρ",
            Sigma: "Σ",
            Tau: "Τ",
            Upsilon: "Υ",
            Phi: "Φ",
            Chi: "Χ",
            Psi: "Ψ",
            Omega: "Ω",
            alpha: "α",
            beta: "β",
            gamma: "γ",
            delta: "δ",
            epsilon: "ε",
            zeta: "ζ",
            eta: "η",
            theta: "θ",
            iota: "ι",
            kappa: "κ",
            lambda: "λ",
            mu: "μ",
            nu: "ν",
            xi: "ξ",
            omicron: "ο",
            pi: "π",
            rho: "ρ",
            sigmaf: "ς",
            sigma: "σ",
            tau: "τ",
            upsilon: "υ",
            phi: "φ",
            chi: "χ",
            psi: "ψ",
            omega: "ω",
            thetasym: "ϑ",
            upsih: "ϒ",
            piv: "ϖ",
            ensp: " ",
            emsp: " ",
            thinsp: " ",
            zwnj: "‌",
            zwj: "‍",
            lrm: "‎",
            rlm: "‏",
            ndash: "–",
            mdash: "—",
            lsquo: "‘",
            rsquo: "’",
            sbquo: "‚",
            ldquo: "“",
            rdquo: "”",
            bdquo: "„",
            dagger: "†",
            Dagger: "‡",
            bull: "•",
            hellip: "…",
            permil: "‰",
            prime: "′",
            Prime: "″",
            lsaquo: "‹",
            rsaquo: "›",
            oline: "‾",
            frasl: "⁄",
            euro: "€",
            image: "ℑ",
            weierp: "℘",
            real: "ℜ",
            trade: "™",
            alefsym: "ℵ",
            larr: "←",
            uarr: "↑",
            rarr: "→",
            darr: "↓",
            harr: "↔",
            crarr: "↵",
            lArr: "⇐",
            uArr: "⇑",
            rArr: "⇒",
            dArr: "⇓",
            hArr: "⇔",
            forall: "∀",
            part: "∂",
            exist: "∃",
            empty: "∅",
            nabla: "∇",
            isin: "∈",
            notin: "∉",
            ni: "∋",
            prod: "∏",
            sum: "∑",
            minus: "−",
            lowast: "∗",
            radic: "√",
            prop: "∝",
            infin: "∞",
            ang: "∠",
            and: "∧",
            or: "∨",
            cap: "∩",
            cup: "∪",
            int: "∫",
            there4: "∴",
            sim: "∼",
            cong: "≅",
            asymp: "≈",
            ne: "≠",
            equiv: "≡",
            le: "≤",
            ge: "≥",
            sub: "⊂",
            sup: "⊃",
            nsub: "⊄",
            sube: "⊆",
            supe: "⊇",
            oplus: "⊕",
            otimes: "⊗",
            perp: "⊥",
            sdot: "⋅",
            lceil: "⌈",
            rceil: "⌉",
            lfloor: "⌊",
            rfloor: "⌋",
            lang: "〈",
            rang: "〉",
            loz: "◊",
            spades: "♠",
            clubs: "♣",
            hearts: "♥",
            diams: "♦"
          };
        },
        234: function (t, e) {
          !function (t) {
            "use strict";

            var e = {
                3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
                5: "class enum extends super const export import",
                6: "enum",
                strict: "implements interface let package private protected public static yield",
                strictBind: "eval arguments"
              },
              i = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this",
              s = {
                5: i,
                "5module": i + " export import",
                6: i + " const class extends export import super"
              },
              r = /^in(stanceof)?$/,
              a = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࢠ-ࢴࢶ-ࣇऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-鿼ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞿꟂ-ꟊꟵ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
              n = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࣓-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-ໍ໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜔ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠐-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿᫀᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷹᷻-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿",
              o = new RegExp("[" + a + "]"),
              h = new RegExp("[" + a + n + "]");
            a = n = null;
            var p = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 107, 20, 28, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 190, 0, 80, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8952, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42717, 35, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938],
              c = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 154, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
            function l(t, e) {
              for (var i = 65536, s = 0; s < e.length; s += 2) {
                if ((i += e[s]) > t) return !1;
                if ((i += e[s + 1]) >= t) return !0;
              }
            }
            function u(t, e) {
              return t < 65 ? 36 === t : t < 91 || (t < 97 ? 95 === t : t < 123 || (t <= 65535 ? t >= 170 && o.test(String.fromCharCode(t)) : !1 !== e && l(t, p)));
            }
            function d(t, e) {
              return t < 48 ? 36 === t : t < 58 || !(t < 65) && (t < 91 || (t < 97 ? 95 === t : t < 123 || (t <= 65535 ? t >= 170 && h.test(String.fromCharCode(t)) : !1 !== e && (l(t, p) || l(t, c)))));
            }
            var f = function (t, e) {
              void 0 === e && (e = {}), this.label = t, this.keyword = e.keyword, this.beforeExpr = !!e.beforeExpr, this.startsExpr = !!e.startsExpr, this.isLoop = !!e.isLoop, this.isAssign = !!e.isAssign, this.prefix = !!e.prefix, this.postfix = !!e.postfix, this.binop = e.binop || null, this.updateContext = null;
            };
            function m(t, e) {
              return new f(t, {
                beforeExpr: !0,
                binop: e
              });
            }
            var g = {
                beforeExpr: !0
              },
              x = {
                startsExpr: !0
              },
              y = {};
            function v(t, e) {
              return void 0 === e && (e = {}), e.keyword = t, y[t] = new f(t, e);
            }
            var b = {
                num: new f("num", x),
                regexp: new f("regexp", x),
                string: new f("string", x),
                name: new f("name", x),
                eof: new f("eof"),
                bracketL: new f("[", {
                  beforeExpr: !0,
                  startsExpr: !0
                }),
                bracketR: new f("]"),
                braceL: new f("{", {
                  beforeExpr: !0,
                  startsExpr: !0
                }),
                braceR: new f("}"),
                parenL: new f("(", {
                  beforeExpr: !0,
                  startsExpr: !0
                }),
                parenR: new f(")"),
                comma: new f(",", g),
                semi: new f(";", g),
                colon: new f(":", g),
                dot: new f("."),
                question: new f("?", g),
                questionDot: new f("?."),
                arrow: new f("=>", g),
                template: new f("template"),
                invalidTemplate: new f("invalidTemplate"),
                ellipsis: new f("...", g),
                backQuote: new f("`", x),
                dollarBraceL: new f("${", {
                  beforeExpr: !0,
                  startsExpr: !0
                }),
                eq: new f("=", {
                  beforeExpr: !0,
                  isAssign: !0
                }),
                assign: new f("_=", {
                  beforeExpr: !0,
                  isAssign: !0
                }),
                incDec: new f("++/--", {
                  prefix: !0,
                  postfix: !0,
                  startsExpr: !0
                }),
                prefix: new f("!/~", {
                  beforeExpr: !0,
                  prefix: !0,
                  startsExpr: !0
                }),
                logicalOR: m("||", 1),
                logicalAND: m("&&", 2),
                bitwiseOR: m("|", 3),
                bitwiseXOR: m("^", 4),
                bitwiseAND: m("&", 5),
                equality: m("==/!=/===/!==", 6),
                relational: m("</>/<=/>=", 7),
                bitShift: m("<</>>/>>>", 8),
                plusMin: new f("+/-", {
                  beforeExpr: !0,
                  binop: 9,
                  prefix: !0,
                  startsExpr: !0
                }),
                modulo: m("%", 10),
                star: m("*", 10),
                slash: m("/", 10),
                starstar: new f("**", {
                  beforeExpr: !0
                }),
                coalesce: m("??", 1),
                _break: v("break"),
                _case: v("case", g),
                _catch: v("catch"),
                _continue: v("continue"),
                _debugger: v("debugger"),
                _default: v("default", g),
                _do: v("do", {
                  isLoop: !0,
                  beforeExpr: !0
                }),
                _else: v("else", g),
                _finally: v("finally"),
                _for: v("for", {
                  isLoop: !0
                }),
                _function: v("function", x),
                _if: v("if"),
                _return: v("return", g),
                _switch: v("switch"),
                _throw: v("throw", g),
                _try: v("try"),
                _var: v("var"),
                _const: v("const"),
                _while: v("while", {
                  isLoop: !0
                }),
                _with: v("with"),
                _new: v("new", {
                  beforeExpr: !0,
                  startsExpr: !0
                }),
                _this: v("this", x),
                _super: v("super", x),
                _class: v("class", x),
                _extends: v("extends", g),
                _export: v("export"),
                _import: v("import", x),
                _null: v("null", x),
                _true: v("true", x),
                _false: v("false", x),
                _in: v("in", {
                  beforeExpr: !0,
                  binop: 7
                }),
                _instanceof: v("instanceof", {
                  beforeExpr: !0,
                  binop: 7
                }),
                _typeof: v("typeof", {
                  beforeExpr: !0,
                  prefix: !0,
                  startsExpr: !0
                }),
                _void: v("void", {
                  beforeExpr: !0,
                  prefix: !0,
                  startsExpr: !0
                }),
                _delete: v("delete", {
                  beforeExpr: !0,
                  prefix: !0,
                  startsExpr: !0
                })
              },
              _ = /\r\n?|\n|\u2028|\u2029/,
              k = new RegExp(_.source, "g");
            function S(t, e) {
              return 10 === t || 13 === t || !e && (8232 === t || 8233 === t);
            }
            var w = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/,
              C = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g,
              E = Object.prototype,
              A = E.hasOwnProperty,
              I = E.toString;
            function P(t, e) {
              return A.call(t, e);
            }
            var T = Array.isArray || function (t) {
              return "[object Array]" === I.call(t);
            };
            function N(t) {
              return new RegExp("^(?:" + t.replace(/ /g, "|") + ")$");
            }
            var L = function (t, e) {
              this.line = t, this.column = e;
            };
            L.prototype.offset = function (t) {
              return new L(this.line, this.column + t);
            };
            var V = function (t, e, i) {
              this.start = e, this.end = i, null !== t.sourceFile && (this.source = t.sourceFile);
            };
            function O(t, e) {
              for (var i = 1, s = 0;;) {
                k.lastIndex = s;
                var r = k.exec(t);
                if (!(r && r.index < e)) return new L(i, e - s);
                ++i, s = r.index + r[0].length;
              }
            }
            var R = {
                ecmaVersion: null,
                sourceType: "script",
                onInsertedSemicolon: null,
                onTrailingComma: null,
                allowReserved: null,
                allowReturnOutsideFunction: !1,
                allowImportExportEverywhere: !1,
                allowAwaitOutsideFunction: !1,
                allowHashBang: !1,
                locations: !1,
                onToken: null,
                onComment: null,
                ranges: !1,
                program: null,
                sourceFile: null,
                directSourceFile: null,
                preserveParens: !1
              },
              M = !1;
            function B(t) {
              var e = {};
              for (var i in R) e[i] = t && P(t, i) ? t[i] : R[i];
              if ("latest" === e.ecmaVersion ? e.ecmaVersion = 1e8 : null == e.ecmaVersion ? (!M && "object" == typeof console && console.warn && (M = !0, console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.")), e.ecmaVersion = 11) : e.ecmaVersion >= 2015 && (e.ecmaVersion -= 2009), null == e.allowReserved && (e.allowReserved = e.ecmaVersion < 5), T(e.onToken)) {
                var s = e.onToken;
                e.onToken = function (t) {
                  return s.push(t);
                };
              }
              return T(e.onComment) && (e.onComment = D(e, e.onComment)), e;
            }
            function D(t, e) {
              return function (i, s, r, a, n, o) {
                var h = {
                  type: i ? "Block" : "Line",
                  value: s,
                  start: r,
                  end: a
                };
                t.locations && (h.loc = new V(this, n, o)), t.ranges && (h.range = [r, a]), e.push(h);
              };
            }
            var j = 1,
              U = 2,
              F = j | U,
              q = 4,
              G = 8,
              H = 16,
              W = 32,
              z = 64,
              K = 128;
            function X(t, e) {
              return U | (t ? q : 0) | (e ? G : 0);
            }
            var Q = 0,
              J = 1,
              Y = 2,
              Z = 3,
              $ = 4,
              tt = 5,
              et = function (t, i, r) {
                this.options = t = B(t), this.sourceFile = t.sourceFile, this.keywords = N(s[t.ecmaVersion >= 6 ? 6 : "module" === t.sourceType ? "5module" : 5]);
                var a = "";
                !0 !== t.allowReserved && (a = e[t.ecmaVersion >= 6 ? 6 : 5 === t.ecmaVersion ? 5 : 3], "module" === t.sourceType && (a += " await")), this.reservedWords = N(a);
                var n = (a ? a + " " : "") + e.strict;
                this.reservedWordsStrict = N(n), this.reservedWordsStrictBind = N(n + " " + e.strictBind), this.input = String(i), this.containsEsc = !1, r ? (this.pos = r, this.lineStart = this.input.lastIndexOf("\n", r - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(_).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = b.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = "module" === t.sourceType, this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = Object.create(null), 0 === this.pos && t.allowHashBang && "#!" === this.input.slice(0, 2) && this.skipLineComment(2), this.scopeStack = [], this.enterScope(j), this.regexpState = null;
              },
              it = {
                inFunction: {
                  configurable: !0
                },
                inGenerator: {
                  configurable: !0
                },
                inAsync: {
                  configurable: !0
                },
                allowSuper: {
                  configurable: !0
                },
                allowDirectSuper: {
                  configurable: !0
                },
                treatFunctionsAsVar: {
                  configurable: !0
                },
                inNonArrowFunction: {
                  configurable: !0
                }
              };
            et.prototype.parse = function () {
              var t = this.options.program || this.startNode();
              return this.nextToken(), this.parseTopLevel(t);
            }, it.inFunction.get = function () {
              return (this.currentVarScope().flags & U) > 0;
            }, it.inGenerator.get = function () {
              return (this.currentVarScope().flags & G) > 0;
            }, it.inAsync.get = function () {
              return (this.currentVarScope().flags & q) > 0;
            }, it.allowSuper.get = function () {
              return (this.currentThisScope().flags & z) > 0;
            }, it.allowDirectSuper.get = function () {
              return (this.currentThisScope().flags & K) > 0;
            }, it.treatFunctionsAsVar.get = function () {
              return this.treatFunctionsAsVarInScope(this.currentScope());
            }, it.inNonArrowFunction.get = function () {
              return (this.currentThisScope().flags & U) > 0;
            }, et.extend = function () {
              for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
              for (var i = this, s = 0; s < t.length; s++) i = t[s](i);
              return i;
            }, et.parse = function (t, e) {
              return new this(e, t).parse();
            }, et.parseExpressionAt = function (t, e, i) {
              var s = new this(i, t, e);
              return s.nextToken(), s.parseExpression();
            }, et.tokenizer = function (t, e) {
              return new this(e, t);
            }, Object.defineProperties(et.prototype, it);
            var st = et.prototype,
              rt = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
            function at() {
              this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
            }
            st.strictDirective = function (t) {
              for (;;) {
                C.lastIndex = t, t += C.exec(this.input)[0].length;
                var e = rt.exec(this.input.slice(t));
                if (!e) return !1;
                if ("use strict" === (e[1] || e[2])) {
                  C.lastIndex = t + e[0].length;
                  var i = C.exec(this.input),
                    s = i.index + i[0].length,
                    r = this.input.charAt(s);
                  return ";" === r || "}" === r || _.test(i[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(r) || "!" === r && "=" === this.input.charAt(s + 1));
                }
                t += e[0].length, C.lastIndex = t, t += C.exec(this.input)[0].length, ";" === this.input[t] && t++;
              }
            }, st.eat = function (t) {
              return this.type === t && (this.next(), !0);
            }, st.isContextual = function (t) {
              return this.type === b.name && this.value === t && !this.containsEsc;
            }, st.eatContextual = function (t) {
              return !!this.isContextual(t) && (this.next(), !0);
            }, st.expectContextual = function (t) {
              this.eatContextual(t) || this.unexpected();
            }, st.canInsertSemicolon = function () {
              return this.type === b.eof || this.type === b.braceR || _.test(this.input.slice(this.lastTokEnd, this.start));
            }, st.insertSemicolon = function () {
              if (this.canInsertSemicolon()) return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
            }, st.semicolon = function () {
              this.eat(b.semi) || this.insertSemicolon() || this.unexpected();
            }, st.afterTrailingComma = function (t, e) {
              if (this.type === t) return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), e || this.next(), !0;
            }, st.expect = function (t) {
              this.eat(t) || this.unexpected();
            }, st.unexpected = function (t) {
              this.raise(null != t ? t : this.start, "Unexpected token");
            }, st.checkPatternErrors = function (t, e) {
              if (t) {
                t.trailingComma > -1 && this.raiseRecoverable(t.trailingComma, "Comma is not permitted after the rest element");
                var i = e ? t.parenthesizedAssign : t.parenthesizedBind;
                i > -1 && this.raiseRecoverable(i, "Parenthesized pattern");
              }
            }, st.checkExpressionErrors = function (t, e) {
              if (!t) return !1;
              var i = t.shorthandAssign,
                s = t.doubleProto;
              if (!e) return i >= 0 || s >= 0;
              i >= 0 && this.raise(i, "Shorthand property assignments are valid only in destructuring patterns"), s >= 0 && this.raiseRecoverable(s, "Redefinition of __proto__ property");
            }, st.checkYieldAwaitInDefaultParams = function () {
              this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
            }, st.isSimpleAssignTarget = function (t) {
              return "ParenthesizedExpression" === t.type ? this.isSimpleAssignTarget(t.expression) : "Identifier" === t.type || "MemberExpression" === t.type;
            };
            var nt = et.prototype;
            nt.parseTopLevel = function (t) {
              var e = Object.create(null);
              for (t.body || (t.body = []); this.type !== b.eof;) {
                var i = this.parseStatement(null, !0, e);
                t.body.push(i);
              }
              if (this.inModule) for (var s = 0, r = Object.keys(this.undefinedExports); s < r.length; s += 1) {
                var a = r[s];
                this.raiseRecoverable(this.undefinedExports[a].start, "Export '" + a + "' is not defined");
              }
              return this.adaptDirectivePrologue(t.body), this.next(), t.sourceType = this.options.sourceType, this.finishNode(t, "Program");
            };
            var ot = {
                kind: "loop"
              },
              ht = {
                kind: "switch"
              };
            nt.isLet = function (t) {
              if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return !1;
              C.lastIndex = this.pos;
              var e = C.exec(this.input),
                i = this.pos + e[0].length,
                s = this.input.charCodeAt(i);
              if (91 === s) return !0;
              if (t) return !1;
              if (123 === s) return !0;
              if (u(s, !0)) {
                for (var a = i + 1; d(this.input.charCodeAt(a), !0);) ++a;
                var n = this.input.slice(i, a);
                if (!r.test(n)) return !0;
              }
              return !1;
            }, nt.isAsyncFunction = function () {
              if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return !1;
              C.lastIndex = this.pos;
              var t = C.exec(this.input),
                e = this.pos + t[0].length;
              return !(_.test(this.input.slice(this.pos, e)) || "function" !== this.input.slice(e, e + 8) || e + 8 !== this.input.length && d(this.input.charAt(e + 8)));
            }, nt.parseStatement = function (t, e, i) {
              var s,
                r = this.type,
                a = this.startNode();
              switch (this.isLet(t) && (r = b._var, s = "let"), r) {
                case b._break:
                case b._continue:
                  return this.parseBreakContinueStatement(a, r.keyword);
                case b._debugger:
                  return this.parseDebuggerStatement(a);
                case b._do:
                  return this.parseDoStatement(a);
                case b._for:
                  return this.parseForStatement(a);
                case b._function:
                  return t && (this.strict || "if" !== t && "label" !== t) && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a, !1, !t);
                case b._class:
                  return t && this.unexpected(), this.parseClass(a, !0);
                case b._if:
                  return this.parseIfStatement(a);
                case b._return:
                  return this.parseReturnStatement(a);
                case b._switch:
                  return this.parseSwitchStatement(a);
                case b._throw:
                  return this.parseThrowStatement(a);
                case b._try:
                  return this.parseTryStatement(a);
                case b._const:
                case b._var:
                  return s = s || this.value, t && "var" !== s && this.unexpected(), this.parseVarStatement(a, s);
                case b._while:
                  return this.parseWhileStatement(a);
                case b._with:
                  return this.parseWithStatement(a);
                case b.braceL:
                  return this.parseBlock(!0, a);
                case b.semi:
                  return this.parseEmptyStatement(a);
                case b._export:
                case b._import:
                  if (this.options.ecmaVersion > 10 && r === b._import) {
                    C.lastIndex = this.pos;
                    var n = C.exec(this.input),
                      o = this.pos + n[0].length,
                      h = this.input.charCodeAt(o);
                    if (40 === h || 46 === h) return this.parseExpressionStatement(a, this.parseExpression());
                  }
                  return this.options.allowImportExportEverywhere || (e || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), r === b._import ? this.parseImport(a) : this.parseExport(a, i);
                default:
                  if (this.isAsyncFunction()) return t && this.unexpected(), this.next(), this.parseFunctionStatement(a, !0, !t);
                  var p = this.value,
                    c = this.parseExpression();
                  return r === b.name && "Identifier" === c.type && this.eat(b.colon) ? this.parseLabeledStatement(a, p, c, t) : this.parseExpressionStatement(a, c);
              }
            }, nt.parseBreakContinueStatement = function (t, e) {
              var i = "break" === e;
              this.next(), this.eat(b.semi) || this.insertSemicolon() ? t.label = null : this.type !== b.name ? this.unexpected() : (t.label = this.parseIdent(), this.semicolon());
              for (var s = 0; s < this.labels.length; ++s) {
                var r = this.labels[s];
                if (null == t.label || r.name === t.label.name) {
                  if (null != r.kind && (i || "loop" === r.kind)) break;
                  if (t.label && i) break;
                }
              }
              return s === this.labels.length && this.raise(t.start, "Unsyntactic " + e), this.finishNode(t, i ? "BreakStatement" : "ContinueStatement");
            }, nt.parseDebuggerStatement = function (t) {
              return this.next(), this.semicolon(), this.finishNode(t, "DebuggerStatement");
            }, nt.parseDoStatement = function (t) {
              return this.next(), this.labels.push(ot), t.body = this.parseStatement("do"), this.labels.pop(), this.expect(b._while), t.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(b.semi) : this.semicolon(), this.finishNode(t, "DoWhileStatement");
            }, nt.parseForStatement = function (t) {
              this.next();
              var e = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
              if (this.labels.push(ot), this.enterScope(0), this.expect(b.parenL), this.type === b.semi) return e > -1 && this.unexpected(e), this.parseFor(t, null);
              var i = this.isLet();
              if (this.type === b._var || this.type === b._const || i) {
                var s = this.startNode(),
                  r = i ? "let" : this.value;
                return this.next(), this.parseVar(s, !0, r), this.finishNode(s, "VariableDeclaration"), (this.type === b._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && 1 === s.declarations.length ? (this.options.ecmaVersion >= 9 && (this.type === b._in ? e > -1 && this.unexpected(e) : t.await = e > -1), this.parseForIn(t, s)) : (e > -1 && this.unexpected(e), this.parseFor(t, s));
              }
              var a = new at(),
                n = this.parseExpression(!0, a);
              return this.type === b._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === b._in ? e > -1 && this.unexpected(e) : t.await = e > -1), this.toAssignable(n, !1, a), this.checkLValPattern(n), this.parseForIn(t, n)) : (this.checkExpressionErrors(a, !0), e > -1 && this.unexpected(e), this.parseFor(t, n));
            }, nt.parseFunctionStatement = function (t, e, i) {
              return this.next(), this.parseFunction(t, ct | (i ? 0 : lt), !1, e);
            }, nt.parseIfStatement = function (t) {
              return this.next(), t.test = this.parseParenExpression(), t.consequent = this.parseStatement("if"), t.alternate = this.eat(b._else) ? this.parseStatement("if") : null, this.finishNode(t, "IfStatement");
            }, nt.parseReturnStatement = function (t) {
              return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(b.semi) || this.insertSemicolon() ? t.argument = null : (t.argument = this.parseExpression(), this.semicolon()), this.finishNode(t, "ReturnStatement");
            }, nt.parseSwitchStatement = function (t) {
              var e;
              this.next(), t.discriminant = this.parseParenExpression(), t.cases = [], this.expect(b.braceL), this.labels.push(ht), this.enterScope(0);
              for (var i = !1; this.type !== b.braceR;) if (this.type === b._case || this.type === b._default) {
                var s = this.type === b._case;
                e && this.finishNode(e, "SwitchCase"), t.cases.push(e = this.startNode()), e.consequent = [], this.next(), s ? e.test = this.parseExpression() : (i && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), i = !0, e.test = null), this.expect(b.colon);
              } else e || this.unexpected(), e.consequent.push(this.parseStatement(null));
              return this.exitScope(), e && this.finishNode(e, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(t, "SwitchStatement");
            }, nt.parseThrowStatement = function (t) {
              return this.next(), _.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), t.argument = this.parseExpression(), this.semicolon(), this.finishNode(t, "ThrowStatement");
            };
            var pt = [];
            nt.parseTryStatement = function (t) {
              if (this.next(), t.block = this.parseBlock(), t.handler = null, this.type === b._catch) {
                var e = this.startNode();
                if (this.next(), this.eat(b.parenL)) {
                  e.param = this.parseBindingAtom();
                  var i = "Identifier" === e.param.type;
                  this.enterScope(i ? W : 0), this.checkLValPattern(e.param, i ? $ : Y), this.expect(b.parenR);
                } else this.options.ecmaVersion < 10 && this.unexpected(), e.param = null, this.enterScope(0);
                e.body = this.parseBlock(!1), this.exitScope(), t.handler = this.finishNode(e, "CatchClause");
              }
              return t.finalizer = this.eat(b._finally) ? this.parseBlock() : null, t.handler || t.finalizer || this.raise(t.start, "Missing catch or finally clause"), this.finishNode(t, "TryStatement");
            }, nt.parseVarStatement = function (t, e) {
              return this.next(), this.parseVar(t, !1, e), this.semicolon(), this.finishNode(t, "VariableDeclaration");
            }, nt.parseWhileStatement = function (t) {
              return this.next(), t.test = this.parseParenExpression(), this.labels.push(ot), t.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(t, "WhileStatement");
            }, nt.parseWithStatement = function (t) {
              return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), t.object = this.parseParenExpression(), t.body = this.parseStatement("with"), this.finishNode(t, "WithStatement");
            }, nt.parseEmptyStatement = function (t) {
              return this.next(), this.finishNode(t, "EmptyStatement");
            }, nt.parseLabeledStatement = function (t, e, i, s) {
              for (var r = 0, a = this.labels; r < a.length; r += 1) a[r].name === e && this.raise(i.start, "Label '" + e + "' is already declared");
              for (var n = this.type.isLoop ? "loop" : this.type === b._switch ? "switch" : null, o = this.labels.length - 1; o >= 0; o--) {
                var h = this.labels[o];
                if (h.statementStart !== t.start) break;
                h.statementStart = this.start, h.kind = n;
              }
              return this.labels.push({
                name: e,
                kind: n,
                statementStart: this.start
              }), t.body = this.parseStatement(s ? -1 === s.indexOf("label") ? s + "label" : s : "label"), this.labels.pop(), t.label = i, this.finishNode(t, "LabeledStatement");
            }, nt.parseExpressionStatement = function (t, e) {
              return t.expression = e, this.semicolon(), this.finishNode(t, "ExpressionStatement");
            }, nt.parseBlock = function (t, e, i) {
              for (void 0 === t && (t = !0), void 0 === e && (e = this.startNode()), e.body = [], this.expect(b.braceL), t && this.enterScope(0); this.type !== b.braceR;) {
                var s = this.parseStatement(null);
                e.body.push(s);
              }
              return i && (this.strict = !1), this.next(), t && this.exitScope(), this.finishNode(e, "BlockStatement");
            }, nt.parseFor = function (t, e) {
              return t.init = e, this.expect(b.semi), t.test = this.type === b.semi ? null : this.parseExpression(), this.expect(b.semi), t.update = this.type === b.parenR ? null : this.parseExpression(), this.expect(b.parenR), t.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(t, "ForStatement");
            }, nt.parseForIn = function (t, e) {
              var i = this.type === b._in;
              return this.next(), "VariableDeclaration" === e.type && null != e.declarations[0].init && (!i || this.options.ecmaVersion < 8 || this.strict || "var" !== e.kind || "Identifier" !== e.declarations[0].id.type) && this.raise(e.start, (i ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"), t.left = e, t.right = i ? this.parseExpression() : this.parseMaybeAssign(), this.expect(b.parenR), t.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(t, i ? "ForInStatement" : "ForOfStatement");
            }, nt.parseVar = function (t, e, i) {
              for (t.declarations = [], t.kind = i;;) {
                var s = this.startNode();
                if (this.parseVarId(s, i), this.eat(b.eq) ? s.init = this.parseMaybeAssign(e) : "const" !== i || this.type === b._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? "Identifier" === s.id.type || e && (this.type === b._in || this.isContextual("of")) ? s.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), t.declarations.push(this.finishNode(s, "VariableDeclarator")), !this.eat(b.comma)) break;
              }
              return t;
            }, nt.parseVarId = function (t, e) {
              t.id = this.parseBindingAtom(), this.checkLValPattern(t.id, "var" === e ? J : Y, !1);
            };
            var ct = 1,
              lt = 2,
              ut = 4;
            nt.parseFunction = function (t, e, i, s) {
              this.initFunction(t), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !s) && (this.type === b.star && e & lt && this.unexpected(), t.generator = this.eat(b.star)), this.options.ecmaVersion >= 8 && (t.async = !!s), e & ct && (t.id = e & ut && this.type !== b.name ? null : this.parseIdent(), !t.id || e & lt || this.checkLValSimple(t.id, this.strict || t.generator || t.async ? this.treatFunctionsAsVar ? J : Y : Z));
              var r = this.yieldPos,
                a = this.awaitPos,
                n = this.awaitIdentPos;
              return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(X(t.async, t.generator)), e & ct || (t.id = this.type === b.name ? this.parseIdent() : null), this.parseFunctionParams(t), this.parseFunctionBody(t, i, !1), this.yieldPos = r, this.awaitPos = a, this.awaitIdentPos = n, this.finishNode(t, e & ct ? "FunctionDeclaration" : "FunctionExpression");
            }, nt.parseFunctionParams = function (t) {
              this.expect(b.parenL), t.params = this.parseBindingList(b.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
            }, nt.parseClass = function (t, e) {
              this.next();
              var i = this.strict;
              this.strict = !0, this.parseClassId(t, e), this.parseClassSuper(t);
              var s = this.startNode(),
                r = !1;
              for (s.body = [], this.expect(b.braceL); this.type !== b.braceR;) {
                var a = this.parseClassElement(null !== t.superClass);
                a && (s.body.push(a), "MethodDefinition" === a.type && "constructor" === a.kind && (r && this.raise(a.start, "Duplicate constructor in the same class"), r = !0));
              }
              return this.strict = i, this.next(), t.body = this.finishNode(s, "ClassBody"), this.finishNode(t, e ? "ClassDeclaration" : "ClassExpression");
            }, nt.parseClassElement = function (t) {
              var e = this;
              if (this.eat(b.semi)) return null;
              var i = this.startNode(),
                s = function (t, s) {
                  void 0 === s && (s = !1);
                  var r = e.start,
                    a = e.startLoc;
                  return !(!e.eatContextual(t) || (e.type === b.parenL || s && e.canInsertSemicolon()) && (i.key && e.unexpected(), i.computed = !1, i.key = e.startNodeAt(r, a), i.key.name = t, e.finishNode(i.key, "Identifier"), 1));
                };
              i.kind = "method", i.static = s("static");
              var r = this.eat(b.star),
                a = !1;
              r || (this.options.ecmaVersion >= 8 && s("async", !0) ? (a = !0, r = this.options.ecmaVersion >= 9 && this.eat(b.star)) : s("get") ? i.kind = "get" : s("set") && (i.kind = "set")), i.key || this.parsePropertyName(i);
              var n = i.key,
                o = !1;
              return i.computed || i.static || !("Identifier" === n.type && "constructor" === n.name || "Literal" === n.type && "constructor" === n.value) ? i.static && "Identifier" === n.type && "prototype" === n.name && this.raise(n.start, "Classes may not have a static property named prototype") : ("method" !== i.kind && this.raise(n.start, "Constructor can't have get/set modifier"), r && this.raise(n.start, "Constructor can't be a generator"), a && this.raise(n.start, "Constructor can't be an async method"), i.kind = "constructor", o = t), this.parseClassMethod(i, r, a, o), "get" === i.kind && 0 !== i.value.params.length && this.raiseRecoverable(i.value.start, "getter should have no params"), "set" === i.kind && 1 !== i.value.params.length && this.raiseRecoverable(i.value.start, "setter should have exactly one param"), "set" === i.kind && "RestElement" === i.value.params[0].type && this.raiseRecoverable(i.value.params[0].start, "Setter cannot use rest params"), i;
            }, nt.parseClassMethod = function (t, e, i, s) {
              return t.value = this.parseMethod(e, i, s), this.finishNode(t, "MethodDefinition");
            }, nt.parseClassId = function (t, e) {
              this.type === b.name ? (t.id = this.parseIdent(), e && this.checkLValSimple(t.id, Y, !1)) : (!0 === e && this.unexpected(), t.id = null);
            }, nt.parseClassSuper = function (t) {
              t.superClass = this.eat(b._extends) ? this.parseExprSubscripts() : null;
            }, nt.parseExport = function (t, e) {
              if (this.next(), this.eat(b.star)) return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (t.exported = this.parseIdent(!0), this.checkExport(e, t.exported.name, this.lastTokStart)) : t.exported = null), this.expectContextual("from"), this.type !== b.string && this.unexpected(), t.source = this.parseExprAtom(), this.semicolon(), this.finishNode(t, "ExportAllDeclaration");
              if (this.eat(b._default)) {
                var i;
                if (this.checkExport(e, "default", this.lastTokStart), this.type === b._function || (i = this.isAsyncFunction())) {
                  var s = this.startNode();
                  this.next(), i && this.next(), t.declaration = this.parseFunction(s, ct | ut, !1, i);
                } else if (this.type === b._class) {
                  var r = this.startNode();
                  t.declaration = this.parseClass(r, "nullableID");
                } else t.declaration = this.parseMaybeAssign(), this.semicolon();
                return this.finishNode(t, "ExportDefaultDeclaration");
              }
              if (this.shouldParseExportStatement()) t.declaration = this.parseStatement(null), "VariableDeclaration" === t.declaration.type ? this.checkVariableExport(e, t.declaration.declarations) : this.checkExport(e, t.declaration.id.name, t.declaration.id.start), t.specifiers = [], t.source = null;else {
                if (t.declaration = null, t.specifiers = this.parseExportSpecifiers(e), this.eatContextual("from")) this.type !== b.string && this.unexpected(), t.source = this.parseExprAtom();else {
                  for (var a = 0, n = t.specifiers; a < n.length; a += 1) {
                    var o = n[a];
                    this.checkUnreserved(o.local), this.checkLocalExport(o.local);
                  }
                  t.source = null;
                }
                this.semicolon();
              }
              return this.finishNode(t, "ExportNamedDeclaration");
            }, nt.checkExport = function (t, e, i) {
              t && (P(t, e) && this.raiseRecoverable(i, "Duplicate export '" + e + "'"), t[e] = !0);
            }, nt.checkPatternExport = function (t, e) {
              var i = e.type;
              if ("Identifier" === i) this.checkExport(t, e.name, e.start);else if ("ObjectPattern" === i) for (var s = 0, r = e.properties; s < r.length; s += 1) {
                var a = r[s];
                this.checkPatternExport(t, a);
              } else if ("ArrayPattern" === i) for (var n = 0, o = e.elements; n < o.length; n += 1) {
                var h = o[n];
                h && this.checkPatternExport(t, h);
              } else "Property" === i ? this.checkPatternExport(t, e.value) : "AssignmentPattern" === i ? this.checkPatternExport(t, e.left) : "RestElement" === i ? this.checkPatternExport(t, e.argument) : "ParenthesizedExpression" === i && this.checkPatternExport(t, e.expression);
            }, nt.checkVariableExport = function (t, e) {
              if (t) for (var i = 0, s = e; i < s.length; i += 1) {
                var r = s[i];
                this.checkPatternExport(t, r.id);
              }
            }, nt.shouldParseExportStatement = function () {
              return "var" === this.type.keyword || "const" === this.type.keyword || "class" === this.type.keyword || "function" === this.type.keyword || this.isLet() || this.isAsyncFunction();
            }, nt.parseExportSpecifiers = function (t) {
              var e = [],
                i = !0;
              for (this.expect(b.braceL); !this.eat(b.braceR);) {
                if (i) i = !1;else if (this.expect(b.comma), this.afterTrailingComma(b.braceR)) break;
                var s = this.startNode();
                s.local = this.parseIdent(!0), s.exported = this.eatContextual("as") ? this.parseIdent(!0) : s.local, this.checkExport(t, s.exported.name, s.exported.start), e.push(this.finishNode(s, "ExportSpecifier"));
              }
              return e;
            }, nt.parseImport = function (t) {
              return this.next(), this.type === b.string ? (t.specifiers = pt, t.source = this.parseExprAtom()) : (t.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), t.source = this.type === b.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(t, "ImportDeclaration");
            }, nt.parseImportSpecifiers = function () {
              var t = [],
                e = !0;
              if (this.type === b.name) {
                var i = this.startNode();
                if (i.local = this.parseIdent(), this.checkLValSimple(i.local, Y), t.push(this.finishNode(i, "ImportDefaultSpecifier")), !this.eat(b.comma)) return t;
              }
              if (this.type === b.star) {
                var s = this.startNode();
                return this.next(), this.expectContextual("as"), s.local = this.parseIdent(), this.checkLValSimple(s.local, Y), t.push(this.finishNode(s, "ImportNamespaceSpecifier")), t;
              }
              for (this.expect(b.braceL); !this.eat(b.braceR);) {
                if (e) e = !1;else if (this.expect(b.comma), this.afterTrailingComma(b.braceR)) break;
                var r = this.startNode();
                r.imported = this.parseIdent(!0), this.eatContextual("as") ? r.local = this.parseIdent() : (this.checkUnreserved(r.imported), r.local = r.imported), this.checkLValSimple(r.local, Y), t.push(this.finishNode(r, "ImportSpecifier"));
              }
              return t;
            }, nt.adaptDirectivePrologue = function (t) {
              for (var e = 0; e < t.length && this.isDirectiveCandidate(t[e]); ++e) t[e].directive = t[e].expression.raw.slice(1, -1);
            }, nt.isDirectiveCandidate = function (t) {
              return "ExpressionStatement" === t.type && "Literal" === t.expression.type && "string" == typeof t.expression.value && ('"' === this.input[t.start] || "'" === this.input[t.start]);
            };
            var dt = et.prototype;
            dt.toAssignable = function (t, e, i) {
              if (this.options.ecmaVersion >= 6 && t) switch (t.type) {
                case "Identifier":
                  this.inAsync && "await" === t.name && this.raise(t.start, "Cannot use 'await' as identifier inside an async function");
                  break;
                case "ObjectPattern":
                case "ArrayPattern":
                case "AssignmentPattern":
                case "RestElement":
                  break;
                case "ObjectExpression":
                  t.type = "ObjectPattern", i && this.checkPatternErrors(i, !0);
                  for (var s = 0, r = t.properties; s < r.length; s += 1) {
                    var a = r[s];
                    this.toAssignable(a, e), "RestElement" !== a.type || "ArrayPattern" !== a.argument.type && "ObjectPattern" !== a.argument.type || this.raise(a.argument.start, "Unexpected token");
                  }
                  break;
                case "Property":
                  "init" !== t.kind && this.raise(t.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(t.value, e);
                  break;
                case "ArrayExpression":
                  t.type = "ArrayPattern", i && this.checkPatternErrors(i, !0), this.toAssignableList(t.elements, e);
                  break;
                case "SpreadElement":
                  t.type = "RestElement", this.toAssignable(t.argument, e), "AssignmentPattern" === t.argument.type && this.raise(t.argument.start, "Rest elements cannot have a default value");
                  break;
                case "AssignmentExpression":
                  "=" !== t.operator && this.raise(t.left.end, "Only '=' operator can be used for specifying default value."), t.type = "AssignmentPattern", delete t.operator, this.toAssignable(t.left, e);
                  break;
                case "ParenthesizedExpression":
                  this.toAssignable(t.expression, e, i);
                  break;
                case "ChainExpression":
                  this.raiseRecoverable(t.start, "Optional chaining cannot appear in left-hand side");
                  break;
                case "MemberExpression":
                  if (!e) break;
                default:
                  this.raise(t.start, "Assigning to rvalue");
              } else i && this.checkPatternErrors(i, !0);
              return t;
            }, dt.toAssignableList = function (t, e) {
              for (var i = t.length, s = 0; s < i; s++) {
                var r = t[s];
                r && this.toAssignable(r, e);
              }
              if (i) {
                var a = t[i - 1];
                6 === this.options.ecmaVersion && e && a && "RestElement" === a.type && "Identifier" !== a.argument.type && this.unexpected(a.argument.start);
              }
              return t;
            }, dt.parseSpread = function (t) {
              var e = this.startNode();
              return this.next(), e.argument = this.parseMaybeAssign(!1, t), this.finishNode(e, "SpreadElement");
            }, dt.parseRestBinding = function () {
              var t = this.startNode();
              return this.next(), 6 === this.options.ecmaVersion && this.type !== b.name && this.unexpected(), t.argument = this.parseBindingAtom(), this.finishNode(t, "RestElement");
            }, dt.parseBindingAtom = function () {
              if (this.options.ecmaVersion >= 6) switch (this.type) {
                case b.bracketL:
                  var t = this.startNode();
                  return this.next(), t.elements = this.parseBindingList(b.bracketR, !0, !0), this.finishNode(t, "ArrayPattern");
                case b.braceL:
                  return this.parseObj(!0);
              }
              return this.parseIdent();
            }, dt.parseBindingList = function (t, e, i) {
              for (var s = [], r = !0; !this.eat(t);) if (r ? r = !1 : this.expect(b.comma), e && this.type === b.comma) s.push(null);else {
                if (i && this.afterTrailingComma(t)) break;
                if (this.type === b.ellipsis) {
                  var a = this.parseRestBinding();
                  this.parseBindingListItem(a), s.push(a), this.type === b.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(t);
                  break;
                }
                var n = this.parseMaybeDefault(this.start, this.startLoc);
                this.parseBindingListItem(n), s.push(n);
              }
              return s;
            }, dt.parseBindingListItem = function (t) {
              return t;
            }, dt.parseMaybeDefault = function (t, e, i) {
              if (i = i || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(b.eq)) return i;
              var s = this.startNodeAt(t, e);
              return s.left = i, s.right = this.parseMaybeAssign(), this.finishNode(s, "AssignmentPattern");
            }, dt.checkLValSimple = function (t, e, i) {
              void 0 === e && (e = Q);
              var s = e !== Q;
              switch (t.type) {
                case "Identifier":
                  this.strict && this.reservedWordsStrictBind.test(t.name) && this.raiseRecoverable(t.start, (s ? "Binding " : "Assigning to ") + t.name + " in strict mode"), s && (e === Y && "let" === t.name && this.raiseRecoverable(t.start, "let is disallowed as a lexically bound name"), i && (P(i, t.name) && this.raiseRecoverable(t.start, "Argument name clash"), i[t.name] = !0), e !== tt && this.declareName(t.name, e, t.start));
                  break;
                case "ChainExpression":
                  this.raiseRecoverable(t.start, "Optional chaining cannot appear in left-hand side");
                  break;
                case "MemberExpression":
                  s && this.raiseRecoverable(t.start, "Binding member expression");
                  break;
                case "ParenthesizedExpression":
                  return s && this.raiseRecoverable(t.start, "Binding parenthesized expression"), this.checkLValSimple(t.expression, e, i);
                default:
                  this.raise(t.start, (s ? "Binding" : "Assigning to") + " rvalue");
              }
            }, dt.checkLValPattern = function (t, e, i) {
              switch (void 0 === e && (e = Q), t.type) {
                case "ObjectPattern":
                  for (var s = 0, r = t.properties; s < r.length; s += 1) {
                    var a = r[s];
                    this.checkLValInnerPattern(a, e, i);
                  }
                  break;
                case "ArrayPattern":
                  for (var n = 0, o = t.elements; n < o.length; n += 1) {
                    var h = o[n];
                    h && this.checkLValInnerPattern(h, e, i);
                  }
                  break;
                default:
                  this.checkLValSimple(t, e, i);
              }
            }, dt.checkLValInnerPattern = function (t, e, i) {
              switch (void 0 === e && (e = Q), t.type) {
                case "Property":
                  this.checkLValInnerPattern(t.value, e, i);
                  break;
                case "AssignmentPattern":
                  this.checkLValPattern(t.left, e, i);
                  break;
                case "RestElement":
                  this.checkLValPattern(t.argument, e, i);
                  break;
                default:
                  this.checkLValPattern(t, e, i);
              }
            };
            var ft = et.prototype;
            ft.checkPropClash = function (t, e, i) {
              if (!(this.options.ecmaVersion >= 9 && "SpreadElement" === t.type || this.options.ecmaVersion >= 6 && (t.computed || t.method || t.shorthand))) {
                var s,
                  r = t.key;
                switch (r.type) {
                  case "Identifier":
                    s = r.name;
                    break;
                  case "Literal":
                    s = String(r.value);
                    break;
                  default:
                    return;
                }
                var a = t.kind;
                if (this.options.ecmaVersion >= 6) "__proto__" === s && "init" === a && (e.proto && (i ? i.doubleProto < 0 && (i.doubleProto = r.start) : this.raiseRecoverable(r.start, "Redefinition of __proto__ property")), e.proto = !0);else {
                  var n = e[s = "$" + s];
                  n ? ("init" === a ? this.strict && n.init || n.get || n.set : n.init || n[a]) && this.raiseRecoverable(r.start, "Redefinition of property") : n = e[s] = {
                    init: !1,
                    get: !1,
                    set: !1
                  }, n[a] = !0;
                }
              }
            }, ft.parseExpression = function (t, e) {
              var i = this.start,
                s = this.startLoc,
                r = this.parseMaybeAssign(t, e);
              if (this.type === b.comma) {
                var a = this.startNodeAt(i, s);
                for (a.expressions = [r]; this.eat(b.comma);) a.expressions.push(this.parseMaybeAssign(t, e));
                return this.finishNode(a, "SequenceExpression");
              }
              return r;
            }, ft.parseMaybeAssign = function (t, e, i) {
              if (this.isContextual("yield")) {
                if (this.inGenerator) return this.parseYield(t);
                this.exprAllowed = !1;
              }
              var s = !1,
                r = -1,
                a = -1;
              e ? (r = e.parenthesizedAssign, a = e.trailingComma, e.parenthesizedAssign = e.trailingComma = -1) : (e = new at(), s = !0);
              var n = this.start,
                o = this.startLoc;
              this.type !== b.parenL && this.type !== b.name || (this.potentialArrowAt = this.start);
              var h = this.parseMaybeConditional(t, e);
              if (i && (h = i.call(this, h, n, o)), this.type.isAssign) {
                var p = this.startNodeAt(n, o);
                return p.operator = this.value, this.type === b.eq && (h = this.toAssignable(h, !1, e)), s || (e.parenthesizedAssign = e.trailingComma = e.doubleProto = -1), e.shorthandAssign >= h.start && (e.shorthandAssign = -1), this.type === b.eq ? this.checkLValPattern(h) : this.checkLValSimple(h), p.left = h, this.next(), p.right = this.parseMaybeAssign(t), this.finishNode(p, "AssignmentExpression");
              }
              return s && this.checkExpressionErrors(e, !0), r > -1 && (e.parenthesizedAssign = r), a > -1 && (e.trailingComma = a), h;
            }, ft.parseMaybeConditional = function (t, e) {
              var i = this.start,
                s = this.startLoc,
                r = this.parseExprOps(t, e);
              if (this.checkExpressionErrors(e)) return r;
              if (this.eat(b.question)) {
                var a = this.startNodeAt(i, s);
                return a.test = r, a.consequent = this.parseMaybeAssign(), this.expect(b.colon), a.alternate = this.parseMaybeAssign(t), this.finishNode(a, "ConditionalExpression");
              }
              return r;
            }, ft.parseExprOps = function (t, e) {
              var i = this.start,
                s = this.startLoc,
                r = this.parseMaybeUnary(e, !1);
              return this.checkExpressionErrors(e) || r.start === i && "ArrowFunctionExpression" === r.type ? r : this.parseExprOp(r, i, s, -1, t);
            }, ft.parseExprOp = function (t, e, i, s, r) {
              var a = this.type.binop;
              if (null != a && (!r || this.type !== b._in) && a > s) {
                var n = this.type === b.logicalOR || this.type === b.logicalAND,
                  o = this.type === b.coalesce;
                o && (a = b.logicalAND.binop);
                var h = this.value;
                this.next();
                var p = this.start,
                  c = this.startLoc,
                  l = this.parseExprOp(this.parseMaybeUnary(null, !1), p, c, a, r),
                  u = this.buildBinary(e, i, t, l, h, n || o);
                return (n && this.type === b.coalesce || o && (this.type === b.logicalOR || this.type === b.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(u, e, i, s, r);
              }
              return t;
            }, ft.buildBinary = function (t, e, i, s, r, a) {
              var n = this.startNodeAt(t, e);
              return n.left = i, n.operator = r, n.right = s, this.finishNode(n, a ? "LogicalExpression" : "BinaryExpression");
            }, ft.parseMaybeUnary = function (t, e) {
              var i,
                s = this.start,
                r = this.startLoc;
              if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction)) i = this.parseAwait(), e = !0;else if (this.type.prefix) {
                var a = this.startNode(),
                  n = this.type === b.incDec;
                a.operator = this.value, a.prefix = !0, this.next(), a.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(t, !0), n ? this.checkLValSimple(a.argument) : this.strict && "delete" === a.operator && "Identifier" === a.argument.type ? this.raiseRecoverable(a.start, "Deleting local variable in strict mode") : e = !0, i = this.finishNode(a, n ? "UpdateExpression" : "UnaryExpression");
              } else {
                if (i = this.parseExprSubscripts(t), this.checkExpressionErrors(t)) return i;
                for (; this.type.postfix && !this.canInsertSemicolon();) {
                  var o = this.startNodeAt(s, r);
                  o.operator = this.value, o.prefix = !1, o.argument = i, this.checkLValSimple(i), this.next(), i = this.finishNode(o, "UpdateExpression");
                }
              }
              return !e && this.eat(b.starstar) ? this.buildBinary(s, r, i, this.parseMaybeUnary(null, !1), "**", !1) : i;
            }, ft.parseExprSubscripts = function (t) {
              var e = this.start,
                i = this.startLoc,
                s = this.parseExprAtom(t);
              if ("ArrowFunctionExpression" === s.type && ")" !== this.input.slice(this.lastTokStart, this.lastTokEnd)) return s;
              var r = this.parseSubscripts(s, e, i);
              return t && "MemberExpression" === r.type && (t.parenthesizedAssign >= r.start && (t.parenthesizedAssign = -1), t.parenthesizedBind >= r.start && (t.parenthesizedBind = -1)), r;
            }, ft.parseSubscripts = function (t, e, i, s) {
              for (var r = this.options.ecmaVersion >= 8 && "Identifier" === t.type && "async" === t.name && this.lastTokEnd === t.end && !this.canInsertSemicolon() && t.end - t.start == 5 && this.potentialArrowAt === t.start, a = !1;;) {
                var n = this.parseSubscript(t, e, i, s, r, a);
                if (n.optional && (a = !0), n === t || "ArrowFunctionExpression" === n.type) {
                  if (a) {
                    var o = this.startNodeAt(e, i);
                    o.expression = n, n = this.finishNode(o, "ChainExpression");
                  }
                  return n;
                }
                t = n;
              }
            }, ft.parseSubscript = function (t, e, i, s, r, a) {
              var n = this.options.ecmaVersion >= 11,
                o = n && this.eat(b.questionDot);
              s && o && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
              var h = this.eat(b.bracketL);
              if (h || o && this.type !== b.parenL && this.type !== b.backQuote || this.eat(b.dot)) {
                var p = this.startNodeAt(e, i);
                p.object = t, p.property = h ? this.parseExpression() : this.parseIdent("never" !== this.options.allowReserved), p.computed = !!h, h && this.expect(b.bracketR), n && (p.optional = o), t = this.finishNode(p, "MemberExpression");
              } else if (!s && this.eat(b.parenL)) {
                var c = new at(),
                  l = this.yieldPos,
                  u = this.awaitPos,
                  d = this.awaitIdentPos;
                this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
                var f = this.parseExprList(b.parenR, this.options.ecmaVersion >= 8, !1, c);
                if (r && !o && !this.canInsertSemicolon() && this.eat(b.arrow)) return this.checkPatternErrors(c, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = l, this.awaitPos = u, this.awaitIdentPos = d, this.parseArrowExpression(this.startNodeAt(e, i), f, !0);
                this.checkExpressionErrors(c, !0), this.yieldPos = l || this.yieldPos, this.awaitPos = u || this.awaitPos, this.awaitIdentPos = d || this.awaitIdentPos;
                var m = this.startNodeAt(e, i);
                m.callee = t, m.arguments = f, n && (m.optional = o), t = this.finishNode(m, "CallExpression");
              } else if (this.type === b.backQuote) {
                (o || a) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
                var g = this.startNodeAt(e, i);
                g.tag = t, g.quasi = this.parseTemplate({
                  isTagged: !0
                }), t = this.finishNode(g, "TaggedTemplateExpression");
              }
              return t;
            }, ft.parseExprAtom = function (t) {
              this.type === b.slash && this.readRegexp();
              var e,
                i = this.potentialArrowAt === this.start;
              switch (this.type) {
                case b._super:
                  return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), e = this.startNode(), this.next(), this.type !== b.parenL || this.allowDirectSuper || this.raise(e.start, "super() call outside constructor of a subclass"), this.type !== b.dot && this.type !== b.bracketL && this.type !== b.parenL && this.unexpected(), this.finishNode(e, "Super");
                case b._this:
                  return e = this.startNode(), this.next(), this.finishNode(e, "ThisExpression");
                case b.name:
                  var s = this.start,
                    r = this.startLoc,
                    a = this.containsEsc,
                    n = this.parseIdent(!1);
                  if (this.options.ecmaVersion >= 8 && !a && "async" === n.name && !this.canInsertSemicolon() && this.eat(b._function)) return this.parseFunction(this.startNodeAt(s, r), 0, !1, !0);
                  if (i && !this.canInsertSemicolon()) {
                    if (this.eat(b.arrow)) return this.parseArrowExpression(this.startNodeAt(s, r), [n], !1);
                    if (this.options.ecmaVersion >= 8 && "async" === n.name && this.type === b.name && !a) return n = this.parseIdent(!1), !this.canInsertSemicolon() && this.eat(b.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(s, r), [n], !0);
                  }
                  return n;
                case b.regexp:
                  var o = this.value;
                  return (e = this.parseLiteral(o.value)).regex = {
                    pattern: o.pattern,
                    flags: o.flags
                  }, e;
                case b.num:
                case b.string:
                  return this.parseLiteral(this.value);
                case b._null:
                case b._true:
                case b._false:
                  return (e = this.startNode()).value = this.type === b._null ? null : this.type === b._true, e.raw = this.type.keyword, this.next(), this.finishNode(e, "Literal");
                case b.parenL:
                  var h = this.start,
                    p = this.parseParenAndDistinguishExpression(i);
                  return t && (t.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(p) && (t.parenthesizedAssign = h), t.parenthesizedBind < 0 && (t.parenthesizedBind = h)), p;
                case b.bracketL:
                  return e = this.startNode(), this.next(), e.elements = this.parseExprList(b.bracketR, !0, !0, t), this.finishNode(e, "ArrayExpression");
                case b.braceL:
                  return this.parseObj(!1, t);
                case b._function:
                  return e = this.startNode(), this.next(), this.parseFunction(e, 0);
                case b._class:
                  return this.parseClass(this.startNode(), !1);
                case b._new:
                  return this.parseNew();
                case b.backQuote:
                  return this.parseTemplate();
                case b._import:
                  return this.options.ecmaVersion >= 11 ? this.parseExprImport() : this.unexpected();
                default:
                  this.unexpected();
              }
            }, ft.parseExprImport = function () {
              var t = this.startNode();
              this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import");
              var e = this.parseIdent(!0);
              switch (this.type) {
                case b.parenL:
                  return this.parseDynamicImport(t);
                case b.dot:
                  return t.meta = e, this.parseImportMeta(t);
                default:
                  this.unexpected();
              }
            }, ft.parseDynamicImport = function (t) {
              if (this.next(), t.source = this.parseMaybeAssign(), !this.eat(b.parenR)) {
                var e = this.start;
                this.eat(b.comma) && this.eat(b.parenR) ? this.raiseRecoverable(e, "Trailing comma is not allowed in import()") : this.unexpected(e);
              }
              return this.finishNode(t, "ImportExpression");
            }, ft.parseImportMeta = function (t) {
              this.next();
              var e = this.containsEsc;
              return t.property = this.parseIdent(!0), "meta" !== t.property.name && this.raiseRecoverable(t.property.start, "The only valid meta property for import is 'import.meta'"), e && this.raiseRecoverable(t.start, "'import.meta' must not contain escaped characters"), "module" !== this.options.sourceType && this.raiseRecoverable(t.start, "Cannot use 'import.meta' outside a module"), this.finishNode(t, "MetaProperty");
            }, ft.parseLiteral = function (t) {
              var e = this.startNode();
              return e.value = t, e.raw = this.input.slice(this.start, this.end), 110 === e.raw.charCodeAt(e.raw.length - 1) && (e.bigint = e.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(e, "Literal");
            }, ft.parseParenExpression = function () {
              this.expect(b.parenL);
              var t = this.parseExpression();
              return this.expect(b.parenR), t;
            }, ft.parseParenAndDistinguishExpression = function (t) {
              var e,
                i = this.start,
                s = this.startLoc,
                r = this.options.ecmaVersion >= 8;
              if (this.options.ecmaVersion >= 6) {
                this.next();
                var a,
                  n = this.start,
                  o = this.startLoc,
                  h = [],
                  p = !0,
                  c = !1,
                  l = new at(),
                  u = this.yieldPos,
                  d = this.awaitPos;
                for (this.yieldPos = 0, this.awaitPos = 0; this.type !== b.parenR;) {
                  if (p ? p = !1 : this.expect(b.comma), r && this.afterTrailingComma(b.parenR, !0)) {
                    c = !0;
                    break;
                  }
                  if (this.type === b.ellipsis) {
                    a = this.start, h.push(this.parseParenItem(this.parseRestBinding())), this.type === b.comma && this.raise(this.start, "Comma is not permitted after the rest element");
                    break;
                  }
                  h.push(this.parseMaybeAssign(!1, l, this.parseParenItem));
                }
                var f = this.start,
                  m = this.startLoc;
                if (this.expect(b.parenR), t && !this.canInsertSemicolon() && this.eat(b.arrow)) return this.checkPatternErrors(l, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = u, this.awaitPos = d, this.parseParenArrowList(i, s, h);
                h.length && !c || this.unexpected(this.lastTokStart), a && this.unexpected(a), this.checkExpressionErrors(l, !0), this.yieldPos = u || this.yieldPos, this.awaitPos = d || this.awaitPos, h.length > 1 ? ((e = this.startNodeAt(n, o)).expressions = h, this.finishNodeAt(e, "SequenceExpression", f, m)) : e = h[0];
              } else e = this.parseParenExpression();
              if (this.options.preserveParens) {
                var g = this.startNodeAt(i, s);
                return g.expression = e, this.finishNode(g, "ParenthesizedExpression");
              }
              return e;
            }, ft.parseParenItem = function (t) {
              return t;
            }, ft.parseParenArrowList = function (t, e, i) {
              return this.parseArrowExpression(this.startNodeAt(t, e), i);
            };
            var mt = [];
            ft.parseNew = function () {
              this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
              var t = this.startNode(),
                e = this.parseIdent(!0);
              if (this.options.ecmaVersion >= 6 && this.eat(b.dot)) {
                t.meta = e;
                var i = this.containsEsc;
                return t.property = this.parseIdent(!0), "target" !== t.property.name && this.raiseRecoverable(t.property.start, "The only valid meta property for new is 'new.target'"), i && this.raiseRecoverable(t.start, "'new.target' must not contain escaped characters"), this.inNonArrowFunction || this.raiseRecoverable(t.start, "'new.target' can only be used in functions"), this.finishNode(t, "MetaProperty");
              }
              var s = this.start,
                r = this.startLoc,
                a = this.type === b._import;
              return t.callee = this.parseSubscripts(this.parseExprAtom(), s, r, !0), a && "ImportExpression" === t.callee.type && this.raise(s, "Cannot use new with import()"), this.eat(b.parenL) ? t.arguments = this.parseExprList(b.parenR, this.options.ecmaVersion >= 8, !1) : t.arguments = mt, this.finishNode(t, "NewExpression");
            }, ft.parseTemplateElement = function (t) {
              var e = t.isTagged,
                i = this.startNode();
              return this.type === b.invalidTemplate ? (e || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), i.value = {
                raw: this.value,
                cooked: null
              }) : i.value = {
                raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
                cooked: this.value
              }, this.next(), i.tail = this.type === b.backQuote, this.finishNode(i, "TemplateElement");
            }, ft.parseTemplate = function (t) {
              void 0 === t && (t = {});
              var e = t.isTagged;
              void 0 === e && (e = !1);
              var i = this.startNode();
              this.next(), i.expressions = [];
              var s = this.parseTemplateElement({
                isTagged: e
              });
              for (i.quasis = [s]; !s.tail;) this.type === b.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(b.dollarBraceL), i.expressions.push(this.parseExpression()), this.expect(b.braceR), i.quasis.push(s = this.parseTemplateElement({
                isTagged: e
              }));
              return this.next(), this.finishNode(i, "TemplateLiteral");
            }, ft.isAsyncProp = function (t) {
              return !t.computed && "Identifier" === t.key.type && "async" === t.key.name && (this.type === b.name || this.type === b.num || this.type === b.string || this.type === b.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === b.star) && !_.test(this.input.slice(this.lastTokEnd, this.start));
            }, ft.parseObj = function (t, e) {
              var i = this.startNode(),
                s = !0,
                r = {};
              for (i.properties = [], this.next(); !this.eat(b.braceR);) {
                if (s) s = !1;else if (this.expect(b.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(b.braceR)) break;
                var a = this.parseProperty(t, e);
                t || this.checkPropClash(a, r, e), i.properties.push(a);
              }
              return this.finishNode(i, t ? "ObjectPattern" : "ObjectExpression");
            }, ft.parseProperty = function (t, e) {
              var i,
                s,
                r,
                a,
                n = this.startNode();
              if (this.options.ecmaVersion >= 9 && this.eat(b.ellipsis)) return t ? (n.argument = this.parseIdent(!1), this.type === b.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(n, "RestElement")) : (this.type === b.parenL && e && (e.parenthesizedAssign < 0 && (e.parenthesizedAssign = this.start), e.parenthesizedBind < 0 && (e.parenthesizedBind = this.start)), n.argument = this.parseMaybeAssign(!1, e), this.type === b.comma && e && e.trailingComma < 0 && (e.trailingComma = this.start), this.finishNode(n, "SpreadElement"));
              this.options.ecmaVersion >= 6 && (n.method = !1, n.shorthand = !1, (t || e) && (r = this.start, a = this.startLoc), t || (i = this.eat(b.star)));
              var o = this.containsEsc;
              return this.parsePropertyName(n), !t && !o && this.options.ecmaVersion >= 8 && !i && this.isAsyncProp(n) ? (s = !0, i = this.options.ecmaVersion >= 9 && this.eat(b.star), this.parsePropertyName(n, e)) : s = !1, this.parsePropertyValue(n, t, i, s, r, a, e, o), this.finishNode(n, "Property");
            }, ft.parsePropertyValue = function (t, e, i, s, r, a, n, o) {
              if ((i || s) && this.type === b.colon && this.unexpected(), this.eat(b.colon)) t.value = e ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, n), t.kind = "init";else if (this.options.ecmaVersion >= 6 && this.type === b.parenL) e && this.unexpected(), t.kind = "init", t.method = !0, t.value = this.parseMethod(i, s);else if (e || o || !(this.options.ecmaVersion >= 5) || t.computed || "Identifier" !== t.key.type || "get" !== t.key.name && "set" !== t.key.name || this.type === b.comma || this.type === b.braceR || this.type === b.eq) this.options.ecmaVersion >= 6 && !t.computed && "Identifier" === t.key.type ? ((i || s) && this.unexpected(), this.checkUnreserved(t.key), "await" !== t.key.name || this.awaitIdentPos || (this.awaitIdentPos = r), t.kind = "init", e ? t.value = this.parseMaybeDefault(r, a, this.copyNode(t.key)) : this.type === b.eq && n ? (n.shorthandAssign < 0 && (n.shorthandAssign = this.start), t.value = this.parseMaybeDefault(r, a, this.copyNode(t.key))) : t.value = this.copyNode(t.key), t.shorthand = !0) : this.unexpected();else {
                (i || s) && this.unexpected(), t.kind = t.key.name, this.parsePropertyName(t), t.value = this.parseMethod(!1);
                var h = "get" === t.kind ? 0 : 1;
                if (t.value.params.length !== h) {
                  var p = t.value.start;
                  "get" === t.kind ? this.raiseRecoverable(p, "getter should have no params") : this.raiseRecoverable(p, "setter should have exactly one param");
                } else "set" === t.kind && "RestElement" === t.value.params[0].type && this.raiseRecoverable(t.value.params[0].start, "Setter cannot use rest params");
              }
            }, ft.parsePropertyName = function (t) {
              if (this.options.ecmaVersion >= 6) {
                if (this.eat(b.bracketL)) return t.computed = !0, t.key = this.parseMaybeAssign(), this.expect(b.bracketR), t.key;
                t.computed = !1;
              }
              return t.key = this.type === b.num || this.type === b.string ? this.parseExprAtom() : this.parseIdent("never" !== this.options.allowReserved);
            }, ft.initFunction = function (t) {
              t.id = null, this.options.ecmaVersion >= 6 && (t.generator = t.expression = !1), this.options.ecmaVersion >= 8 && (t.async = !1);
            }, ft.parseMethod = function (t, e, i) {
              var s = this.startNode(),
                r = this.yieldPos,
                a = this.awaitPos,
                n = this.awaitIdentPos;
              return this.initFunction(s), this.options.ecmaVersion >= 6 && (s.generator = t), this.options.ecmaVersion >= 8 && (s.async = !!e), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(X(e, s.generator) | z | (i ? K : 0)), this.expect(b.parenL), s.params = this.parseBindingList(b.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(s, !1, !0), this.yieldPos = r, this.awaitPos = a, this.awaitIdentPos = n, this.finishNode(s, "FunctionExpression");
            }, ft.parseArrowExpression = function (t, e, i) {
              var s = this.yieldPos,
                r = this.awaitPos,
                a = this.awaitIdentPos;
              return this.enterScope(X(i, !1) | H), this.initFunction(t), this.options.ecmaVersion >= 8 && (t.async = !!i), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, t.params = this.toAssignableList(e, !0), this.parseFunctionBody(t, !0, !1), this.yieldPos = s, this.awaitPos = r, this.awaitIdentPos = a, this.finishNode(t, "ArrowFunctionExpression");
            }, ft.parseFunctionBody = function (t, e, i) {
              var s = e && this.type !== b.braceL,
                r = this.strict,
                a = !1;
              if (s) t.body = this.parseMaybeAssign(), t.expression = !0, this.checkParams(t, !1);else {
                var n = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(t.params);
                r && !n || (a = this.strictDirective(this.end)) && n && this.raiseRecoverable(t.start, "Illegal 'use strict' directive in function with non-simple parameter list");
                var o = this.labels;
                this.labels = [], a && (this.strict = !0), this.checkParams(t, !r && !a && !e && !i && this.isSimpleParamList(t.params)), this.strict && t.id && this.checkLValSimple(t.id, tt), t.body = this.parseBlock(!1, void 0, a && !r), t.expression = !1, this.adaptDirectivePrologue(t.body.body), this.labels = o;
              }
              this.exitScope();
            }, ft.isSimpleParamList = function (t) {
              for (var e = 0, i = t; e < i.length; e += 1) if ("Identifier" !== i[e].type) return !1;
              return !0;
            }, ft.checkParams = function (t, e) {
              for (var i = Object.create(null), s = 0, r = t.params; s < r.length; s += 1) {
                var a = r[s];
                this.checkLValInnerPattern(a, J, e ? null : i);
              }
            }, ft.parseExprList = function (t, e, i, s) {
              for (var r = [], a = !0; !this.eat(t);) {
                if (a) a = !1;else if (this.expect(b.comma), e && this.afterTrailingComma(t)) break;
                var n = void 0;
                i && this.type === b.comma ? n = null : this.type === b.ellipsis ? (n = this.parseSpread(s), s && this.type === b.comma && s.trailingComma < 0 && (s.trailingComma = this.start)) : n = this.parseMaybeAssign(!1, s), r.push(n);
              }
              return r;
            }, ft.checkUnreserved = function (t) {
              var e = t.start,
                i = t.end,
                s = t.name;
              this.inGenerator && "yield" === s && this.raiseRecoverable(e, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && "await" === s && this.raiseRecoverable(e, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(s) && this.raise(e, "Unexpected keyword '" + s + "'"), this.options.ecmaVersion < 6 && -1 !== this.input.slice(e, i).indexOf("\\") || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(s) && (this.inAsync || "await" !== s || this.raiseRecoverable(e, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(e, "The keyword '" + s + "' is reserved"));
            }, ft.parseIdent = function (t, e) {
              var i = this.startNode();
              return this.type === b.name ? i.name = this.value : this.type.keyword ? (i.name = this.type.keyword, "class" !== i.name && "function" !== i.name || this.lastTokEnd === this.lastTokStart + 1 && 46 === this.input.charCodeAt(this.lastTokStart) || this.context.pop()) : this.unexpected(), this.next(!!t), this.finishNode(i, "Identifier"), t || (this.checkUnreserved(i), "await" !== i.name || this.awaitIdentPos || (this.awaitIdentPos = i.start)), i;
            }, ft.parseYield = function (t) {
              this.yieldPos || (this.yieldPos = this.start);
              var e = this.startNode();
              return this.next(), this.type === b.semi || this.canInsertSemicolon() || this.type !== b.star && !this.type.startsExpr ? (e.delegate = !1, e.argument = null) : (e.delegate = this.eat(b.star), e.argument = this.parseMaybeAssign(t)), this.finishNode(e, "YieldExpression");
            }, ft.parseAwait = function () {
              this.awaitPos || (this.awaitPos = this.start);
              var t = this.startNode();
              return this.next(), t.argument = this.parseMaybeUnary(null, !0), this.finishNode(t, "AwaitExpression");
            };
            var gt = et.prototype;
            gt.raise = function (t, e) {
              var i = O(this.input, t);
              e += " (" + i.line + ":" + i.column + ")";
              var s = new SyntaxError(e);
              throw s.pos = t, s.loc = i, s.raisedAt = this.pos, s;
            }, gt.raiseRecoverable = gt.raise, gt.curPosition = function () {
              if (this.options.locations) return new L(this.curLine, this.pos - this.lineStart);
            };
            var xt = et.prototype,
              yt = function (t) {
                this.flags = t, this.var = [], this.lexical = [], this.functions = [];
              };
            xt.enterScope = function (t) {
              this.scopeStack.push(new yt(t));
            }, xt.exitScope = function () {
              this.scopeStack.pop();
            }, xt.treatFunctionsAsVarInScope = function (t) {
              return t.flags & U || !this.inModule && t.flags & j;
            }, xt.declareName = function (t, e, i) {
              var s = !1;
              if (e === Y) {
                var r = this.currentScope();
                s = r.lexical.indexOf(t) > -1 || r.functions.indexOf(t) > -1 || r.var.indexOf(t) > -1, r.lexical.push(t), this.inModule && r.flags & j && delete this.undefinedExports[t];
              } else if (e === $) this.currentScope().lexical.push(t);else if (e === Z) {
                var a = this.currentScope();
                s = this.treatFunctionsAsVar ? a.lexical.indexOf(t) > -1 : a.lexical.indexOf(t) > -1 || a.var.indexOf(t) > -1, a.functions.push(t);
              } else for (var n = this.scopeStack.length - 1; n >= 0; --n) {
                var o = this.scopeStack[n];
                if (o.lexical.indexOf(t) > -1 && !(o.flags & W && o.lexical[0] === t) || !this.treatFunctionsAsVarInScope(o) && o.functions.indexOf(t) > -1) {
                  s = !0;
                  break;
                }
                if (o.var.push(t), this.inModule && o.flags & j && delete this.undefinedExports[t], o.flags & F) break;
              }
              s && this.raiseRecoverable(i, "Identifier '" + t + "' has already been declared");
            }, xt.checkLocalExport = function (t) {
              -1 === this.scopeStack[0].lexical.indexOf(t.name) && -1 === this.scopeStack[0].var.indexOf(t.name) && (this.undefinedExports[t.name] = t);
            }, xt.currentScope = function () {
              return this.scopeStack[this.scopeStack.length - 1];
            }, xt.currentVarScope = function () {
              for (var t = this.scopeStack.length - 1;; t--) {
                var e = this.scopeStack[t];
                if (e.flags & F) return e;
              }
            }, xt.currentThisScope = function () {
              for (var t = this.scopeStack.length - 1;; t--) {
                var e = this.scopeStack[t];
                if (e.flags & F && !(e.flags & H)) return e;
              }
            };
            var vt = function (t, e, i) {
                this.type = "", this.start = e, this.end = 0, t.options.locations && (this.loc = new V(t, i)), t.options.directSourceFile && (this.sourceFile = t.options.directSourceFile), t.options.ranges && (this.range = [e, 0]);
              },
              bt = et.prototype;
            function _t(t, e, i, s) {
              return t.type = e, t.end = i, this.options.locations && (t.loc.end = s), this.options.ranges && (t.range[1] = i), t;
            }
            bt.startNode = function () {
              return new vt(this, this.start, this.startLoc);
            }, bt.startNodeAt = function (t, e) {
              return new vt(this, t, e);
            }, bt.finishNode = function (t, e) {
              return _t.call(this, t, e, this.lastTokEnd, this.lastTokEndLoc);
            }, bt.finishNodeAt = function (t, e, i, s) {
              return _t.call(this, t, e, i, s);
            }, bt.copyNode = function (t) {
              var e = new vt(this, t.start, this.startLoc);
              for (var i in t) e[i] = t[i];
              return e;
            };
            var kt = function (t, e, i, s, r) {
                this.token = t, this.isExpr = !!e, this.preserveSpace = !!i, this.override = s, this.generator = !!r;
              },
              St = {
                b_stat: new kt("{", !1),
                b_expr: new kt("{", !0),
                b_tmpl: new kt("${", !1),
                p_stat: new kt("(", !1),
                p_expr: new kt("(", !0),
                q_tmpl: new kt("`", !0, !0, function (t) {
                  return t.tryReadTemplateToken();
                }),
                f_stat: new kt("function", !1),
                f_expr: new kt("function", !0),
                f_expr_gen: new kt("function", !0, !1, null, !0),
                f_gen: new kt("function", !1, !1, null, !0)
              },
              wt = et.prototype;
            wt.initialContext = function () {
              return [St.b_stat];
            }, wt.braceIsBlock = function (t) {
              var e = this.curContext();
              return e === St.f_expr || e === St.f_stat || (t !== b.colon || e !== St.b_stat && e !== St.b_expr ? t === b._return || t === b.name && this.exprAllowed ? _.test(this.input.slice(this.lastTokEnd, this.start)) : t === b._else || t === b.semi || t === b.eof || t === b.parenR || t === b.arrow || (t === b.braceL ? e === St.b_stat : t !== b._var && t !== b._const && t !== b.name && !this.exprAllowed) : !e.isExpr);
            }, wt.inGeneratorContext = function () {
              for (var t = this.context.length - 1; t >= 1; t--) {
                var e = this.context[t];
                if ("function" === e.token) return e.generator;
              }
              return !1;
            }, wt.updateContext = function (t) {
              var e,
                i = this.type;
              i.keyword && t === b.dot ? this.exprAllowed = !1 : (e = i.updateContext) ? e.call(this, t) : this.exprAllowed = i.beforeExpr;
            }, b.parenR.updateContext = b.braceR.updateContext = function () {
              if (1 !== this.context.length) {
                var t = this.context.pop();
                t === St.b_stat && "function" === this.curContext().token && (t = this.context.pop()), this.exprAllowed = !t.isExpr;
              } else this.exprAllowed = !0;
            }, b.braceL.updateContext = function (t) {
              this.context.push(this.braceIsBlock(t) ? St.b_stat : St.b_expr), this.exprAllowed = !0;
            }, b.dollarBraceL.updateContext = function () {
              this.context.push(St.b_tmpl), this.exprAllowed = !0;
            }, b.parenL.updateContext = function (t) {
              var e = t === b._if || t === b._for || t === b._with || t === b._while;
              this.context.push(e ? St.p_stat : St.p_expr), this.exprAllowed = !0;
            }, b.incDec.updateContext = function () {}, b._function.updateContext = b._class.updateContext = function (t) {
              !t.beforeExpr || t === b._else || t === b.semi && this.curContext() !== St.p_stat || t === b._return && _.test(this.input.slice(this.lastTokEnd, this.start)) || (t === b.colon || t === b.braceL) && this.curContext() === St.b_stat ? this.context.push(St.f_stat) : this.context.push(St.f_expr), this.exprAllowed = !1;
            }, b.backQuote.updateContext = function () {
              this.curContext() === St.q_tmpl ? this.context.pop() : this.context.push(St.q_tmpl), this.exprAllowed = !1;
            }, b.star.updateContext = function (t) {
              if (t === b._function) {
                var e = this.context.length - 1;
                this.context[e] === St.f_expr ? this.context[e] = St.f_expr_gen : this.context[e] = St.f_gen;
              }
              this.exprAllowed = !0;
            }, b.name.updateContext = function (t) {
              var e = !1;
              this.options.ecmaVersion >= 6 && t !== b.dot && ("of" === this.value && !this.exprAllowed || "yield" === this.value && this.inGeneratorContext()) && (e = !0), this.exprAllowed = e;
            };
            var Ct = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS",
              Et = Ct + " Extended_Pictographic",
              At = {
                9: Ct,
                10: Et,
                11: Et,
                12: Et + " EBase EComp EMod EPres ExtPict"
              },
              It = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu",
              Pt = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb",
              Tt = Pt + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd",
              Nt = Tt + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho",
              Lt = {
                9: Pt,
                10: Tt,
                11: Nt,
                12: Nt + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi"
              },
              Vt = {};
            function Ot(t) {
              var e = Vt[t] = {
                binary: N(At[t] + " " + It),
                nonBinary: {
                  General_Category: N(It),
                  Script: N(Lt[t])
                }
              };
              e.nonBinary.Script_Extensions = e.nonBinary.Script, e.nonBinary.gc = e.nonBinary.General_Category, e.nonBinary.sc = e.nonBinary.Script, e.nonBinary.scx = e.nonBinary.Script_Extensions;
            }
            Ot(9), Ot(10), Ot(11), Ot(12);
            var Rt = et.prototype,
              Mt = function (t) {
                this.parser = t, this.validFlags = "gim" + (t.options.ecmaVersion >= 6 ? "uy" : "") + (t.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = Vt[t.options.ecmaVersion >= 12 ? 12 : t.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
              };
            function Bt(t) {
              return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(55296 + (t >> 10), 56320 + (1023 & t)));
            }
            function Dt(t) {
              return 36 === t || t >= 40 && t <= 43 || 46 === t || 63 === t || t >= 91 && t <= 94 || t >= 123 && t <= 125;
            }
            function jt(t) {
              return u(t, !0) || 36 === t || 95 === t;
            }
            function Ut(t) {
              return d(t, !0) || 36 === t || 95 === t || 8204 === t || 8205 === t;
            }
            function Ft(t) {
              return t >= 65 && t <= 90 || t >= 97 && t <= 122;
            }
            function qt(t) {
              return t >= 0 && t <= 1114111;
            }
            function Gt(t) {
              return 100 === t || 68 === t || 115 === t || 83 === t || 119 === t || 87 === t;
            }
            function Ht(t) {
              return Ft(t) || 95 === t;
            }
            function Wt(t) {
              return Ht(t) || zt(t);
            }
            function zt(t) {
              return t >= 48 && t <= 57;
            }
            function Kt(t) {
              return t >= 48 && t <= 57 || t >= 65 && t <= 70 || t >= 97 && t <= 102;
            }
            function Xt(t) {
              return t >= 65 && t <= 70 ? t - 65 + 10 : t >= 97 && t <= 102 ? t - 97 + 10 : t - 48;
            }
            function Qt(t) {
              return t >= 48 && t <= 55;
            }
            Mt.prototype.reset = function (t, e, i) {
              var s = -1 !== i.indexOf("u");
              this.start = 0 | t, this.source = e + "", this.flags = i, this.switchU = s && this.parser.options.ecmaVersion >= 6, this.switchN = s && this.parser.options.ecmaVersion >= 9;
            }, Mt.prototype.raise = function (t) {
              this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + t);
            }, Mt.prototype.at = function (t, e) {
              void 0 === e && (e = !1);
              var i = this.source,
                s = i.length;
              if (t >= s) return -1;
              var r = i.charCodeAt(t);
              if (!e && !this.switchU || r <= 55295 || r >= 57344 || t + 1 >= s) return r;
              var a = i.charCodeAt(t + 1);
              return a >= 56320 && a <= 57343 ? (r << 10) + a - 56613888 : r;
            }, Mt.prototype.nextIndex = function (t, e) {
              void 0 === e && (e = !1);
              var i = this.source,
                s = i.length;
              if (t >= s) return s;
              var r,
                a = i.charCodeAt(t);
              return !e && !this.switchU || a <= 55295 || a >= 57344 || t + 1 >= s || (r = i.charCodeAt(t + 1)) < 56320 || r > 57343 ? t + 1 : t + 2;
            }, Mt.prototype.current = function (t) {
              return void 0 === t && (t = !1), this.at(this.pos, t);
            }, Mt.prototype.lookahead = function (t) {
              return void 0 === t && (t = !1), this.at(this.nextIndex(this.pos, t), t);
            }, Mt.prototype.advance = function (t) {
              void 0 === t && (t = !1), this.pos = this.nextIndex(this.pos, t);
            }, Mt.prototype.eat = function (t, e) {
              return void 0 === e && (e = !1), this.current(e) === t && (this.advance(e), !0);
            }, Rt.validateRegExpFlags = function (t) {
              for (var e = t.validFlags, i = t.flags, s = 0; s < i.length; s++) {
                var r = i.charAt(s);
                -1 === e.indexOf(r) && this.raise(t.start, "Invalid regular expression flag"), i.indexOf(r, s + 1) > -1 && this.raise(t.start, "Duplicate regular expression flag");
              }
            }, Rt.validateRegExpPattern = function (t) {
              this.regexp_pattern(t), !t.switchN && this.options.ecmaVersion >= 9 && t.groupNames.length > 0 && (t.switchN = !0, this.regexp_pattern(t));
            }, Rt.regexp_pattern = function (t) {
              t.pos = 0, t.lastIntValue = 0, t.lastStringValue = "", t.lastAssertionIsQuantifiable = !1, t.numCapturingParens = 0, t.maxBackReference = 0, t.groupNames.length = 0, t.backReferenceNames.length = 0, this.regexp_disjunction(t), t.pos !== t.source.length && (t.eat(41) && t.raise("Unmatched ')'"), (t.eat(93) || t.eat(125)) && t.raise("Lone quantifier brackets")), t.maxBackReference > t.numCapturingParens && t.raise("Invalid escape");
              for (var e = 0, i = t.backReferenceNames; e < i.length; e += 1) {
                var s = i[e];
                -1 === t.groupNames.indexOf(s) && t.raise("Invalid named capture referenced");
              }
            }, Rt.regexp_disjunction = function (t) {
              for (this.regexp_alternative(t); t.eat(124);) this.regexp_alternative(t);
              this.regexp_eatQuantifier(t, !0) && t.raise("Nothing to repeat"), t.eat(123) && t.raise("Lone quantifier brackets");
            }, Rt.regexp_alternative = function (t) {
              for (; t.pos < t.source.length && this.regexp_eatTerm(t););
            }, Rt.regexp_eatTerm = function (t) {
              return this.regexp_eatAssertion(t) ? (t.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(t) && t.switchU && t.raise("Invalid quantifier"), !0) : !!(t.switchU ? this.regexp_eatAtom(t) : this.regexp_eatExtendedAtom(t)) && (this.regexp_eatQuantifier(t), !0);
            }, Rt.regexp_eatAssertion = function (t) {
              var e = t.pos;
              if (t.lastAssertionIsQuantifiable = !1, t.eat(94) || t.eat(36)) return !0;
              if (t.eat(92)) {
                if (t.eat(66) || t.eat(98)) return !0;
                t.pos = e;
              }
              if (t.eat(40) && t.eat(63)) {
                var i = !1;
                if (this.options.ecmaVersion >= 9 && (i = t.eat(60)), t.eat(61) || t.eat(33)) return this.regexp_disjunction(t), t.eat(41) || t.raise("Unterminated group"), t.lastAssertionIsQuantifiable = !i, !0;
              }
              return t.pos = e, !1;
            }, Rt.regexp_eatQuantifier = function (t, e) {
              return void 0 === e && (e = !1), !!this.regexp_eatQuantifierPrefix(t, e) && (t.eat(63), !0);
            }, Rt.regexp_eatQuantifierPrefix = function (t, e) {
              return t.eat(42) || t.eat(43) || t.eat(63) || this.regexp_eatBracedQuantifier(t, e);
            }, Rt.regexp_eatBracedQuantifier = function (t, e) {
              var i = t.pos;
              if (t.eat(123)) {
                var s = 0,
                  r = -1;
                if (this.regexp_eatDecimalDigits(t) && (s = t.lastIntValue, t.eat(44) && this.regexp_eatDecimalDigits(t) && (r = t.lastIntValue), t.eat(125))) return -1 !== r && r < s && !e && t.raise("numbers out of order in {} quantifier"), !0;
                t.switchU && !e && t.raise("Incomplete quantifier"), t.pos = i;
              }
              return !1;
            }, Rt.regexp_eatAtom = function (t) {
              return this.regexp_eatPatternCharacters(t) || t.eat(46) || this.regexp_eatReverseSolidusAtomEscape(t) || this.regexp_eatCharacterClass(t) || this.regexp_eatUncapturingGroup(t) || this.regexp_eatCapturingGroup(t);
            }, Rt.regexp_eatReverseSolidusAtomEscape = function (t) {
              var e = t.pos;
              if (t.eat(92)) {
                if (this.regexp_eatAtomEscape(t)) return !0;
                t.pos = e;
              }
              return !1;
            }, Rt.regexp_eatUncapturingGroup = function (t) {
              var e = t.pos;
              if (t.eat(40)) {
                if (t.eat(63) && t.eat(58)) {
                  if (this.regexp_disjunction(t), t.eat(41)) return !0;
                  t.raise("Unterminated group");
                }
                t.pos = e;
              }
              return !1;
            }, Rt.regexp_eatCapturingGroup = function (t) {
              if (t.eat(40)) {
                if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(t) : 63 === t.current() && t.raise("Invalid group"), this.regexp_disjunction(t), t.eat(41)) return t.numCapturingParens += 1, !0;
                t.raise("Unterminated group");
              }
              return !1;
            }, Rt.regexp_eatExtendedAtom = function (t) {
              return t.eat(46) || this.regexp_eatReverseSolidusAtomEscape(t) || this.regexp_eatCharacterClass(t) || this.regexp_eatUncapturingGroup(t) || this.regexp_eatCapturingGroup(t) || this.regexp_eatInvalidBracedQuantifier(t) || this.regexp_eatExtendedPatternCharacter(t);
            }, Rt.regexp_eatInvalidBracedQuantifier = function (t) {
              return this.regexp_eatBracedQuantifier(t, !0) && t.raise("Nothing to repeat"), !1;
            }, Rt.regexp_eatSyntaxCharacter = function (t) {
              var e = t.current();
              return !!Dt(e) && (t.lastIntValue = e, t.advance(), !0);
            }, Rt.regexp_eatPatternCharacters = function (t) {
              for (var e = t.pos, i = 0; -1 !== (i = t.current()) && !Dt(i);) t.advance();
              return t.pos !== e;
            }, Rt.regexp_eatExtendedPatternCharacter = function (t) {
              var e = t.current();
              return !(-1 === e || 36 === e || e >= 40 && e <= 43 || 46 === e || 63 === e || 91 === e || 94 === e || 124 === e || (t.advance(), 0));
            }, Rt.regexp_groupSpecifier = function (t) {
              if (t.eat(63)) {
                if (this.regexp_eatGroupName(t)) return -1 !== t.groupNames.indexOf(t.lastStringValue) && t.raise("Duplicate capture group name"), void t.groupNames.push(t.lastStringValue);
                t.raise("Invalid group");
              }
            }, Rt.regexp_eatGroupName = function (t) {
              if (t.lastStringValue = "", t.eat(60)) {
                if (this.regexp_eatRegExpIdentifierName(t) && t.eat(62)) return !0;
                t.raise("Invalid capture group name");
              }
              return !1;
            }, Rt.regexp_eatRegExpIdentifierName = function (t) {
              if (t.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(t)) {
                for (t.lastStringValue += Bt(t.lastIntValue); this.regexp_eatRegExpIdentifierPart(t);) t.lastStringValue += Bt(t.lastIntValue);
                return !0;
              }
              return !1;
            }, Rt.regexp_eatRegExpIdentifierStart = function (t) {
              var e = t.pos,
                i = this.options.ecmaVersion >= 11,
                s = t.current(i);
              return t.advance(i), 92 === s && this.regexp_eatRegExpUnicodeEscapeSequence(t, i) && (s = t.lastIntValue), jt(s) ? (t.lastIntValue = s, !0) : (t.pos = e, !1);
            }, Rt.regexp_eatRegExpIdentifierPart = function (t) {
              var e = t.pos,
                i = this.options.ecmaVersion >= 11,
                s = t.current(i);
              return t.advance(i), 92 === s && this.regexp_eatRegExpUnicodeEscapeSequence(t, i) && (s = t.lastIntValue), Ut(s) ? (t.lastIntValue = s, !0) : (t.pos = e, !1);
            }, Rt.regexp_eatAtomEscape = function (t) {
              return !!(this.regexp_eatBackReference(t) || this.regexp_eatCharacterClassEscape(t) || this.regexp_eatCharacterEscape(t) || t.switchN && this.regexp_eatKGroupName(t)) || (t.switchU && (99 === t.current() && t.raise("Invalid unicode escape"), t.raise("Invalid escape")), !1);
            }, Rt.regexp_eatBackReference = function (t) {
              var e = t.pos;
              if (this.regexp_eatDecimalEscape(t)) {
                var i = t.lastIntValue;
                if (t.switchU) return i > t.maxBackReference && (t.maxBackReference = i), !0;
                if (i <= t.numCapturingParens) return !0;
                t.pos = e;
              }
              return !1;
            }, Rt.regexp_eatKGroupName = function (t) {
              if (t.eat(107)) {
                if (this.regexp_eatGroupName(t)) return t.backReferenceNames.push(t.lastStringValue), !0;
                t.raise("Invalid named reference");
              }
              return !1;
            }, Rt.regexp_eatCharacterEscape = function (t) {
              return this.regexp_eatControlEscape(t) || this.regexp_eatCControlLetter(t) || this.regexp_eatZero(t) || this.regexp_eatHexEscapeSequence(t) || this.regexp_eatRegExpUnicodeEscapeSequence(t, !1) || !t.switchU && this.regexp_eatLegacyOctalEscapeSequence(t) || this.regexp_eatIdentityEscape(t);
            }, Rt.regexp_eatCControlLetter = function (t) {
              var e = t.pos;
              if (t.eat(99)) {
                if (this.regexp_eatControlLetter(t)) return !0;
                t.pos = e;
              }
              return !1;
            }, Rt.regexp_eatZero = function (t) {
              return 48 === t.current() && !zt(t.lookahead()) && (t.lastIntValue = 0, t.advance(), !0);
            }, Rt.regexp_eatControlEscape = function (t) {
              var e = t.current();
              return 116 === e ? (t.lastIntValue = 9, t.advance(), !0) : 110 === e ? (t.lastIntValue = 10, t.advance(), !0) : 118 === e ? (t.lastIntValue = 11, t.advance(), !0) : 102 === e ? (t.lastIntValue = 12, t.advance(), !0) : 114 === e && (t.lastIntValue = 13, t.advance(), !0);
            }, Rt.regexp_eatControlLetter = function (t) {
              var e = t.current();
              return !!Ft(e) && (t.lastIntValue = e % 32, t.advance(), !0);
            }, Rt.regexp_eatRegExpUnicodeEscapeSequence = function (t, e) {
              void 0 === e && (e = !1);
              var i = t.pos,
                s = e || t.switchU;
              if (t.eat(117)) {
                if (this.regexp_eatFixedHexDigits(t, 4)) {
                  var r = t.lastIntValue;
                  if (s && r >= 55296 && r <= 56319) {
                    var a = t.pos;
                    if (t.eat(92) && t.eat(117) && this.regexp_eatFixedHexDigits(t, 4)) {
                      var n = t.lastIntValue;
                      if (n >= 56320 && n <= 57343) return t.lastIntValue = 1024 * (r - 55296) + (n - 56320) + 65536, !0;
                    }
                    t.pos = a, t.lastIntValue = r;
                  }
                  return !0;
                }
                if (s && t.eat(123) && this.regexp_eatHexDigits(t) && t.eat(125) && qt(t.lastIntValue)) return !0;
                s && t.raise("Invalid unicode escape"), t.pos = i;
              }
              return !1;
            }, Rt.regexp_eatIdentityEscape = function (t) {
              if (t.switchU) return !!this.regexp_eatSyntaxCharacter(t) || !!t.eat(47) && (t.lastIntValue = 47, !0);
              var e = t.current();
              return !(99 === e || t.switchN && 107 === e || (t.lastIntValue = e, t.advance(), 0));
            }, Rt.regexp_eatDecimalEscape = function (t) {
              t.lastIntValue = 0;
              var e = t.current();
              if (e >= 49 && e <= 57) {
                do {
                  t.lastIntValue = 10 * t.lastIntValue + (e - 48), t.advance();
                } while ((e = t.current()) >= 48 && e <= 57);
                return !0;
              }
              return !1;
            }, Rt.regexp_eatCharacterClassEscape = function (t) {
              var e = t.current();
              if (Gt(e)) return t.lastIntValue = -1, t.advance(), !0;
              if (t.switchU && this.options.ecmaVersion >= 9 && (80 === e || 112 === e)) {
                if (t.lastIntValue = -1, t.advance(), t.eat(123) && this.regexp_eatUnicodePropertyValueExpression(t) && t.eat(125)) return !0;
                t.raise("Invalid property name");
              }
              return !1;
            }, Rt.regexp_eatUnicodePropertyValueExpression = function (t) {
              var e = t.pos;
              if (this.regexp_eatUnicodePropertyName(t) && t.eat(61)) {
                var i = t.lastStringValue;
                if (this.regexp_eatUnicodePropertyValue(t)) {
                  var s = t.lastStringValue;
                  return this.regexp_validateUnicodePropertyNameAndValue(t, i, s), !0;
                }
              }
              if (t.pos = e, this.regexp_eatLoneUnicodePropertyNameOrValue(t)) {
                var r = t.lastStringValue;
                return this.regexp_validateUnicodePropertyNameOrValue(t, r), !0;
              }
              return !1;
            }, Rt.regexp_validateUnicodePropertyNameAndValue = function (t, e, i) {
              P(t.unicodeProperties.nonBinary, e) || t.raise("Invalid property name"), t.unicodeProperties.nonBinary[e].test(i) || t.raise("Invalid property value");
            }, Rt.regexp_validateUnicodePropertyNameOrValue = function (t, e) {
              t.unicodeProperties.binary.test(e) || t.raise("Invalid property name");
            }, Rt.regexp_eatUnicodePropertyName = function (t) {
              var e = 0;
              for (t.lastStringValue = ""; Ht(e = t.current());) t.lastStringValue += Bt(e), t.advance();
              return "" !== t.lastStringValue;
            }, Rt.regexp_eatUnicodePropertyValue = function (t) {
              var e = 0;
              for (t.lastStringValue = ""; Wt(e = t.current());) t.lastStringValue += Bt(e), t.advance();
              return "" !== t.lastStringValue;
            }, Rt.regexp_eatLoneUnicodePropertyNameOrValue = function (t) {
              return this.regexp_eatUnicodePropertyValue(t);
            }, Rt.regexp_eatCharacterClass = function (t) {
              if (t.eat(91)) {
                if (t.eat(94), this.regexp_classRanges(t), t.eat(93)) return !0;
                t.raise("Unterminated character class");
              }
              return !1;
            }, Rt.regexp_classRanges = function (t) {
              for (; this.regexp_eatClassAtom(t);) {
                var e = t.lastIntValue;
                if (t.eat(45) && this.regexp_eatClassAtom(t)) {
                  var i = t.lastIntValue;
                  !t.switchU || -1 !== e && -1 !== i || t.raise("Invalid character class"), -1 !== e && -1 !== i && e > i && t.raise("Range out of order in character class");
                }
              }
            }, Rt.regexp_eatClassAtom = function (t) {
              var e = t.pos;
              if (t.eat(92)) {
                if (this.regexp_eatClassEscape(t)) return !0;
                if (t.switchU) {
                  var i = t.current();
                  (99 === i || Qt(i)) && t.raise("Invalid class escape"), t.raise("Invalid escape");
                }
                t.pos = e;
              }
              var s = t.current();
              return 93 !== s && (t.lastIntValue = s, t.advance(), !0);
            }, Rt.regexp_eatClassEscape = function (t) {
              var e = t.pos;
              if (t.eat(98)) return t.lastIntValue = 8, !0;
              if (t.switchU && t.eat(45)) return t.lastIntValue = 45, !0;
              if (!t.switchU && t.eat(99)) {
                if (this.regexp_eatClassControlLetter(t)) return !0;
                t.pos = e;
              }
              return this.regexp_eatCharacterClassEscape(t) || this.regexp_eatCharacterEscape(t);
            }, Rt.regexp_eatClassControlLetter = function (t) {
              var e = t.current();
              return !(!zt(e) && 95 !== e || (t.lastIntValue = e % 32, t.advance(), 0));
            }, Rt.regexp_eatHexEscapeSequence = function (t) {
              var e = t.pos;
              if (t.eat(120)) {
                if (this.regexp_eatFixedHexDigits(t, 2)) return !0;
                t.switchU && t.raise("Invalid escape"), t.pos = e;
              }
              return !1;
            }, Rt.regexp_eatDecimalDigits = function (t) {
              var e = t.pos,
                i = 0;
              for (t.lastIntValue = 0; zt(i = t.current());) t.lastIntValue = 10 * t.lastIntValue + (i - 48), t.advance();
              return t.pos !== e;
            }, Rt.regexp_eatHexDigits = function (t) {
              var e = t.pos,
                i = 0;
              for (t.lastIntValue = 0; Kt(i = t.current());) t.lastIntValue = 16 * t.lastIntValue + Xt(i), t.advance();
              return t.pos !== e;
            }, Rt.regexp_eatLegacyOctalEscapeSequence = function (t) {
              if (this.regexp_eatOctalDigit(t)) {
                var e = t.lastIntValue;
                if (this.regexp_eatOctalDigit(t)) {
                  var i = t.lastIntValue;
                  e <= 3 && this.regexp_eatOctalDigit(t) ? t.lastIntValue = 64 * e + 8 * i + t.lastIntValue : t.lastIntValue = 8 * e + i;
                } else t.lastIntValue = e;
                return !0;
              }
              return !1;
            }, Rt.regexp_eatOctalDigit = function (t) {
              var e = t.current();
              return Qt(e) ? (t.lastIntValue = e - 48, t.advance(), !0) : (t.lastIntValue = 0, !1);
            }, Rt.regexp_eatFixedHexDigits = function (t, e) {
              var i = t.pos;
              t.lastIntValue = 0;
              for (var s = 0; s < e; ++s) {
                var r = t.current();
                if (!Kt(r)) return t.pos = i, !1;
                t.lastIntValue = 16 * t.lastIntValue + Xt(r), t.advance();
              }
              return !0;
            };
            var Jt = function (t) {
                this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, t.options.locations && (this.loc = new V(t, t.startLoc, t.endLoc)), t.options.ranges && (this.range = [t.start, t.end]);
              },
              Yt = et.prototype;
            function Zt(t, e) {
              return e ? parseInt(t, 8) : parseFloat(t.replace(/_/g, ""));
            }
            function $t(t) {
              return "function" != typeof BigInt ? null : BigInt(t.replace(/_/g, ""));
            }
            function te(t) {
              return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(55296 + (t >> 10), 56320 + (1023 & t)));
            }
            Yt.next = function (t) {
              !t && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new Jt(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
            }, Yt.getToken = function () {
              return this.next(), new Jt(this);
            }, "undefined" != typeof Symbol && (Yt[Symbol.iterator] = function () {
              var t = this;
              return {
                next: function () {
                  var e = t.getToken();
                  return {
                    done: e.type === b.eof,
                    value: e
                  };
                }
              };
            }), Yt.curContext = function () {
              return this.context[this.context.length - 1];
            }, Yt.nextToken = function () {
              var t = this.curContext();
              return t && t.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(b.eof) : t.override ? t.override(this) : void this.readToken(this.fullCharCodeAtPos());
            }, Yt.readToken = function (t) {
              return u(t, this.options.ecmaVersion >= 6) || 92 === t ? this.readWord() : this.getTokenFromCode(t);
            }, Yt.fullCharCodeAtPos = function () {
              var t = this.input.charCodeAt(this.pos);
              return t <= 55295 || t >= 57344 ? t : (t << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
            }, Yt.skipBlockComment = function () {
              var t,
                e = this.options.onComment && this.curPosition(),
                i = this.pos,
                s = this.input.indexOf("*/", this.pos += 2);
              if (-1 === s && this.raise(this.pos - 2, "Unterminated comment"), this.pos = s + 2, this.options.locations) for (k.lastIndex = i; (t = k.exec(this.input)) && t.index < this.pos;) ++this.curLine, this.lineStart = t.index + t[0].length;
              this.options.onComment && this.options.onComment(!0, this.input.slice(i + 2, s), i, this.pos, e, this.curPosition());
            }, Yt.skipLineComment = function (t) {
              for (var e = this.pos, i = this.options.onComment && this.curPosition(), s = this.input.charCodeAt(this.pos += t); this.pos < this.input.length && !S(s);) s = this.input.charCodeAt(++this.pos);
              this.options.onComment && this.options.onComment(!1, this.input.slice(e + t, this.pos), e, this.pos, i, this.curPosition());
            }, Yt.skipSpace = function () {
              t: for (; this.pos < this.input.length;) {
                var t = this.input.charCodeAt(this.pos);
                switch (t) {
                  case 32:
                  case 160:
                    ++this.pos;
                    break;
                  case 13:
                    10 === this.input.charCodeAt(this.pos + 1) && ++this.pos;
                  case 10:
                  case 8232:
                  case 8233:
                    ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                    break;
                  case 47:
                    switch (this.input.charCodeAt(this.pos + 1)) {
                      case 42:
                        this.skipBlockComment();
                        break;
                      case 47:
                        this.skipLineComment(2);
                        break;
                      default:
                        break t;
                    }
                    break;
                  default:
                    if (!(t > 8 && t < 14 || t >= 5760 && w.test(String.fromCharCode(t)))) break t;
                    ++this.pos;
                }
              }
            }, Yt.finishToken = function (t, e) {
              this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
              var i = this.type;
              this.type = t, this.value = e, this.updateContext(i);
            }, Yt.readToken_dot = function () {
              var t = this.input.charCodeAt(this.pos + 1);
              if (t >= 48 && t <= 57) return this.readNumber(!0);
              var e = this.input.charCodeAt(this.pos + 2);
              return this.options.ecmaVersion >= 6 && 46 === t && 46 === e ? (this.pos += 3, this.finishToken(b.ellipsis)) : (++this.pos, this.finishToken(b.dot));
            }, Yt.readToken_slash = function () {
              var t = this.input.charCodeAt(this.pos + 1);
              return this.exprAllowed ? (++this.pos, this.readRegexp()) : 61 === t ? this.finishOp(b.assign, 2) : this.finishOp(b.slash, 1);
            }, Yt.readToken_mult_modulo_exp = function (t) {
              var e = this.input.charCodeAt(this.pos + 1),
                i = 1,
                s = 42 === t ? b.star : b.modulo;
              return this.options.ecmaVersion >= 7 && 42 === t && 42 === e && (++i, s = b.starstar, e = this.input.charCodeAt(this.pos + 2)), 61 === e ? this.finishOp(b.assign, i + 1) : this.finishOp(s, i);
            }, Yt.readToken_pipe_amp = function (t) {
              var e = this.input.charCodeAt(this.pos + 1);
              return e === t ? this.options.ecmaVersion >= 12 && 61 === this.input.charCodeAt(this.pos + 2) ? this.finishOp(b.assign, 3) : this.finishOp(124 === t ? b.logicalOR : b.logicalAND, 2) : 61 === e ? this.finishOp(b.assign, 2) : this.finishOp(124 === t ? b.bitwiseOR : b.bitwiseAND, 1);
            }, Yt.readToken_caret = function () {
              return 61 === this.input.charCodeAt(this.pos + 1) ? this.finishOp(b.assign, 2) : this.finishOp(b.bitwiseXOR, 1);
            }, Yt.readToken_plus_min = function (t) {
              var e = this.input.charCodeAt(this.pos + 1);
              return e === t ? 45 !== e || this.inModule || 62 !== this.input.charCodeAt(this.pos + 2) || 0 !== this.lastTokEnd && !_.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(b.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : 61 === e ? this.finishOp(b.assign, 2) : this.finishOp(b.plusMin, 1);
            }, Yt.readToken_lt_gt = function (t) {
              var e = this.input.charCodeAt(this.pos + 1),
                i = 1;
              return e === t ? (i = 62 === t && 62 === this.input.charCodeAt(this.pos + 2) ? 3 : 2, 61 === this.input.charCodeAt(this.pos + i) ? this.finishOp(b.assign, i + 1) : this.finishOp(b.bitShift, i)) : 33 !== e || 60 !== t || this.inModule || 45 !== this.input.charCodeAt(this.pos + 2) || 45 !== this.input.charCodeAt(this.pos + 3) ? (61 === e && (i = 2), this.finishOp(b.relational, i)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
            }, Yt.readToken_eq_excl = function (t) {
              var e = this.input.charCodeAt(this.pos + 1);
              return 61 === e ? this.finishOp(b.equality, 61 === this.input.charCodeAt(this.pos + 2) ? 3 : 2) : 61 === t && 62 === e && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(b.arrow)) : this.finishOp(61 === t ? b.eq : b.prefix, 1);
            }, Yt.readToken_question = function () {
              var t = this.options.ecmaVersion;
              if (t >= 11) {
                var e = this.input.charCodeAt(this.pos + 1);
                if (46 === e) {
                  var i = this.input.charCodeAt(this.pos + 2);
                  if (i < 48 || i > 57) return this.finishOp(b.questionDot, 2);
                }
                if (63 === e) return t >= 12 && 61 === this.input.charCodeAt(this.pos + 2) ? this.finishOp(b.assign, 3) : this.finishOp(b.coalesce, 2);
              }
              return this.finishOp(b.question, 1);
            }, Yt.getTokenFromCode = function (t) {
              switch (t) {
                case 46:
                  return this.readToken_dot();
                case 40:
                  return ++this.pos, this.finishToken(b.parenL);
                case 41:
                  return ++this.pos, this.finishToken(b.parenR);
                case 59:
                  return ++this.pos, this.finishToken(b.semi);
                case 44:
                  return ++this.pos, this.finishToken(b.comma);
                case 91:
                  return ++this.pos, this.finishToken(b.bracketL);
                case 93:
                  return ++this.pos, this.finishToken(b.bracketR);
                case 123:
                  return ++this.pos, this.finishToken(b.braceL);
                case 125:
                  return ++this.pos, this.finishToken(b.braceR);
                case 58:
                  return ++this.pos, this.finishToken(b.colon);
                case 96:
                  if (this.options.ecmaVersion < 6) break;
                  return ++this.pos, this.finishToken(b.backQuote);
                case 48:
                  var e = this.input.charCodeAt(this.pos + 1);
                  if (120 === e || 88 === e) return this.readRadixNumber(16);
                  if (this.options.ecmaVersion >= 6) {
                    if (111 === e || 79 === e) return this.readRadixNumber(8);
                    if (98 === e || 66 === e) return this.readRadixNumber(2);
                  }
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                  return this.readNumber(!1);
                case 34:
                case 39:
                  return this.readString(t);
                case 47:
                  return this.readToken_slash();
                case 37:
                case 42:
                  return this.readToken_mult_modulo_exp(t);
                case 124:
                case 38:
                  return this.readToken_pipe_amp(t);
                case 94:
                  return this.readToken_caret();
                case 43:
                case 45:
                  return this.readToken_plus_min(t);
                case 60:
                case 62:
                  return this.readToken_lt_gt(t);
                case 61:
                case 33:
                  return this.readToken_eq_excl(t);
                case 63:
                  return this.readToken_question();
                case 126:
                  return this.finishOp(b.prefix, 1);
              }
              this.raise(this.pos, "Unexpected character '" + te(t) + "'");
            }, Yt.finishOp = function (t, e) {
              var i = this.input.slice(this.pos, this.pos + e);
              return this.pos += e, this.finishToken(t, i);
            }, Yt.readRegexp = function () {
              for (var t, e, i = this.pos;;) {
                this.pos >= this.input.length && this.raise(i, "Unterminated regular expression");
                var s = this.input.charAt(this.pos);
                if (_.test(s) && this.raise(i, "Unterminated regular expression"), t) t = !1;else {
                  if ("[" === s) e = !0;else if ("]" === s && e) e = !1;else if ("/" === s && !e) break;
                  t = "\\" === s;
                }
                ++this.pos;
              }
              var r = this.input.slice(i, this.pos);
              ++this.pos;
              var a = this.pos,
                n = this.readWord1();
              this.containsEsc && this.unexpected(a);
              var o = this.regexpState || (this.regexpState = new Mt(this));
              o.reset(i, r, n), this.validateRegExpFlags(o), this.validateRegExpPattern(o);
              var h = null;
              try {
                h = new RegExp(r, n);
              } catch (t) {}
              return this.finishToken(b.regexp, {
                pattern: r,
                flags: n,
                value: h
              });
            }, Yt.readInt = function (t, e, i) {
              for (var s = this.options.ecmaVersion >= 12 && void 0 === e, r = i && 48 === this.input.charCodeAt(this.pos), a = this.pos, n = 0, o = 0, h = 0, p = null == e ? 1 / 0 : e; h < p; ++h, ++this.pos) {
                var c = this.input.charCodeAt(this.pos),
                  l = void 0;
                if (s && 95 === c) r && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), 95 === o && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), 0 === h && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), o = c;else {
                  if ((l = c >= 97 ? c - 97 + 10 : c >= 65 ? c - 65 + 10 : c >= 48 && c <= 57 ? c - 48 : 1 / 0) >= t) break;
                  o = c, n = n * t + l;
                }
              }
              return s && 95 === o && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === a || null != e && this.pos - a !== e ? null : n;
            }, Yt.readRadixNumber = function (t) {
              var e = this.pos;
              this.pos += 2;
              var i = this.readInt(t);
              return null == i && this.raise(this.start + 2, "Expected number in radix " + t), this.options.ecmaVersion >= 11 && 110 === this.input.charCodeAt(this.pos) ? (i = $t(this.input.slice(e, this.pos)), ++this.pos) : u(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(b.num, i);
            }, Yt.readNumber = function (t) {
              var e = this.pos;
              t || null !== this.readInt(10, void 0, !0) || this.raise(e, "Invalid number");
              var i = this.pos - e >= 2 && 48 === this.input.charCodeAt(e);
              i && this.strict && this.raise(e, "Invalid number");
              var s = this.input.charCodeAt(this.pos);
              if (!i && !t && this.options.ecmaVersion >= 11 && 110 === s) {
                var r = $t(this.input.slice(e, this.pos));
                return ++this.pos, u(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(b.num, r);
              }
              i && /[89]/.test(this.input.slice(e, this.pos)) && (i = !1), 46 !== s || i || (++this.pos, this.readInt(10), s = this.input.charCodeAt(this.pos)), 69 !== s && 101 !== s || i || (43 !== (s = this.input.charCodeAt(++this.pos)) && 45 !== s || ++this.pos, null === this.readInt(10) && this.raise(e, "Invalid number")), u(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
              var a = Zt(this.input.slice(e, this.pos), i);
              return this.finishToken(b.num, a);
            }, Yt.readCodePoint = function () {
              var t;
              if (123 === this.input.charCodeAt(this.pos)) {
                this.options.ecmaVersion < 6 && this.unexpected();
                var e = ++this.pos;
                t = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, t > 1114111 && this.invalidStringToken(e, "Code point out of bounds");
              } else t = this.readHexChar(4);
              return t;
            }, Yt.readString = function (t) {
              for (var e = "", i = ++this.pos;;) {
                this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
                var s = this.input.charCodeAt(this.pos);
                if (s === t) break;
                92 === s ? (e += this.input.slice(i, this.pos), e += this.readEscapedChar(!1), i = this.pos) : (S(s, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
              }
              return e += this.input.slice(i, this.pos++), this.finishToken(b.string, e);
            };
            var ee = {};
            Yt.tryReadTemplateToken = function () {
              this.inTemplateElement = !0;
              try {
                this.readTmplToken();
              } catch (t) {
                if (t !== ee) throw t;
                this.readInvalidTemplateToken();
              }
              this.inTemplateElement = !1;
            }, Yt.invalidStringToken = function (t, e) {
              if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw ee;
              this.raise(t, e);
            }, Yt.readTmplToken = function () {
              for (var t = "", e = this.pos;;) {
                this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
                var i = this.input.charCodeAt(this.pos);
                if (96 === i || 36 === i && 123 === this.input.charCodeAt(this.pos + 1)) return this.pos !== this.start || this.type !== b.template && this.type !== b.invalidTemplate ? (t += this.input.slice(e, this.pos), this.finishToken(b.template, t)) : 36 === i ? (this.pos += 2, this.finishToken(b.dollarBraceL)) : (++this.pos, this.finishToken(b.backQuote));
                if (92 === i) t += this.input.slice(e, this.pos), t += this.readEscapedChar(!0), e = this.pos;else if (S(i)) {
                  switch (t += this.input.slice(e, this.pos), ++this.pos, i) {
                    case 13:
                      10 === this.input.charCodeAt(this.pos) && ++this.pos;
                    case 10:
                      t += "\n";
                      break;
                    default:
                      t += String.fromCharCode(i);
                  }
                  this.options.locations && (++this.curLine, this.lineStart = this.pos), e = this.pos;
                } else ++this.pos;
              }
            }, Yt.readInvalidTemplateToken = function () {
              for (; this.pos < this.input.length; this.pos++) switch (this.input[this.pos]) {
                case "\\":
                  ++this.pos;
                  break;
                case "$":
                  if ("{" !== this.input[this.pos + 1]) break;
                case "`":
                  return this.finishToken(b.invalidTemplate, this.input.slice(this.start, this.pos));
              }
              this.raise(this.start, "Unterminated template");
            }, Yt.readEscapedChar = function (t) {
              var e = this.input.charCodeAt(++this.pos);
              switch (++this.pos, e) {
                case 110:
                  return "\n";
                case 114:
                  return "\r";
                case 120:
                  return String.fromCharCode(this.readHexChar(2));
                case 117:
                  return te(this.readCodePoint());
                case 116:
                  return "\t";
                case 98:
                  return "\b";
                case 118:
                  return "\v";
                case 102:
                  return "\f";
                case 13:
                  10 === this.input.charCodeAt(this.pos) && ++this.pos;
                case 10:
                  return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
                case 56:
                case 57:
                  if (this.strict && this.invalidStringToken(this.pos - 1, "Invalid escape sequence"), t) {
                    var i = this.pos - 1;
                    return this.invalidStringToken(i, "Invalid escape sequence in template string"), null;
                  }
                default:
                  if (e >= 48 && e <= 55) {
                    var s = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0],
                      r = parseInt(s, 8);
                    return r > 255 && (s = s.slice(0, -1), r = parseInt(s, 8)), this.pos += s.length - 1, e = this.input.charCodeAt(this.pos), "0" === s && 56 !== e && 57 !== e || !this.strict && !t || this.invalidStringToken(this.pos - 1 - s.length, t ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(r);
                  }
                  return S(e) ? "" : String.fromCharCode(e);
              }
            }, Yt.readHexChar = function (t) {
              var e = this.pos,
                i = this.readInt(16, t);
              return null === i && this.invalidStringToken(e, "Bad character escape sequence"), i;
            }, Yt.readWord1 = function () {
              this.containsEsc = !1;
              for (var t = "", e = !0, i = this.pos, s = this.options.ecmaVersion >= 6; this.pos < this.input.length;) {
                var r = this.fullCharCodeAtPos();
                if (d(r, s)) this.pos += r <= 65535 ? 1 : 2;else {
                  if (92 !== r) break;
                  this.containsEsc = !0, t += this.input.slice(i, this.pos);
                  var a = this.pos;
                  117 !== this.input.charCodeAt(++this.pos) && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
                  var n = this.readCodePoint();
                  (e ? u : d)(n, s) || this.invalidStringToken(a, "Invalid Unicode escape"), t += te(n), i = this.pos;
                }
                e = !1;
              }
              return t + this.input.slice(i, this.pos);
            }, Yt.readWord = function () {
              var t = this.readWord1(),
                e = b.name;
              return this.keywords.test(t) && (e = y[t]), this.finishToken(e, t);
            };
            var ie = "8.0.5";
            function se(t, e) {
              return et.parse(t, e);
            }
            function re(t, e, i) {
              return et.parseExpressionAt(t, e, i);
            }
            function ae(t, e) {
              return et.tokenizer(t, e);
            }
            et.acorn = {
              Parser: et,
              version: ie,
              defaultOptions: R,
              Position: L,
              SourceLocation: V,
              getLineInfo: O,
              Node: vt,
              TokenType: f,
              tokTypes: b,
              keywordTypes: y,
              TokContext: kt,
              tokContexts: St,
              isIdentifierChar: d,
              isIdentifierStart: u,
              Token: Jt,
              isNewLine: S,
              lineBreak: _,
              lineBreakG: k,
              nonASCIIwhitespace: w
            }, t.Node = vt, t.Parser = et, t.Position = L, t.SourceLocation = V, t.TokContext = kt, t.Token = Jt, t.TokenType = f, t.defaultOptions = R, t.getLineInfo = O, t.isIdentifierChar = d, t.isIdentifierStart = u, t.isNewLine = S, t.keywordTypes = y, t.lineBreak = _, t.lineBreakG = k, t.nonASCIIwhitespace = w, t.parse = se, t.parseExpressionAt = re, t.tokContexts = St, t.tokTypes = b, t.tokenizer = ae, t.version = ie, Object.defineProperty(t, "__esModule", {
              value: !0
            });
          }(e);
        },
        272: (t, e, i) => {
          "use strict";

          i.r(e), i.d(e, {
            default: () => _e
          });
          var s = {
              3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
              5: "class enum extends super const export import",
              6: "enum",
              strict: "implements interface let package private protected public static yield",
              strictBind: "eval arguments"
            },
            r = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this",
            a = {
              5: r,
              "5module": r + " export import",
              6: r + " const class extends export import super"
            },
            n = /^in(stanceof)?$/,
            o = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࢠ-ࢴࢶ-ࣇऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-鿼ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞿꟂ-ꟊꟵ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
            h = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࣓-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-ໍ໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜔ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠐-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿᫀᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷹᷻-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿",
            p = new RegExp("[" + o + "]"),
            c = new RegExp("[" + o + h + "]");
          o = h = null;
          var l = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 107, 20, 28, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 190, 0, 80, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8952, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42717, 35, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938],
            u = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 154, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
          function d(t, e) {
            for (var i = 65536, s = 0; s < e.length; s += 2) {
              if ((i += e[s]) > t) return !1;
              if ((i += e[s + 1]) >= t) return !0;
            }
          }
          function f(t, e) {
            return t < 65 ? 36 === t : t < 91 || (t < 97 ? 95 === t : t < 123 || (t <= 65535 ? t >= 170 && p.test(String.fromCharCode(t)) : !1 !== e && d(t, l)));
          }
          function m(t, e) {
            return t < 48 ? 36 === t : t < 58 || !(t < 65) && (t < 91 || (t < 97 ? 95 === t : t < 123 || (t <= 65535 ? t >= 170 && c.test(String.fromCharCode(t)) : !1 !== e && (d(t, l) || d(t, u)))));
          }
          var g = function (t, e) {
            void 0 === e && (e = {}), this.label = t, this.keyword = e.keyword, this.beforeExpr = !!e.beforeExpr, this.startsExpr = !!e.startsExpr, this.isLoop = !!e.isLoop, this.isAssign = !!e.isAssign, this.prefix = !!e.prefix, this.postfix = !!e.postfix, this.binop = e.binop || null, this.updateContext = null;
          };
          function x(t, e) {
            return new g(t, {
              beforeExpr: !0,
              binop: e
            });
          }
          var y = {
              beforeExpr: !0
            },
            v = {
              startsExpr: !0
            },
            b = {};
          function _(t, e) {
            return void 0 === e && (e = {}), e.keyword = t, b[t] = new g(t, e);
          }
          var k = {
              num: new g("num", v),
              regexp: new g("regexp", v),
              string: new g("string", v),
              name: new g("name", v),
              eof: new g("eof"),
              bracketL: new g("[", {
                beforeExpr: !0,
                startsExpr: !0
              }),
              bracketR: new g("]"),
              braceL: new g("{", {
                beforeExpr: !0,
                startsExpr: !0
              }),
              braceR: new g("}"),
              parenL: new g("(", {
                beforeExpr: !0,
                startsExpr: !0
              }),
              parenR: new g(")"),
              comma: new g(",", y),
              semi: new g(";", y),
              colon: new g(":", y),
              dot: new g("."),
              question: new g("?", y),
              questionDot: new g("?."),
              arrow: new g("=>", y),
              template: new g("template"),
              invalidTemplate: new g("invalidTemplate"),
              ellipsis: new g("...", y),
              backQuote: new g("`", v),
              dollarBraceL: new g("${", {
                beforeExpr: !0,
                startsExpr: !0
              }),
              eq: new g("=", {
                beforeExpr: !0,
                isAssign: !0
              }),
              assign: new g("_=", {
                beforeExpr: !0,
                isAssign: !0
              }),
              incDec: new g("++/--", {
                prefix: !0,
                postfix: !0,
                startsExpr: !0
              }),
              prefix: new g("!/~", {
                beforeExpr: !0,
                prefix: !0,
                startsExpr: !0
              }),
              logicalOR: x("||", 1),
              logicalAND: x("&&", 2),
              bitwiseOR: x("|", 3),
              bitwiseXOR: x("^", 4),
              bitwiseAND: x("&", 5),
              equality: x("==/!=/===/!==", 6),
              relational: x("</>/<=/>=", 7),
              bitShift: x("<</>>/>>>", 8),
              plusMin: new g("+/-", {
                beforeExpr: !0,
                binop: 9,
                prefix: !0,
                startsExpr: !0
              }),
              modulo: x("%", 10),
              star: x("*", 10),
              slash: x("/", 10),
              starstar: new g("**", {
                beforeExpr: !0
              }),
              coalesce: x("??", 1),
              _break: _("break"),
              _case: _("case", y),
              _catch: _("catch"),
              _continue: _("continue"),
              _debugger: _("debugger"),
              _default: _("default", y),
              _do: _("do", {
                isLoop: !0,
                beforeExpr: !0
              }),
              _else: _("else", y),
              _finally: _("finally"),
              _for: _("for", {
                isLoop: !0
              }),
              _function: _("function", v),
              _if: _("if"),
              _return: _("return", y),
              _switch: _("switch"),
              _throw: _("throw", y),
              _try: _("try"),
              _var: _("var"),
              _const: _("const"),
              _while: _("while", {
                isLoop: !0
              }),
              _with: _("with"),
              _new: _("new", {
                beforeExpr: !0,
                startsExpr: !0
              }),
              _this: _("this", v),
              _super: _("super", v),
              _class: _("class", v),
              _extends: _("extends", y),
              _export: _("export"),
              _import: _("import", v),
              _null: _("null", v),
              _true: _("true", v),
              _false: _("false", v),
              _in: _("in", {
                beforeExpr: !0,
                binop: 7
              }),
              _instanceof: _("instanceof", {
                beforeExpr: !0,
                binop: 7
              }),
              _typeof: _("typeof", {
                beforeExpr: !0,
                prefix: !0,
                startsExpr: !0
              }),
              _void: _("void", {
                beforeExpr: !0,
                prefix: !0,
                startsExpr: !0
              }),
              _delete: _("delete", {
                beforeExpr: !0,
                prefix: !0,
                startsExpr: !0
              })
            },
            S = /\r\n?|\n|\u2028|\u2029/,
            w = new RegExp(S.source, "g");
          function C(t, e) {
            return 10 === t || 13 === t || !e && (8232 === t || 8233 === t);
          }
          var E = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/,
            A = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g,
            I = Object.prototype,
            P = I.hasOwnProperty,
            T = I.toString;
          function N(t, e) {
            return P.call(t, e);
          }
          var L = Array.isArray || function (t) {
            return "[object Array]" === T.call(t);
          };
          function V(t) {
            return new RegExp("^(?:" + t.replace(/ /g, "|") + ")$");
          }
          var O = function (t, e) {
            this.line = t, this.column = e;
          };
          O.prototype.offset = function (t) {
            return new O(this.line, this.column + t);
          };
          var R = function (t, e, i) {
            this.start = e, this.end = i, null !== t.sourceFile && (this.source = t.sourceFile);
          };
          function M(t, e) {
            for (var i = 1, s = 0;;) {
              w.lastIndex = s;
              var r = w.exec(t);
              if (!(r && r.index < e)) return new O(i, e - s);
              ++i, s = r.index + r[0].length;
            }
          }
          var B = {
              ecmaVersion: null,
              sourceType: "script",
              onInsertedSemicolon: null,
              onTrailingComma: null,
              allowReserved: null,
              allowReturnOutsideFunction: !1,
              allowImportExportEverywhere: !1,
              allowAwaitOutsideFunction: !1,
              allowHashBang: !1,
              locations: !1,
              onToken: null,
              onComment: null,
              ranges: !1,
              program: null,
              sourceFile: null,
              directSourceFile: null,
              preserveParens: !1
            },
            D = !1;
          function j(t) {
            var e = {};
            for (var i in B) e[i] = t && N(t, i) ? t[i] : B[i];
            if ("latest" === e.ecmaVersion ? e.ecmaVersion = 1e8 : null == e.ecmaVersion ? (!D && "object" == typeof console && console.warn && (D = !0, console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.")), e.ecmaVersion = 11) : e.ecmaVersion >= 2015 && (e.ecmaVersion -= 2009), null == e.allowReserved && (e.allowReserved = e.ecmaVersion < 5), L(e.onToken)) {
              var s = e.onToken;
              e.onToken = function (t) {
                return s.push(t);
              };
            }
            return L(e.onComment) && (e.onComment = function (t, e) {
              return function (i, s, r, a, n, o) {
                var h = {
                  type: i ? "Block" : "Line",
                  value: s,
                  start: r,
                  end: a
                };
                t.locations && (h.loc = new R(this, n, o)), t.ranges && (h.range = [r, a]), e.push(h);
              };
            }(e, e.onComment)), e;
          }
          function U(t, e) {
            return 2 | (t ? 4 : 0) | (e ? 8 : 0);
          }
          var F = function (t, e, i) {
              this.options = t = j(t), this.sourceFile = t.sourceFile, this.keywords = V(a[t.ecmaVersion >= 6 ? 6 : "module" === t.sourceType ? "5module" : 5]);
              var r = "";
              !0 !== t.allowReserved && (r = s[t.ecmaVersion >= 6 ? 6 : 5 === t.ecmaVersion ? 5 : 3], "module" === t.sourceType && (r += " await")), this.reservedWords = V(r);
              var n = (r ? r + " " : "") + s.strict;
              this.reservedWordsStrict = V(n), this.reservedWordsStrictBind = V(n + " " + s.strictBind), this.input = String(e), this.containsEsc = !1, i ? (this.pos = i, this.lineStart = this.input.lastIndexOf("\n", i - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(S).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = k.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = "module" === t.sourceType, this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = Object.create(null), 0 === this.pos && t.allowHashBang && "#!" === this.input.slice(0, 2) && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
            },
            q = {
              inFunction: {
                configurable: !0
              },
              inGenerator: {
                configurable: !0
              },
              inAsync: {
                configurable: !0
              },
              allowSuper: {
                configurable: !0
              },
              allowDirectSuper: {
                configurable: !0
              },
              treatFunctionsAsVar: {
                configurable: !0
              },
              inNonArrowFunction: {
                configurable: !0
              }
            };
          F.prototype.parse = function () {
            var t = this.options.program || this.startNode();
            return this.nextToken(), this.parseTopLevel(t);
          }, q.inFunction.get = function () {
            return (2 & this.currentVarScope().flags) > 0;
          }, q.inGenerator.get = function () {
            return (8 & this.currentVarScope().flags) > 0;
          }, q.inAsync.get = function () {
            return (4 & this.currentVarScope().flags) > 0;
          }, q.allowSuper.get = function () {
            return (64 & this.currentThisScope().flags) > 0;
          }, q.allowDirectSuper.get = function () {
            return (128 & this.currentThisScope().flags) > 0;
          }, q.treatFunctionsAsVar.get = function () {
            return this.treatFunctionsAsVarInScope(this.currentScope());
          }, q.inNonArrowFunction.get = function () {
            return (2 & this.currentThisScope().flags) > 0;
          }, F.extend = function () {
            for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
            for (var i = this, s = 0; s < t.length; s++) i = t[s](i);
            return i;
          }, F.parse = function (t, e) {
            return new this(e, t).parse();
          }, F.parseExpressionAt = function (t, e, i) {
            var s = new this(i, t, e);
            return s.nextToken(), s.parseExpression();
          }, F.tokenizer = function (t, e) {
            return new this(e, t);
          }, Object.defineProperties(F.prototype, q);
          var G = F.prototype,
            H = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
          function W() {
            this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
          }
          G.strictDirective = function (t) {
            for (;;) {
              A.lastIndex = t, t += A.exec(this.input)[0].length;
              var e = H.exec(this.input.slice(t));
              if (!e) return !1;
              if ("use strict" === (e[1] || e[2])) {
                A.lastIndex = t + e[0].length;
                var i = A.exec(this.input),
                  s = i.index + i[0].length,
                  r = this.input.charAt(s);
                return ";" === r || "}" === r || S.test(i[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(r) || "!" === r && "=" === this.input.charAt(s + 1));
              }
              t += e[0].length, A.lastIndex = t, t += A.exec(this.input)[0].length, ";" === this.input[t] && t++;
            }
          }, G.eat = function (t) {
            return this.type === t && (this.next(), !0);
          }, G.isContextual = function (t) {
            return this.type === k.name && this.value === t && !this.containsEsc;
          }, G.eatContextual = function (t) {
            return !!this.isContextual(t) && (this.next(), !0);
          }, G.expectContextual = function (t) {
            this.eatContextual(t) || this.unexpected();
          }, G.canInsertSemicolon = function () {
            return this.type === k.eof || this.type === k.braceR || S.test(this.input.slice(this.lastTokEnd, this.start));
          }, G.insertSemicolon = function () {
            if (this.canInsertSemicolon()) return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
          }, G.semicolon = function () {
            this.eat(k.semi) || this.insertSemicolon() || this.unexpected();
          }, G.afterTrailingComma = function (t, e) {
            if (this.type === t) return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), e || this.next(), !0;
          }, G.expect = function (t) {
            this.eat(t) || this.unexpected();
          }, G.unexpected = function (t) {
            this.raise(null != t ? t : this.start, "Unexpected token");
          }, G.checkPatternErrors = function (t, e) {
            if (t) {
              t.trailingComma > -1 && this.raiseRecoverable(t.trailingComma, "Comma is not permitted after the rest element");
              var i = e ? t.parenthesizedAssign : t.parenthesizedBind;
              i > -1 && this.raiseRecoverable(i, "Parenthesized pattern");
            }
          }, G.checkExpressionErrors = function (t, e) {
            if (!t) return !1;
            var i = t.shorthandAssign,
              s = t.doubleProto;
            if (!e) return i >= 0 || s >= 0;
            i >= 0 && this.raise(i, "Shorthand property assignments are valid only in destructuring patterns"), s >= 0 && this.raiseRecoverable(s, "Redefinition of __proto__ property");
          }, G.checkYieldAwaitInDefaultParams = function () {
            this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
          }, G.isSimpleAssignTarget = function (t) {
            return "ParenthesizedExpression" === t.type ? this.isSimpleAssignTarget(t.expression) : "Identifier" === t.type || "MemberExpression" === t.type;
          };
          var z = F.prototype;
          z.parseTopLevel = function (t) {
            var e = Object.create(null);
            for (t.body || (t.body = []); this.type !== k.eof;) {
              var i = this.parseStatement(null, !0, e);
              t.body.push(i);
            }
            if (this.inModule) for (var s = 0, r = Object.keys(this.undefinedExports); s < r.length; s += 1) {
              var a = r[s];
              this.raiseRecoverable(this.undefinedExports[a].start, "Export '" + a + "' is not defined");
            }
            return this.adaptDirectivePrologue(t.body), this.next(), t.sourceType = this.options.sourceType, this.finishNode(t, "Program");
          };
          var K = {
              kind: "loop"
            },
            X = {
              kind: "switch"
            };
          z.isLet = function (t) {
            if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return !1;
            A.lastIndex = this.pos;
            var e = A.exec(this.input),
              i = this.pos + e[0].length,
              s = this.input.charCodeAt(i);
            if (91 === s) return !0;
            if (t) return !1;
            if (123 === s) return !0;
            if (f(s, !0)) {
              for (var r = i + 1; m(this.input.charCodeAt(r), !0);) ++r;
              var a = this.input.slice(i, r);
              if (!n.test(a)) return !0;
            }
            return !1;
          }, z.isAsyncFunction = function () {
            if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return !1;
            A.lastIndex = this.pos;
            var t = A.exec(this.input),
              e = this.pos + t[0].length;
            return !(S.test(this.input.slice(this.pos, e)) || "function" !== this.input.slice(e, e + 8) || e + 8 !== this.input.length && m(this.input.charAt(e + 8)));
          }, z.parseStatement = function (t, e, i) {
            var s,
              r = this.type,
              a = this.startNode();
            switch (this.isLet(t) && (r = k._var, s = "let"), r) {
              case k._break:
              case k._continue:
                return this.parseBreakContinueStatement(a, r.keyword);
              case k._debugger:
                return this.parseDebuggerStatement(a);
              case k._do:
                return this.parseDoStatement(a);
              case k._for:
                return this.parseForStatement(a);
              case k._function:
                return t && (this.strict || "if" !== t && "label" !== t) && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a, !1, !t);
              case k._class:
                return t && this.unexpected(), this.parseClass(a, !0);
              case k._if:
                return this.parseIfStatement(a);
              case k._return:
                return this.parseReturnStatement(a);
              case k._switch:
                return this.parseSwitchStatement(a);
              case k._throw:
                return this.parseThrowStatement(a);
              case k._try:
                return this.parseTryStatement(a);
              case k._const:
              case k._var:
                return s = s || this.value, t && "var" !== s && this.unexpected(), this.parseVarStatement(a, s);
              case k._while:
                return this.parseWhileStatement(a);
              case k._with:
                return this.parseWithStatement(a);
              case k.braceL:
                return this.parseBlock(!0, a);
              case k.semi:
                return this.parseEmptyStatement(a);
              case k._export:
              case k._import:
                if (this.options.ecmaVersion > 10 && r === k._import) {
                  A.lastIndex = this.pos;
                  var n = A.exec(this.input),
                    o = this.pos + n[0].length,
                    h = this.input.charCodeAt(o);
                  if (40 === h || 46 === h) return this.parseExpressionStatement(a, this.parseExpression());
                }
                return this.options.allowImportExportEverywhere || (e || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), r === k._import ? this.parseImport(a) : this.parseExport(a, i);
              default:
                if (this.isAsyncFunction()) return t && this.unexpected(), this.next(), this.parseFunctionStatement(a, !0, !t);
                var p = this.value,
                  c = this.parseExpression();
                return r === k.name && "Identifier" === c.type && this.eat(k.colon) ? this.parseLabeledStatement(a, p, c, t) : this.parseExpressionStatement(a, c);
            }
          }, z.parseBreakContinueStatement = function (t, e) {
            var i = "break" === e;
            this.next(), this.eat(k.semi) || this.insertSemicolon() ? t.label = null : this.type !== k.name ? this.unexpected() : (t.label = this.parseIdent(), this.semicolon());
            for (var s = 0; s < this.labels.length; ++s) {
              var r = this.labels[s];
              if (null == t.label || r.name === t.label.name) {
                if (null != r.kind && (i || "loop" === r.kind)) break;
                if (t.label && i) break;
              }
            }
            return s === this.labels.length && this.raise(t.start, "Unsyntactic " + e), this.finishNode(t, i ? "BreakStatement" : "ContinueStatement");
          }, z.parseDebuggerStatement = function (t) {
            return this.next(), this.semicolon(), this.finishNode(t, "DebuggerStatement");
          }, z.parseDoStatement = function (t) {
            return this.next(), this.labels.push(K), t.body = this.parseStatement("do"), this.labels.pop(), this.expect(k._while), t.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(k.semi) : this.semicolon(), this.finishNode(t, "DoWhileStatement");
          }, z.parseForStatement = function (t) {
            this.next();
            var e = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
            if (this.labels.push(K), this.enterScope(0), this.expect(k.parenL), this.type === k.semi) return e > -1 && this.unexpected(e), this.parseFor(t, null);
            var i = this.isLet();
            if (this.type === k._var || this.type === k._const || i) {
              var s = this.startNode(),
                r = i ? "let" : this.value;
              return this.next(), this.parseVar(s, !0, r), this.finishNode(s, "VariableDeclaration"), (this.type === k._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && 1 === s.declarations.length ? (this.options.ecmaVersion >= 9 && (this.type === k._in ? e > -1 && this.unexpected(e) : t.await = e > -1), this.parseForIn(t, s)) : (e > -1 && this.unexpected(e), this.parseFor(t, s));
            }
            var a = new W(),
              n = this.parseExpression(!0, a);
            return this.type === k._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === k._in ? e > -1 && this.unexpected(e) : t.await = e > -1), this.toAssignable(n, !1, a), this.checkLValPattern(n), this.parseForIn(t, n)) : (this.checkExpressionErrors(a, !0), e > -1 && this.unexpected(e), this.parseFor(t, n));
          }, z.parseFunctionStatement = function (t, e, i) {
            return this.next(), this.parseFunction(t, J | (i ? 0 : Y), !1, e);
          }, z.parseIfStatement = function (t) {
            return this.next(), t.test = this.parseParenExpression(), t.consequent = this.parseStatement("if"), t.alternate = this.eat(k._else) ? this.parseStatement("if") : null, this.finishNode(t, "IfStatement");
          }, z.parseReturnStatement = function (t) {
            return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(k.semi) || this.insertSemicolon() ? t.argument = null : (t.argument = this.parseExpression(), this.semicolon()), this.finishNode(t, "ReturnStatement");
          }, z.parseSwitchStatement = function (t) {
            var e;
            this.next(), t.discriminant = this.parseParenExpression(), t.cases = [], this.expect(k.braceL), this.labels.push(X), this.enterScope(0);
            for (var i = !1; this.type !== k.braceR;) if (this.type === k._case || this.type === k._default) {
              var s = this.type === k._case;
              e && this.finishNode(e, "SwitchCase"), t.cases.push(e = this.startNode()), e.consequent = [], this.next(), s ? e.test = this.parseExpression() : (i && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), i = !0, e.test = null), this.expect(k.colon);
            } else e || this.unexpected(), e.consequent.push(this.parseStatement(null));
            return this.exitScope(), e && this.finishNode(e, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(t, "SwitchStatement");
          }, z.parseThrowStatement = function (t) {
            return this.next(), S.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), t.argument = this.parseExpression(), this.semicolon(), this.finishNode(t, "ThrowStatement");
          };
          var Q = [];
          z.parseTryStatement = function (t) {
            if (this.next(), t.block = this.parseBlock(), t.handler = null, this.type === k._catch) {
              var e = this.startNode();
              if (this.next(), this.eat(k.parenL)) {
                e.param = this.parseBindingAtom();
                var i = "Identifier" === e.param.type;
                this.enterScope(i ? 32 : 0), this.checkLValPattern(e.param, i ? 4 : 2), this.expect(k.parenR);
              } else this.options.ecmaVersion < 10 && this.unexpected(), e.param = null, this.enterScope(0);
              e.body = this.parseBlock(!1), this.exitScope(), t.handler = this.finishNode(e, "CatchClause");
            }
            return t.finalizer = this.eat(k._finally) ? this.parseBlock() : null, t.handler || t.finalizer || this.raise(t.start, "Missing catch or finally clause"), this.finishNode(t, "TryStatement");
          }, z.parseVarStatement = function (t, e) {
            return this.next(), this.parseVar(t, !1, e), this.semicolon(), this.finishNode(t, "VariableDeclaration");
          }, z.parseWhileStatement = function (t) {
            return this.next(), t.test = this.parseParenExpression(), this.labels.push(K), t.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(t, "WhileStatement");
          }, z.parseWithStatement = function (t) {
            return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), t.object = this.parseParenExpression(), t.body = this.parseStatement("with"), this.finishNode(t, "WithStatement");
          }, z.parseEmptyStatement = function (t) {
            return this.next(), this.finishNode(t, "EmptyStatement");
          }, z.parseLabeledStatement = function (t, e, i, s) {
            for (var r = 0, a = this.labels; r < a.length; r += 1) {
              a[r].name === e && this.raise(i.start, "Label '" + e + "' is already declared");
            }
            for (var n = this.type.isLoop ? "loop" : this.type === k._switch ? "switch" : null, o = this.labels.length - 1; o >= 0; o--) {
              var h = this.labels[o];
              if (h.statementStart !== t.start) break;
              h.statementStart = this.start, h.kind = n;
            }
            return this.labels.push({
              name: e,
              kind: n,
              statementStart: this.start
            }), t.body = this.parseStatement(s ? -1 === s.indexOf("label") ? s + "label" : s : "label"), this.labels.pop(), t.label = i, this.finishNode(t, "LabeledStatement");
          }, z.parseExpressionStatement = function (t, e) {
            return t.expression = e, this.semicolon(), this.finishNode(t, "ExpressionStatement");
          }, z.parseBlock = function (t, e, i) {
            for (void 0 === t && (t = !0), void 0 === e && (e = this.startNode()), e.body = [], this.expect(k.braceL), t && this.enterScope(0); this.type !== k.braceR;) {
              var s = this.parseStatement(null);
              e.body.push(s);
            }
            return i && (this.strict = !1), this.next(), t && this.exitScope(), this.finishNode(e, "BlockStatement");
          }, z.parseFor = function (t, e) {
            return t.init = e, this.expect(k.semi), t.test = this.type === k.semi ? null : this.parseExpression(), this.expect(k.semi), t.update = this.type === k.parenR ? null : this.parseExpression(), this.expect(k.parenR), t.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(t, "ForStatement");
          }, z.parseForIn = function (t, e) {
            var i = this.type === k._in;
            return this.next(), "VariableDeclaration" === e.type && null != e.declarations[0].init && (!i || this.options.ecmaVersion < 8 || this.strict || "var" !== e.kind || "Identifier" !== e.declarations[0].id.type) && this.raise(e.start, (i ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"), t.left = e, t.right = i ? this.parseExpression() : this.parseMaybeAssign(), this.expect(k.parenR), t.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(t, i ? "ForInStatement" : "ForOfStatement");
          }, z.parseVar = function (t, e, i) {
            for (t.declarations = [], t.kind = i;;) {
              var s = this.startNode();
              if (this.parseVarId(s, i), this.eat(k.eq) ? s.init = this.parseMaybeAssign(e) : "const" !== i || this.type === k._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? "Identifier" === s.id.type || e && (this.type === k._in || this.isContextual("of")) ? s.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), t.declarations.push(this.finishNode(s, "VariableDeclarator")), !this.eat(k.comma)) break;
            }
            return t;
          }, z.parseVarId = function (t, e) {
            t.id = this.parseBindingAtom(), this.checkLValPattern(t.id, "var" === e ? 1 : 2, !1);
          };
          var J = 1,
            Y = 2;
          z.parseFunction = function (t, e, i, s) {
            this.initFunction(t), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !s) && (this.type === k.star && e & Y && this.unexpected(), t.generator = this.eat(k.star)), this.options.ecmaVersion >= 8 && (t.async = !!s), e & J && (t.id = 4 & e && this.type !== k.name ? null : this.parseIdent(), !t.id || e & Y || this.checkLValSimple(t.id, this.strict || t.generator || t.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
            var r = this.yieldPos,
              a = this.awaitPos,
              n = this.awaitIdentPos;
            return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(U(t.async, t.generator)), e & J || (t.id = this.type === k.name ? this.parseIdent() : null), this.parseFunctionParams(t), this.parseFunctionBody(t, i, !1), this.yieldPos = r, this.awaitPos = a, this.awaitIdentPos = n, this.finishNode(t, e & J ? "FunctionDeclaration" : "FunctionExpression");
          }, z.parseFunctionParams = function (t) {
            this.expect(k.parenL), t.params = this.parseBindingList(k.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
          }, z.parseClass = function (t, e) {
            this.next();
            var i = this.strict;
            this.strict = !0, this.parseClassId(t, e), this.parseClassSuper(t);
            var s = this.startNode(),
              r = !1;
            for (s.body = [], this.expect(k.braceL); this.type !== k.braceR;) {
              var a = this.parseClassElement(null !== t.superClass);
              a && (s.body.push(a), "MethodDefinition" === a.type && "constructor" === a.kind && (r && this.raise(a.start, "Duplicate constructor in the same class"), r = !0));
            }
            return this.strict = i, this.next(), t.body = this.finishNode(s, "ClassBody"), this.finishNode(t, e ? "ClassDeclaration" : "ClassExpression");
          }, z.parseClassElement = function (t) {
            var e = this;
            if (this.eat(k.semi)) return null;
            var i = this.startNode(),
              s = function (t, s) {
                void 0 === s && (s = !1);
                var r = e.start,
                  a = e.startLoc;
                return !!e.eatContextual(t) && (!(e.type === k.parenL || s && e.canInsertSemicolon()) || (i.key && e.unexpected(), i.computed = !1, i.key = e.startNodeAt(r, a), i.key.name = t, e.finishNode(i.key, "Identifier"), !1));
              };
            i.kind = "method", i.static = s("static");
            var r = this.eat(k.star),
              a = !1;
            r || (this.options.ecmaVersion >= 8 && s("async", !0) ? (a = !0, r = this.options.ecmaVersion >= 9 && this.eat(k.star)) : s("get") ? i.kind = "get" : s("set") && (i.kind = "set")), i.key || this.parsePropertyName(i);
            var n = i.key,
              o = !1;
            return i.computed || i.static || !("Identifier" === n.type && "constructor" === n.name || "Literal" === n.type && "constructor" === n.value) ? i.static && "Identifier" === n.type && "prototype" === n.name && this.raise(n.start, "Classes may not have a static property named prototype") : ("method" !== i.kind && this.raise(n.start, "Constructor can't have get/set modifier"), r && this.raise(n.start, "Constructor can't be a generator"), a && this.raise(n.start, "Constructor can't be an async method"), i.kind = "constructor", o = t), this.parseClassMethod(i, r, a, o), "get" === i.kind && 0 !== i.value.params.length && this.raiseRecoverable(i.value.start, "getter should have no params"), "set" === i.kind && 1 !== i.value.params.length && this.raiseRecoverable(i.value.start, "setter should have exactly one param"), "set" === i.kind && "RestElement" === i.value.params[0].type && this.raiseRecoverable(i.value.params[0].start, "Setter cannot use rest params"), i;
          }, z.parseClassMethod = function (t, e, i, s) {
            return t.value = this.parseMethod(e, i, s), this.finishNode(t, "MethodDefinition");
          }, z.parseClassId = function (t, e) {
            this.type === k.name ? (t.id = this.parseIdent(), e && this.checkLValSimple(t.id, 2, !1)) : (!0 === e && this.unexpected(), t.id = null);
          }, z.parseClassSuper = function (t) {
            t.superClass = this.eat(k._extends) ? this.parseExprSubscripts() : null;
          }, z.parseExport = function (t, e) {
            if (this.next(), this.eat(k.star)) return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (t.exported = this.parseIdent(!0), this.checkExport(e, t.exported.name, this.lastTokStart)) : t.exported = null), this.expectContextual("from"), this.type !== k.string && this.unexpected(), t.source = this.parseExprAtom(), this.semicolon(), this.finishNode(t, "ExportAllDeclaration");
            if (this.eat(k._default)) {
              var i;
              if (this.checkExport(e, "default", this.lastTokStart), this.type === k._function || (i = this.isAsyncFunction())) {
                var s = this.startNode();
                this.next(), i && this.next(), t.declaration = this.parseFunction(s, 4 | J, !1, i);
              } else if (this.type === k._class) {
                var r = this.startNode();
                t.declaration = this.parseClass(r, "nullableID");
              } else t.declaration = this.parseMaybeAssign(), this.semicolon();
              return this.finishNode(t, "ExportDefaultDeclaration");
            }
            if (this.shouldParseExportStatement()) t.declaration = this.parseStatement(null), "VariableDeclaration" === t.declaration.type ? this.checkVariableExport(e, t.declaration.declarations) : this.checkExport(e, t.declaration.id.name, t.declaration.id.start), t.specifiers = [], t.source = null;else {
              if (t.declaration = null, t.specifiers = this.parseExportSpecifiers(e), this.eatContextual("from")) this.type !== k.string && this.unexpected(), t.source = this.parseExprAtom();else {
                for (var a = 0, n = t.specifiers; a < n.length; a += 1) {
                  var o = n[a];
                  this.checkUnreserved(o.local), this.checkLocalExport(o.local);
                }
                t.source = null;
              }
              this.semicolon();
            }
            return this.finishNode(t, "ExportNamedDeclaration");
          }, z.checkExport = function (t, e, i) {
            t && (N(t, e) && this.raiseRecoverable(i, "Duplicate export '" + e + "'"), t[e] = !0);
          }, z.checkPatternExport = function (t, e) {
            var i = e.type;
            if ("Identifier" === i) this.checkExport(t, e.name, e.start);else if ("ObjectPattern" === i) for (var s = 0, r = e.properties; s < r.length; s += 1) {
              var a = r[s];
              this.checkPatternExport(t, a);
            } else if ("ArrayPattern" === i) for (var n = 0, o = e.elements; n < o.length; n += 1) {
              var h = o[n];
              h && this.checkPatternExport(t, h);
            } else "Property" === i ? this.checkPatternExport(t, e.value) : "AssignmentPattern" === i ? this.checkPatternExport(t, e.left) : "RestElement" === i ? this.checkPatternExport(t, e.argument) : "ParenthesizedExpression" === i && this.checkPatternExport(t, e.expression);
          }, z.checkVariableExport = function (t, e) {
            if (t) for (var i = 0, s = e; i < s.length; i += 1) {
              var r = s[i];
              this.checkPatternExport(t, r.id);
            }
          }, z.shouldParseExportStatement = function () {
            return "var" === this.type.keyword || "const" === this.type.keyword || "class" === this.type.keyword || "function" === this.type.keyword || this.isLet() || this.isAsyncFunction();
          }, z.parseExportSpecifiers = function (t) {
            var e = [],
              i = !0;
            for (this.expect(k.braceL); !this.eat(k.braceR);) {
              if (i) i = !1;else if (this.expect(k.comma), this.afterTrailingComma(k.braceR)) break;
              var s = this.startNode();
              s.local = this.parseIdent(!0), s.exported = this.eatContextual("as") ? this.parseIdent(!0) : s.local, this.checkExport(t, s.exported.name, s.exported.start), e.push(this.finishNode(s, "ExportSpecifier"));
            }
            return e;
          }, z.parseImport = function (t) {
            return this.next(), this.type === k.string ? (t.specifiers = Q, t.source = this.parseExprAtom()) : (t.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), t.source = this.type === k.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(t, "ImportDeclaration");
          }, z.parseImportSpecifiers = function () {
            var t = [],
              e = !0;
            if (this.type === k.name) {
              var i = this.startNode();
              if (i.local = this.parseIdent(), this.checkLValSimple(i.local, 2), t.push(this.finishNode(i, "ImportDefaultSpecifier")), !this.eat(k.comma)) return t;
            }
            if (this.type === k.star) {
              var s = this.startNode();
              return this.next(), this.expectContextual("as"), s.local = this.parseIdent(), this.checkLValSimple(s.local, 2), t.push(this.finishNode(s, "ImportNamespaceSpecifier")), t;
            }
            for (this.expect(k.braceL); !this.eat(k.braceR);) {
              if (e) e = !1;else if (this.expect(k.comma), this.afterTrailingComma(k.braceR)) break;
              var r = this.startNode();
              r.imported = this.parseIdent(!0), this.eatContextual("as") ? r.local = this.parseIdent() : (this.checkUnreserved(r.imported), r.local = r.imported), this.checkLValSimple(r.local, 2), t.push(this.finishNode(r, "ImportSpecifier"));
            }
            return t;
          }, z.adaptDirectivePrologue = function (t) {
            for (var e = 0; e < t.length && this.isDirectiveCandidate(t[e]); ++e) t[e].directive = t[e].expression.raw.slice(1, -1);
          }, z.isDirectiveCandidate = function (t) {
            return "ExpressionStatement" === t.type && "Literal" === t.expression.type && "string" == typeof t.expression.value && ('"' === this.input[t.start] || "'" === this.input[t.start]);
          };
          var Z = F.prototype;
          Z.toAssignable = function (t, e, i) {
            if (this.options.ecmaVersion >= 6 && t) switch (t.type) {
              case "Identifier":
                this.inAsync && "await" === t.name && this.raise(t.start, "Cannot use 'await' as identifier inside an async function");
                break;
              case "ObjectPattern":
              case "ArrayPattern":
              case "AssignmentPattern":
              case "RestElement":
                break;
              case "ObjectExpression":
                t.type = "ObjectPattern", i && this.checkPatternErrors(i, !0);
                for (var s = 0, r = t.properties; s < r.length; s += 1) {
                  var a = r[s];
                  this.toAssignable(a, e), "RestElement" !== a.type || "ArrayPattern" !== a.argument.type && "ObjectPattern" !== a.argument.type || this.raise(a.argument.start, "Unexpected token");
                }
                break;
              case "Property":
                "init" !== t.kind && this.raise(t.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(t.value, e);
                break;
              case "ArrayExpression":
                t.type = "ArrayPattern", i && this.checkPatternErrors(i, !0), this.toAssignableList(t.elements, e);
                break;
              case "SpreadElement":
                t.type = "RestElement", this.toAssignable(t.argument, e), "AssignmentPattern" === t.argument.type && this.raise(t.argument.start, "Rest elements cannot have a default value");
                break;
              case "AssignmentExpression":
                "=" !== t.operator && this.raise(t.left.end, "Only '=' operator can be used for specifying default value."), t.type = "AssignmentPattern", delete t.operator, this.toAssignable(t.left, e);
                break;
              case "ParenthesizedExpression":
                this.toAssignable(t.expression, e, i);
                break;
              case "ChainExpression":
                this.raiseRecoverable(t.start, "Optional chaining cannot appear in left-hand side");
                break;
              case "MemberExpression":
                if (!e) break;
              default:
                this.raise(t.start, "Assigning to rvalue");
            } else i && this.checkPatternErrors(i, !0);
            return t;
          }, Z.toAssignableList = function (t, e) {
            for (var i = t.length, s = 0; s < i; s++) {
              var r = t[s];
              r && this.toAssignable(r, e);
            }
            if (i) {
              var a = t[i - 1];
              6 === this.options.ecmaVersion && e && a && "RestElement" === a.type && "Identifier" !== a.argument.type && this.unexpected(a.argument.start);
            }
            return t;
          }, Z.parseSpread = function (t) {
            var e = this.startNode();
            return this.next(), e.argument = this.parseMaybeAssign(!1, t), this.finishNode(e, "SpreadElement");
          }, Z.parseRestBinding = function () {
            var t = this.startNode();
            return this.next(), 6 === this.options.ecmaVersion && this.type !== k.name && this.unexpected(), t.argument = this.parseBindingAtom(), this.finishNode(t, "RestElement");
          }, Z.parseBindingAtom = function () {
            if (this.options.ecmaVersion >= 6) switch (this.type) {
              case k.bracketL:
                var t = this.startNode();
                return this.next(), t.elements = this.parseBindingList(k.bracketR, !0, !0), this.finishNode(t, "ArrayPattern");
              case k.braceL:
                return this.parseObj(!0);
            }
            return this.parseIdent();
          }, Z.parseBindingList = function (t, e, i) {
            for (var s = [], r = !0; !this.eat(t);) if (r ? r = !1 : this.expect(k.comma), e && this.type === k.comma) s.push(null);else {
              if (i && this.afterTrailingComma(t)) break;
              if (this.type === k.ellipsis) {
                var a = this.parseRestBinding();
                this.parseBindingListItem(a), s.push(a), this.type === k.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(t);
                break;
              }
              var n = this.parseMaybeDefault(this.start, this.startLoc);
              this.parseBindingListItem(n), s.push(n);
            }
            return s;
          }, Z.parseBindingListItem = function (t) {
            return t;
          }, Z.parseMaybeDefault = function (t, e, i) {
            if (i = i || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(k.eq)) return i;
            var s = this.startNodeAt(t, e);
            return s.left = i, s.right = this.parseMaybeAssign(), this.finishNode(s, "AssignmentPattern");
          }, Z.checkLValSimple = function (t, e, i) {
            void 0 === e && (e = 0);
            var s = 0 !== e;
            switch (t.type) {
              case "Identifier":
                this.strict && this.reservedWordsStrictBind.test(t.name) && this.raiseRecoverable(t.start, (s ? "Binding " : "Assigning to ") + t.name + " in strict mode"), s && (2 === e && "let" === t.name && this.raiseRecoverable(t.start, "let is disallowed as a lexically bound name"), i && (N(i, t.name) && this.raiseRecoverable(t.start, "Argument name clash"), i[t.name] = !0), 5 !== e && this.declareName(t.name, e, t.start));
                break;
              case "ChainExpression":
                this.raiseRecoverable(t.start, "Optional chaining cannot appear in left-hand side");
                break;
              case "MemberExpression":
                s && this.raiseRecoverable(t.start, "Binding member expression");
                break;
              case "ParenthesizedExpression":
                return s && this.raiseRecoverable(t.start, "Binding parenthesized expression"), this.checkLValSimple(t.expression, e, i);
              default:
                this.raise(t.start, (s ? "Binding" : "Assigning to") + " rvalue");
            }
          }, Z.checkLValPattern = function (t, e, i) {
            switch (void 0 === e && (e = 0), t.type) {
              case "ObjectPattern":
                for (var s = 0, r = t.properties; s < r.length; s += 1) {
                  var a = r[s];
                  this.checkLValInnerPattern(a, e, i);
                }
                break;
              case "ArrayPattern":
                for (var n = 0, o = t.elements; n < o.length; n += 1) {
                  var h = o[n];
                  h && this.checkLValInnerPattern(h, e, i);
                }
                break;
              default:
                this.checkLValSimple(t, e, i);
            }
          }, Z.checkLValInnerPattern = function (t, e, i) {
            switch (void 0 === e && (e = 0), t.type) {
              case "Property":
                this.checkLValInnerPattern(t.value, e, i);
                break;
              case "AssignmentPattern":
                this.checkLValPattern(t.left, e, i);
                break;
              case "RestElement":
                this.checkLValPattern(t.argument, e, i);
                break;
              default:
                this.checkLValPattern(t, e, i);
            }
          };
          var $ = F.prototype;
          $.checkPropClash = function (t, e, i) {
            if (!(this.options.ecmaVersion >= 9 && "SpreadElement" === t.type || this.options.ecmaVersion >= 6 && (t.computed || t.method || t.shorthand))) {
              var s,
                r = t.key;
              switch (r.type) {
                case "Identifier":
                  s = r.name;
                  break;
                case "Literal":
                  s = String(r.value);
                  break;
                default:
                  return;
              }
              var a = t.kind;
              if (this.options.ecmaVersion >= 6) "__proto__" === s && "init" === a && (e.proto && (i ? i.doubleProto < 0 && (i.doubleProto = r.start) : this.raiseRecoverable(r.start, "Redefinition of __proto__ property")), e.proto = !0);else {
                var n = e[s = "$" + s];
                if (n) ("init" === a ? this.strict && n.init || n.get || n.set : n.init || n[a]) && this.raiseRecoverable(r.start, "Redefinition of property");else n = e[s] = {
                  init: !1,
                  get: !1,
                  set: !1
                };
                n[a] = !0;
              }
            }
          }, $.parseExpression = function (t, e) {
            var i = this.start,
              s = this.startLoc,
              r = this.parseMaybeAssign(t, e);
            if (this.type === k.comma) {
              var a = this.startNodeAt(i, s);
              for (a.expressions = [r]; this.eat(k.comma);) a.expressions.push(this.parseMaybeAssign(t, e));
              return this.finishNode(a, "SequenceExpression");
            }
            return r;
          }, $.parseMaybeAssign = function (t, e, i) {
            if (this.isContextual("yield")) {
              if (this.inGenerator) return this.parseYield(t);
              this.exprAllowed = !1;
            }
            var s = !1,
              r = -1,
              a = -1;
            e ? (r = e.parenthesizedAssign, a = e.trailingComma, e.parenthesizedAssign = e.trailingComma = -1) : (e = new W(), s = !0);
            var n = this.start,
              o = this.startLoc;
            this.type !== k.parenL && this.type !== k.name || (this.potentialArrowAt = this.start);
            var h = this.parseMaybeConditional(t, e);
            if (i && (h = i.call(this, h, n, o)), this.type.isAssign) {
              var p = this.startNodeAt(n, o);
              return p.operator = this.value, this.type === k.eq && (h = this.toAssignable(h, !1, e)), s || (e.parenthesizedAssign = e.trailingComma = e.doubleProto = -1), e.shorthandAssign >= h.start && (e.shorthandAssign = -1), this.type === k.eq ? this.checkLValPattern(h) : this.checkLValSimple(h), p.left = h, this.next(), p.right = this.parseMaybeAssign(t), this.finishNode(p, "AssignmentExpression");
            }
            return s && this.checkExpressionErrors(e, !0), r > -1 && (e.parenthesizedAssign = r), a > -1 && (e.trailingComma = a), h;
          }, $.parseMaybeConditional = function (t, e) {
            var i = this.start,
              s = this.startLoc,
              r = this.parseExprOps(t, e);
            if (this.checkExpressionErrors(e)) return r;
            if (this.eat(k.question)) {
              var a = this.startNodeAt(i, s);
              return a.test = r, a.consequent = this.parseMaybeAssign(), this.expect(k.colon), a.alternate = this.parseMaybeAssign(t), this.finishNode(a, "ConditionalExpression");
            }
            return r;
          }, $.parseExprOps = function (t, e) {
            var i = this.start,
              s = this.startLoc,
              r = this.parseMaybeUnary(e, !1);
            return this.checkExpressionErrors(e) || r.start === i && "ArrowFunctionExpression" === r.type ? r : this.parseExprOp(r, i, s, -1, t);
          }, $.parseExprOp = function (t, e, i, s, r) {
            var a = this.type.binop;
            if (null != a && (!r || this.type !== k._in) && a > s) {
              var n = this.type === k.logicalOR || this.type === k.logicalAND,
                o = this.type === k.coalesce;
              o && (a = k.logicalAND.binop);
              var h = this.value;
              this.next();
              var p = this.start,
                c = this.startLoc,
                l = this.parseExprOp(this.parseMaybeUnary(null, !1), p, c, a, r),
                u = this.buildBinary(e, i, t, l, h, n || o);
              return (n && this.type === k.coalesce || o && (this.type === k.logicalOR || this.type === k.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(u, e, i, s, r);
            }
            return t;
          }, $.buildBinary = function (t, e, i, s, r, a) {
            var n = this.startNodeAt(t, e);
            return n.left = i, n.operator = r, n.right = s, this.finishNode(n, a ? "LogicalExpression" : "BinaryExpression");
          }, $.parseMaybeUnary = function (t, e) {
            var i,
              s = this.start,
              r = this.startLoc;
            if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction)) i = this.parseAwait(), e = !0;else if (this.type.prefix) {
              var a = this.startNode(),
                n = this.type === k.incDec;
              a.operator = this.value, a.prefix = !0, this.next(), a.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(t, !0), n ? this.checkLValSimple(a.argument) : this.strict && "delete" === a.operator && "Identifier" === a.argument.type ? this.raiseRecoverable(a.start, "Deleting local variable in strict mode") : e = !0, i = this.finishNode(a, n ? "UpdateExpression" : "UnaryExpression");
            } else {
              if (i = this.parseExprSubscripts(t), this.checkExpressionErrors(t)) return i;
              for (; this.type.postfix && !this.canInsertSemicolon();) {
                var o = this.startNodeAt(s, r);
                o.operator = this.value, o.prefix = !1, o.argument = i, this.checkLValSimple(i), this.next(), i = this.finishNode(o, "UpdateExpression");
              }
            }
            return !e && this.eat(k.starstar) ? this.buildBinary(s, r, i, this.parseMaybeUnary(null, !1), "**", !1) : i;
          }, $.parseExprSubscripts = function (t) {
            var e = this.start,
              i = this.startLoc,
              s = this.parseExprAtom(t);
            if ("ArrowFunctionExpression" === s.type && ")" !== this.input.slice(this.lastTokStart, this.lastTokEnd)) return s;
            var r = this.parseSubscripts(s, e, i);
            return t && "MemberExpression" === r.type && (t.parenthesizedAssign >= r.start && (t.parenthesizedAssign = -1), t.parenthesizedBind >= r.start && (t.parenthesizedBind = -1)), r;
          }, $.parseSubscripts = function (t, e, i, s) {
            for (var r = this.options.ecmaVersion >= 8 && "Identifier" === t.type && "async" === t.name && this.lastTokEnd === t.end && !this.canInsertSemicolon() && t.end - t.start == 5 && this.potentialArrowAt === t.start, a = !1;;) {
              var n = this.parseSubscript(t, e, i, s, r, a);
              if (n.optional && (a = !0), n === t || "ArrowFunctionExpression" === n.type) {
                if (a) {
                  var o = this.startNodeAt(e, i);
                  o.expression = n, n = this.finishNode(o, "ChainExpression");
                }
                return n;
              }
              t = n;
            }
          }, $.parseSubscript = function (t, e, i, s, r, a) {
            var n = this.options.ecmaVersion >= 11,
              o = n && this.eat(k.questionDot);
            s && o && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
            var h = this.eat(k.bracketL);
            if (h || o && this.type !== k.parenL && this.type !== k.backQuote || this.eat(k.dot)) {
              var p = this.startNodeAt(e, i);
              p.object = t, p.property = h ? this.parseExpression() : this.parseIdent("never" !== this.options.allowReserved), p.computed = !!h, h && this.expect(k.bracketR), n && (p.optional = o), t = this.finishNode(p, "MemberExpression");
            } else if (!s && this.eat(k.parenL)) {
              var c = new W(),
                l = this.yieldPos,
                u = this.awaitPos,
                d = this.awaitIdentPos;
              this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
              var f = this.parseExprList(k.parenR, this.options.ecmaVersion >= 8, !1, c);
              if (r && !o && !this.canInsertSemicolon() && this.eat(k.arrow)) return this.checkPatternErrors(c, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = l, this.awaitPos = u, this.awaitIdentPos = d, this.parseArrowExpression(this.startNodeAt(e, i), f, !0);
              this.checkExpressionErrors(c, !0), this.yieldPos = l || this.yieldPos, this.awaitPos = u || this.awaitPos, this.awaitIdentPos = d || this.awaitIdentPos;
              var m = this.startNodeAt(e, i);
              m.callee = t, m.arguments = f, n && (m.optional = o), t = this.finishNode(m, "CallExpression");
            } else if (this.type === k.backQuote) {
              (o || a) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
              var g = this.startNodeAt(e, i);
              g.tag = t, g.quasi = this.parseTemplate({
                isTagged: !0
              }), t = this.finishNode(g, "TaggedTemplateExpression");
            }
            return t;
          }, $.parseExprAtom = function (t) {
            this.type === k.slash && this.readRegexp();
            var e,
              i = this.potentialArrowAt === this.start;
            switch (this.type) {
              case k._super:
                return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), e = this.startNode(), this.next(), this.type !== k.parenL || this.allowDirectSuper || this.raise(e.start, "super() call outside constructor of a subclass"), this.type !== k.dot && this.type !== k.bracketL && this.type !== k.parenL && this.unexpected(), this.finishNode(e, "Super");
              case k._this:
                return e = this.startNode(), this.next(), this.finishNode(e, "ThisExpression");
              case k.name:
                var s = this.start,
                  r = this.startLoc,
                  a = this.containsEsc,
                  n = this.parseIdent(!1);
                if (this.options.ecmaVersion >= 8 && !a && "async" === n.name && !this.canInsertSemicolon() && this.eat(k._function)) return this.parseFunction(this.startNodeAt(s, r), 0, !1, !0);
                if (i && !this.canInsertSemicolon()) {
                  if (this.eat(k.arrow)) return this.parseArrowExpression(this.startNodeAt(s, r), [n], !1);
                  if (this.options.ecmaVersion >= 8 && "async" === n.name && this.type === k.name && !a) return n = this.parseIdent(!1), !this.canInsertSemicolon() && this.eat(k.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(s, r), [n], !0);
                }
                return n;
              case k.regexp:
                var o = this.value;
                return (e = this.parseLiteral(o.value)).regex = {
                  pattern: o.pattern,
                  flags: o.flags
                }, e;
              case k.num:
              case k.string:
                return this.parseLiteral(this.value);
              case k._null:
              case k._true:
              case k._false:
                return (e = this.startNode()).value = this.type === k._null ? null : this.type === k._true, e.raw = this.type.keyword, this.next(), this.finishNode(e, "Literal");
              case k.parenL:
                var h = this.start,
                  p = this.parseParenAndDistinguishExpression(i);
                return t && (t.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(p) && (t.parenthesizedAssign = h), t.parenthesizedBind < 0 && (t.parenthesizedBind = h)), p;
              case k.bracketL:
                return e = this.startNode(), this.next(), e.elements = this.parseExprList(k.bracketR, !0, !0, t), this.finishNode(e, "ArrayExpression");
              case k.braceL:
                return this.parseObj(!1, t);
              case k._function:
                return e = this.startNode(), this.next(), this.parseFunction(e, 0);
              case k._class:
                return this.parseClass(this.startNode(), !1);
              case k._new:
                return this.parseNew();
              case k.backQuote:
                return this.parseTemplate();
              case k._import:
                return this.options.ecmaVersion >= 11 ? this.parseExprImport() : this.unexpected();
              default:
                this.unexpected();
            }
          }, $.parseExprImport = function () {
            var t = this.startNode();
            this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import");
            var e = this.parseIdent(!0);
            switch (this.type) {
              case k.parenL:
                return this.parseDynamicImport(t);
              case k.dot:
                return t.meta = e, this.parseImportMeta(t);
              default:
                this.unexpected();
            }
          }, $.parseDynamicImport = function (t) {
            if (this.next(), t.source = this.parseMaybeAssign(), !this.eat(k.parenR)) {
              var e = this.start;
              this.eat(k.comma) && this.eat(k.parenR) ? this.raiseRecoverable(e, "Trailing comma is not allowed in import()") : this.unexpected(e);
            }
            return this.finishNode(t, "ImportExpression");
          }, $.parseImportMeta = function (t) {
            this.next();
            var e = this.containsEsc;
            return t.property = this.parseIdent(!0), "meta" !== t.property.name && this.raiseRecoverable(t.property.start, "The only valid meta property for import is 'import.meta'"), e && this.raiseRecoverable(t.start, "'import.meta' must not contain escaped characters"), "module" !== this.options.sourceType && this.raiseRecoverable(t.start, "Cannot use 'import.meta' outside a module"), this.finishNode(t, "MetaProperty");
          }, $.parseLiteral = function (t) {
            var e = this.startNode();
            return e.value = t, e.raw = this.input.slice(this.start, this.end), 110 === e.raw.charCodeAt(e.raw.length - 1) && (e.bigint = e.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(e, "Literal");
          }, $.parseParenExpression = function () {
            this.expect(k.parenL);
            var t = this.parseExpression();
            return this.expect(k.parenR), t;
          }, $.parseParenAndDistinguishExpression = function (t) {
            var e,
              i = this.start,
              s = this.startLoc,
              r = this.options.ecmaVersion >= 8;
            if (this.options.ecmaVersion >= 6) {
              this.next();
              var a,
                n = this.start,
                o = this.startLoc,
                h = [],
                p = !0,
                c = !1,
                l = new W(),
                u = this.yieldPos,
                d = this.awaitPos;
              for (this.yieldPos = 0, this.awaitPos = 0; this.type !== k.parenR;) {
                if (p ? p = !1 : this.expect(k.comma), r && this.afterTrailingComma(k.parenR, !0)) {
                  c = !0;
                  break;
                }
                if (this.type === k.ellipsis) {
                  a = this.start, h.push(this.parseParenItem(this.parseRestBinding())), this.type === k.comma && this.raise(this.start, "Comma is not permitted after the rest element");
                  break;
                }
                h.push(this.parseMaybeAssign(!1, l, this.parseParenItem));
              }
              var f = this.start,
                m = this.startLoc;
              if (this.expect(k.parenR), t && !this.canInsertSemicolon() && this.eat(k.arrow)) return this.checkPatternErrors(l, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = u, this.awaitPos = d, this.parseParenArrowList(i, s, h);
              h.length && !c || this.unexpected(this.lastTokStart), a && this.unexpected(a), this.checkExpressionErrors(l, !0), this.yieldPos = u || this.yieldPos, this.awaitPos = d || this.awaitPos, h.length > 1 ? ((e = this.startNodeAt(n, o)).expressions = h, this.finishNodeAt(e, "SequenceExpression", f, m)) : e = h[0];
            } else e = this.parseParenExpression();
            if (this.options.preserveParens) {
              var g = this.startNodeAt(i, s);
              return g.expression = e, this.finishNode(g, "ParenthesizedExpression");
            }
            return e;
          }, $.parseParenItem = function (t) {
            return t;
          }, $.parseParenArrowList = function (t, e, i) {
            return this.parseArrowExpression(this.startNodeAt(t, e), i);
          };
          var tt = [];
          $.parseNew = function () {
            this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
            var t = this.startNode(),
              e = this.parseIdent(!0);
            if (this.options.ecmaVersion >= 6 && this.eat(k.dot)) {
              t.meta = e;
              var i = this.containsEsc;
              return t.property = this.parseIdent(!0), "target" !== t.property.name && this.raiseRecoverable(t.property.start, "The only valid meta property for new is 'new.target'"), i && this.raiseRecoverable(t.start, "'new.target' must not contain escaped characters"), this.inNonArrowFunction || this.raiseRecoverable(t.start, "'new.target' can only be used in functions"), this.finishNode(t, "MetaProperty");
            }
            var s = this.start,
              r = this.startLoc,
              a = this.type === k._import;
            return t.callee = this.parseSubscripts(this.parseExprAtom(), s, r, !0), a && "ImportExpression" === t.callee.type && this.raise(s, "Cannot use new with import()"), this.eat(k.parenL) ? t.arguments = this.parseExprList(k.parenR, this.options.ecmaVersion >= 8, !1) : t.arguments = tt, this.finishNode(t, "NewExpression");
          }, $.parseTemplateElement = function (t) {
            var e = t.isTagged,
              i = this.startNode();
            return this.type === k.invalidTemplate ? (e || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), i.value = {
              raw: this.value,
              cooked: null
            }) : i.value = {
              raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
              cooked: this.value
            }, this.next(), i.tail = this.type === k.backQuote, this.finishNode(i, "TemplateElement");
          }, $.parseTemplate = function (t) {
            void 0 === t && (t = {});
            var e = t.isTagged;
            void 0 === e && (e = !1);
            var i = this.startNode();
            this.next(), i.expressions = [];
            var s = this.parseTemplateElement({
              isTagged: e
            });
            for (i.quasis = [s]; !s.tail;) this.type === k.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(k.dollarBraceL), i.expressions.push(this.parseExpression()), this.expect(k.braceR), i.quasis.push(s = this.parseTemplateElement({
              isTagged: e
            }));
            return this.next(), this.finishNode(i, "TemplateLiteral");
          }, $.isAsyncProp = function (t) {
            return !t.computed && "Identifier" === t.key.type && "async" === t.key.name && (this.type === k.name || this.type === k.num || this.type === k.string || this.type === k.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === k.star) && !S.test(this.input.slice(this.lastTokEnd, this.start));
          }, $.parseObj = function (t, e) {
            var i = this.startNode(),
              s = !0,
              r = {};
            for (i.properties = [], this.next(); !this.eat(k.braceR);) {
              if (s) s = !1;else if (this.expect(k.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(k.braceR)) break;
              var a = this.parseProperty(t, e);
              t || this.checkPropClash(a, r, e), i.properties.push(a);
            }
            return this.finishNode(i, t ? "ObjectPattern" : "ObjectExpression");
          }, $.parseProperty = function (t, e) {
            var i,
              s,
              r,
              a,
              n = this.startNode();
            if (this.options.ecmaVersion >= 9 && this.eat(k.ellipsis)) return t ? (n.argument = this.parseIdent(!1), this.type === k.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(n, "RestElement")) : (this.type === k.parenL && e && (e.parenthesizedAssign < 0 && (e.parenthesizedAssign = this.start), e.parenthesizedBind < 0 && (e.parenthesizedBind = this.start)), n.argument = this.parseMaybeAssign(!1, e), this.type === k.comma && e && e.trailingComma < 0 && (e.trailingComma = this.start), this.finishNode(n, "SpreadElement"));
            this.options.ecmaVersion >= 6 && (n.method = !1, n.shorthand = !1, (t || e) && (r = this.start, a = this.startLoc), t || (i = this.eat(k.star)));
            var o = this.containsEsc;
            return this.parsePropertyName(n), !t && !o && this.options.ecmaVersion >= 8 && !i && this.isAsyncProp(n) ? (s = !0, i = this.options.ecmaVersion >= 9 && this.eat(k.star), this.parsePropertyName(n, e)) : s = !1, this.parsePropertyValue(n, t, i, s, r, a, e, o), this.finishNode(n, "Property");
          }, $.parsePropertyValue = function (t, e, i, s, r, a, n, o) {
            if ((i || s) && this.type === k.colon && this.unexpected(), this.eat(k.colon)) t.value = e ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, n), t.kind = "init";else if (this.options.ecmaVersion >= 6 && this.type === k.parenL) e && this.unexpected(), t.kind = "init", t.method = !0, t.value = this.parseMethod(i, s);else if (e || o || !(this.options.ecmaVersion >= 5) || t.computed || "Identifier" !== t.key.type || "get" !== t.key.name && "set" !== t.key.name || this.type === k.comma || this.type === k.braceR || this.type === k.eq) this.options.ecmaVersion >= 6 && !t.computed && "Identifier" === t.key.type ? ((i || s) && this.unexpected(), this.checkUnreserved(t.key), "await" !== t.key.name || this.awaitIdentPos || (this.awaitIdentPos = r), t.kind = "init", e ? t.value = this.parseMaybeDefault(r, a, this.copyNode(t.key)) : this.type === k.eq && n ? (n.shorthandAssign < 0 && (n.shorthandAssign = this.start), t.value = this.parseMaybeDefault(r, a, this.copyNode(t.key))) : t.value = this.copyNode(t.key), t.shorthand = !0) : this.unexpected();else {
              (i || s) && this.unexpected(), t.kind = t.key.name, this.parsePropertyName(t), t.value = this.parseMethod(!1);
              var h = "get" === t.kind ? 0 : 1;
              if (t.value.params.length !== h) {
                var p = t.value.start;
                "get" === t.kind ? this.raiseRecoverable(p, "getter should have no params") : this.raiseRecoverable(p, "setter should have exactly one param");
              } else "set" === t.kind && "RestElement" === t.value.params[0].type && this.raiseRecoverable(t.value.params[0].start, "Setter cannot use rest params");
            }
          }, $.parsePropertyName = function (t) {
            if (this.options.ecmaVersion >= 6) {
              if (this.eat(k.bracketL)) return t.computed = !0, t.key = this.parseMaybeAssign(), this.expect(k.bracketR), t.key;
              t.computed = !1;
            }
            return t.key = this.type === k.num || this.type === k.string ? this.parseExprAtom() : this.parseIdent("never" !== this.options.allowReserved);
          }, $.initFunction = function (t) {
            t.id = null, this.options.ecmaVersion >= 6 && (t.generator = t.expression = !1), this.options.ecmaVersion >= 8 && (t.async = !1);
          }, $.parseMethod = function (t, e, i) {
            var s = this.startNode(),
              r = this.yieldPos,
              a = this.awaitPos,
              n = this.awaitIdentPos;
            return this.initFunction(s), this.options.ecmaVersion >= 6 && (s.generator = t), this.options.ecmaVersion >= 8 && (s.async = !!e), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | U(e, s.generator) | (i ? 128 : 0)), this.expect(k.parenL), s.params = this.parseBindingList(k.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(s, !1, !0), this.yieldPos = r, this.awaitPos = a, this.awaitIdentPos = n, this.finishNode(s, "FunctionExpression");
          }, $.parseArrowExpression = function (t, e, i) {
            var s = this.yieldPos,
              r = this.awaitPos,
              a = this.awaitIdentPos;
            return this.enterScope(16 | U(i, !1)), this.initFunction(t), this.options.ecmaVersion >= 8 && (t.async = !!i), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, t.params = this.toAssignableList(e, !0), this.parseFunctionBody(t, !0, !1), this.yieldPos = s, this.awaitPos = r, this.awaitIdentPos = a, this.finishNode(t, "ArrowFunctionExpression");
          }, $.parseFunctionBody = function (t, e, i) {
            var s = e && this.type !== k.braceL,
              r = this.strict,
              a = !1;
            if (s) t.body = this.parseMaybeAssign(), t.expression = !0, this.checkParams(t, !1);else {
              var n = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(t.params);
              r && !n || (a = this.strictDirective(this.end)) && n && this.raiseRecoverable(t.start, "Illegal 'use strict' directive in function with non-simple parameter list");
              var o = this.labels;
              this.labels = [], a && (this.strict = !0), this.checkParams(t, !r && !a && !e && !i && this.isSimpleParamList(t.params)), this.strict && t.id && this.checkLValSimple(t.id, 5), t.body = this.parseBlock(!1, void 0, a && !r), t.expression = !1, this.adaptDirectivePrologue(t.body.body), this.labels = o;
            }
            this.exitScope();
          }, $.isSimpleParamList = function (t) {
            for (var e = 0, i = t; e < i.length; e += 1) {
              if ("Identifier" !== i[e].type) return !1;
            }
            return !0;
          }, $.checkParams = function (t, e) {
            for (var i = Object.create(null), s = 0, r = t.params; s < r.length; s += 1) {
              var a = r[s];
              this.checkLValInnerPattern(a, 1, e ? null : i);
            }
          }, $.parseExprList = function (t, e, i, s) {
            for (var r = [], a = !0; !this.eat(t);) {
              if (a) a = !1;else if (this.expect(k.comma), e && this.afterTrailingComma(t)) break;
              var n = void 0;
              i && this.type === k.comma ? n = null : this.type === k.ellipsis ? (n = this.parseSpread(s), s && this.type === k.comma && s.trailingComma < 0 && (s.trailingComma = this.start)) : n = this.parseMaybeAssign(!1, s), r.push(n);
            }
            return r;
          }, $.checkUnreserved = function (t) {
            var e = t.start,
              i = t.end,
              s = t.name;
            (this.inGenerator && "yield" === s && this.raiseRecoverable(e, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && "await" === s && this.raiseRecoverable(e, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(s) && this.raise(e, "Unexpected keyword '" + s + "'"), this.options.ecmaVersion < 6 && -1 !== this.input.slice(e, i).indexOf("\\")) || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(s) && (this.inAsync || "await" !== s || this.raiseRecoverable(e, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(e, "The keyword '" + s + "' is reserved"));
          }, $.parseIdent = function (t, e) {
            var i = this.startNode();
            return this.type === k.name ? i.name = this.value : this.type.keyword ? (i.name = this.type.keyword, "class" !== i.name && "function" !== i.name || this.lastTokEnd === this.lastTokStart + 1 && 46 === this.input.charCodeAt(this.lastTokStart) || this.context.pop()) : this.unexpected(), this.next(!!t), this.finishNode(i, "Identifier"), t || (this.checkUnreserved(i), "await" !== i.name || this.awaitIdentPos || (this.awaitIdentPos = i.start)), i;
          }, $.parseYield = function (t) {
            this.yieldPos || (this.yieldPos = this.start);
            var e = this.startNode();
            return this.next(), this.type === k.semi || this.canInsertSemicolon() || this.type !== k.star && !this.type.startsExpr ? (e.delegate = !1, e.argument = null) : (e.delegate = this.eat(k.star), e.argument = this.parseMaybeAssign(t)), this.finishNode(e, "YieldExpression");
          }, $.parseAwait = function () {
            this.awaitPos || (this.awaitPos = this.start);
            var t = this.startNode();
            return this.next(), t.argument = this.parseMaybeUnary(null, !0), this.finishNode(t, "AwaitExpression");
          };
          var et = F.prototype;
          et.raise = function (t, e) {
            var i = M(this.input, t);
            e += " (" + i.line + ":" + i.column + ")";
            var s = new SyntaxError(e);
            throw s.pos = t, s.loc = i, s.raisedAt = this.pos, s;
          }, et.raiseRecoverable = et.raise, et.curPosition = function () {
            if (this.options.locations) return new O(this.curLine, this.pos - this.lineStart);
          };
          var it = F.prototype,
            st = function (t) {
              this.flags = t, this.var = [], this.lexical = [], this.functions = [];
            };
          it.enterScope = function (t) {
            this.scopeStack.push(new st(t));
          }, it.exitScope = function () {
            this.scopeStack.pop();
          }, it.treatFunctionsAsVarInScope = function (t) {
            return 2 & t.flags || !this.inModule && 1 & t.flags;
          }, it.declareName = function (t, e, i) {
            var s = !1;
            if (2 === e) {
              var r = this.currentScope();
              s = r.lexical.indexOf(t) > -1 || r.functions.indexOf(t) > -1 || r.var.indexOf(t) > -1, r.lexical.push(t), this.inModule && 1 & r.flags && delete this.undefinedExports[t];
            } else if (4 === e) {
              this.currentScope().lexical.push(t);
            } else if (3 === e) {
              var a = this.currentScope();
              s = this.treatFunctionsAsVar ? a.lexical.indexOf(t) > -1 : a.lexical.indexOf(t) > -1 || a.var.indexOf(t) > -1, a.functions.push(t);
            } else for (var n = this.scopeStack.length - 1; n >= 0; --n) {
              var o = this.scopeStack[n];
              if (o.lexical.indexOf(t) > -1 && !(32 & o.flags && o.lexical[0] === t) || !this.treatFunctionsAsVarInScope(o) && o.functions.indexOf(t) > -1) {
                s = !0;
                break;
              }
              if (o.var.push(t), this.inModule && 1 & o.flags && delete this.undefinedExports[t], 3 & o.flags) break;
            }
            s && this.raiseRecoverable(i, "Identifier '" + t + "' has already been declared");
          }, it.checkLocalExport = function (t) {
            -1 === this.scopeStack[0].lexical.indexOf(t.name) && -1 === this.scopeStack[0].var.indexOf(t.name) && (this.undefinedExports[t.name] = t);
          }, it.currentScope = function () {
            return this.scopeStack[this.scopeStack.length - 1];
          }, it.currentVarScope = function () {
            for (var t = this.scopeStack.length - 1;; t--) {
              var e = this.scopeStack[t];
              if (3 & e.flags) return e;
            }
          }, it.currentThisScope = function () {
            for (var t = this.scopeStack.length - 1;; t--) {
              var e = this.scopeStack[t];
              if (3 & e.flags && !(16 & e.flags)) return e;
            }
          };
          var rt = function (t, e, i) {
              this.type = "", this.start = e, this.end = 0, t.options.locations && (this.loc = new R(t, i)), t.options.directSourceFile && (this.sourceFile = t.options.directSourceFile), t.options.ranges && (this.range = [e, 0]);
            },
            at = F.prototype;
          function nt(t, e, i, s) {
            return t.type = e, t.end = i, this.options.locations && (t.loc.end = s), this.options.ranges && (t.range[1] = i), t;
          }
          at.startNode = function () {
            return new rt(this, this.start, this.startLoc);
          }, at.startNodeAt = function (t, e) {
            return new rt(this, t, e);
          }, at.finishNode = function (t, e) {
            return nt.call(this, t, e, this.lastTokEnd, this.lastTokEndLoc);
          }, at.finishNodeAt = function (t, e, i, s) {
            return nt.call(this, t, e, i, s);
          }, at.copyNode = function (t) {
            var e = new rt(this, t.start, this.startLoc);
            for (var i in t) e[i] = t[i];
            return e;
          };
          var ot = function (t, e, i, s, r) {
              this.token = t, this.isExpr = !!e, this.preserveSpace = !!i, this.override = s, this.generator = !!r;
            },
            ht = {
              b_stat: new ot("{", !1),
              b_expr: new ot("{", !0),
              b_tmpl: new ot("${", !1),
              p_stat: new ot("(", !1),
              p_expr: new ot("(", !0),
              q_tmpl: new ot("`", !0, !0, function (t) {
                return t.tryReadTemplateToken();
              }),
              f_stat: new ot("function", !1),
              f_expr: new ot("function", !0),
              f_expr_gen: new ot("function", !0, !1, null, !0),
              f_gen: new ot("function", !1, !1, null, !0)
            },
            pt = F.prototype;
          pt.initialContext = function () {
            return [ht.b_stat];
          }, pt.braceIsBlock = function (t) {
            var e = this.curContext();
            return e === ht.f_expr || e === ht.f_stat || (t !== k.colon || e !== ht.b_stat && e !== ht.b_expr ? t === k._return || t === k.name && this.exprAllowed ? S.test(this.input.slice(this.lastTokEnd, this.start)) : t === k._else || t === k.semi || t === k.eof || t === k.parenR || t === k.arrow || (t === k.braceL ? e === ht.b_stat : t !== k._var && t !== k._const && t !== k.name && !this.exprAllowed) : !e.isExpr);
          }, pt.inGeneratorContext = function () {
            for (var t = this.context.length - 1; t >= 1; t--) {
              var e = this.context[t];
              if ("function" === e.token) return e.generator;
            }
            return !1;
          }, pt.updateContext = function (t) {
            var e,
              i = this.type;
            i.keyword && t === k.dot ? this.exprAllowed = !1 : (e = i.updateContext) ? e.call(this, t) : this.exprAllowed = i.beforeExpr;
          }, k.parenR.updateContext = k.braceR.updateContext = function () {
            if (1 !== this.context.length) {
              var t = this.context.pop();
              t === ht.b_stat && "function" === this.curContext().token && (t = this.context.pop()), this.exprAllowed = !t.isExpr;
            } else this.exprAllowed = !0;
          }, k.braceL.updateContext = function (t) {
            this.context.push(this.braceIsBlock(t) ? ht.b_stat : ht.b_expr), this.exprAllowed = !0;
          }, k.dollarBraceL.updateContext = function () {
            this.context.push(ht.b_tmpl), this.exprAllowed = !0;
          }, k.parenL.updateContext = function (t) {
            var e = t === k._if || t === k._for || t === k._with || t === k._while;
            this.context.push(e ? ht.p_stat : ht.p_expr), this.exprAllowed = !0;
          }, k.incDec.updateContext = function () {}, k._function.updateContext = k._class.updateContext = function (t) {
            !t.beforeExpr || t === k._else || t === k.semi && this.curContext() !== ht.p_stat || t === k._return && S.test(this.input.slice(this.lastTokEnd, this.start)) || (t === k.colon || t === k.braceL) && this.curContext() === ht.b_stat ? this.context.push(ht.f_stat) : this.context.push(ht.f_expr), this.exprAllowed = !1;
          }, k.backQuote.updateContext = function () {
            this.curContext() === ht.q_tmpl ? this.context.pop() : this.context.push(ht.q_tmpl), this.exprAllowed = !1;
          }, k.star.updateContext = function (t) {
            if (t === k._function) {
              var e = this.context.length - 1;
              this.context[e] === ht.f_expr ? this.context[e] = ht.f_expr_gen : this.context[e] = ht.f_gen;
            }
            this.exprAllowed = !0;
          }, k.name.updateContext = function (t) {
            var e = !1;
            this.options.ecmaVersion >= 6 && t !== k.dot && ("of" === this.value && !this.exprAllowed || "yield" === this.value && this.inGeneratorContext()) && (e = !0), this.exprAllowed = e;
          };
          var ct = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS",
            lt = ct + " Extended_Pictographic",
            ut = {
              9: ct,
              10: lt,
              11: lt,
              12: "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS Extended_Pictographic EBase EComp EMod EPres ExtPict"
            },
            dt = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu",
            ft = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb",
            mt = ft + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd",
            gt = mt + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho",
            xt = {
              9: ft,
              10: mt,
              11: gt,
              12: "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi"
            },
            yt = {};
          function vt(t) {
            var e = yt[t] = {
              binary: V(ut[t] + " " + dt),
              nonBinary: {
                General_Category: V(dt),
                Script: V(xt[t])
              }
            };
            e.nonBinary.Script_Extensions = e.nonBinary.Script, e.nonBinary.gc = e.nonBinary.General_Category, e.nonBinary.sc = e.nonBinary.Script, e.nonBinary.scx = e.nonBinary.Script_Extensions;
          }
          vt(9), vt(10), vt(11), vt(12);
          var bt = F.prototype,
            _t = function (t) {
              this.parser = t, this.validFlags = "gim" + (t.options.ecmaVersion >= 6 ? "uy" : "") + (t.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = yt[t.options.ecmaVersion >= 12 ? 12 : t.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
            };
          function kt(t) {
            return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(55296 + (t >> 10), 56320 + (1023 & t)));
          }
          function St(t) {
            return 36 === t || t >= 40 && t <= 43 || 46 === t || 63 === t || t >= 91 && t <= 94 || t >= 123 && t <= 125;
          }
          function wt(t) {
            return t >= 65 && t <= 90 || t >= 97 && t <= 122;
          }
          function Ct(t) {
            return wt(t) || 95 === t;
          }
          function Et(t) {
            return Ct(t) || At(t);
          }
          function At(t) {
            return t >= 48 && t <= 57;
          }
          function It(t) {
            return t >= 48 && t <= 57 || t >= 65 && t <= 70 || t >= 97 && t <= 102;
          }
          function Pt(t) {
            return t >= 65 && t <= 70 ? t - 65 + 10 : t >= 97 && t <= 102 ? t - 97 + 10 : t - 48;
          }
          function Tt(t) {
            return t >= 48 && t <= 55;
          }
          _t.prototype.reset = function (t, e, i) {
            var s = -1 !== i.indexOf("u");
            this.start = 0 | t, this.source = e + "", this.flags = i, this.switchU = s && this.parser.options.ecmaVersion >= 6, this.switchN = s && this.parser.options.ecmaVersion >= 9;
          }, _t.prototype.raise = function (t) {
            this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + t);
          }, _t.prototype.at = function (t, e) {
            void 0 === e && (e = !1);
            var i = this.source,
              s = i.length;
            if (t >= s) return -1;
            var r = i.charCodeAt(t);
            if (!e && !this.switchU || r <= 55295 || r >= 57344 || t + 1 >= s) return r;
            var a = i.charCodeAt(t + 1);
            return a >= 56320 && a <= 57343 ? (r << 10) + a - 56613888 : r;
          }, _t.prototype.nextIndex = function (t, e) {
            void 0 === e && (e = !1);
            var i = this.source,
              s = i.length;
            if (t >= s) return s;
            var r,
              a = i.charCodeAt(t);
            return !e && !this.switchU || a <= 55295 || a >= 57344 || t + 1 >= s || (r = i.charCodeAt(t + 1)) < 56320 || r > 57343 ? t + 1 : t + 2;
          }, _t.prototype.current = function (t) {
            return void 0 === t && (t = !1), this.at(this.pos, t);
          }, _t.prototype.lookahead = function (t) {
            return void 0 === t && (t = !1), this.at(this.nextIndex(this.pos, t), t);
          }, _t.prototype.advance = function (t) {
            void 0 === t && (t = !1), this.pos = this.nextIndex(this.pos, t);
          }, _t.prototype.eat = function (t, e) {
            return void 0 === e && (e = !1), this.current(e) === t && (this.advance(e), !0);
          }, bt.validateRegExpFlags = function (t) {
            for (var e = t.validFlags, i = t.flags, s = 0; s < i.length; s++) {
              var r = i.charAt(s);
              -1 === e.indexOf(r) && this.raise(t.start, "Invalid regular expression flag"), i.indexOf(r, s + 1) > -1 && this.raise(t.start, "Duplicate regular expression flag");
            }
          }, bt.validateRegExpPattern = function (t) {
            this.regexp_pattern(t), !t.switchN && this.options.ecmaVersion >= 9 && t.groupNames.length > 0 && (t.switchN = !0, this.regexp_pattern(t));
          }, bt.regexp_pattern = function (t) {
            t.pos = 0, t.lastIntValue = 0, t.lastStringValue = "", t.lastAssertionIsQuantifiable = !1, t.numCapturingParens = 0, t.maxBackReference = 0, t.groupNames.length = 0, t.backReferenceNames.length = 0, this.regexp_disjunction(t), t.pos !== t.source.length && (t.eat(41) && t.raise("Unmatched ')'"), (t.eat(93) || t.eat(125)) && t.raise("Lone quantifier brackets")), t.maxBackReference > t.numCapturingParens && t.raise("Invalid escape");
            for (var e = 0, i = t.backReferenceNames; e < i.length; e += 1) {
              var s = i[e];
              -1 === t.groupNames.indexOf(s) && t.raise("Invalid named capture referenced");
            }
          }, bt.regexp_disjunction = function (t) {
            for (this.regexp_alternative(t); t.eat(124);) this.regexp_alternative(t);
            this.regexp_eatQuantifier(t, !0) && t.raise("Nothing to repeat"), t.eat(123) && t.raise("Lone quantifier brackets");
          }, bt.regexp_alternative = function (t) {
            for (; t.pos < t.source.length && this.regexp_eatTerm(t););
          }, bt.regexp_eatTerm = function (t) {
            return this.regexp_eatAssertion(t) ? (t.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(t) && t.switchU && t.raise("Invalid quantifier"), !0) : !!(t.switchU ? this.regexp_eatAtom(t) : this.regexp_eatExtendedAtom(t)) && (this.regexp_eatQuantifier(t), !0);
          }, bt.regexp_eatAssertion = function (t) {
            var e = t.pos;
            if (t.lastAssertionIsQuantifiable = !1, t.eat(94) || t.eat(36)) return !0;
            if (t.eat(92)) {
              if (t.eat(66) || t.eat(98)) return !0;
              t.pos = e;
            }
            if (t.eat(40) && t.eat(63)) {
              var i = !1;
              if (this.options.ecmaVersion >= 9 && (i = t.eat(60)), t.eat(61) || t.eat(33)) return this.regexp_disjunction(t), t.eat(41) || t.raise("Unterminated group"), t.lastAssertionIsQuantifiable = !i, !0;
            }
            return t.pos = e, !1;
          }, bt.regexp_eatQuantifier = function (t, e) {
            return void 0 === e && (e = !1), !!this.regexp_eatQuantifierPrefix(t, e) && (t.eat(63), !0);
          }, bt.regexp_eatQuantifierPrefix = function (t, e) {
            return t.eat(42) || t.eat(43) || t.eat(63) || this.regexp_eatBracedQuantifier(t, e);
          }, bt.regexp_eatBracedQuantifier = function (t, e) {
            var i = t.pos;
            if (t.eat(123)) {
              var s = 0,
                r = -1;
              if (this.regexp_eatDecimalDigits(t) && (s = t.lastIntValue, t.eat(44) && this.regexp_eatDecimalDigits(t) && (r = t.lastIntValue), t.eat(125))) return -1 !== r && r < s && !e && t.raise("numbers out of order in {} quantifier"), !0;
              t.switchU && !e && t.raise("Incomplete quantifier"), t.pos = i;
            }
            return !1;
          }, bt.regexp_eatAtom = function (t) {
            return this.regexp_eatPatternCharacters(t) || t.eat(46) || this.regexp_eatReverseSolidusAtomEscape(t) || this.regexp_eatCharacterClass(t) || this.regexp_eatUncapturingGroup(t) || this.regexp_eatCapturingGroup(t);
          }, bt.regexp_eatReverseSolidusAtomEscape = function (t) {
            var e = t.pos;
            if (t.eat(92)) {
              if (this.regexp_eatAtomEscape(t)) return !0;
              t.pos = e;
            }
            return !1;
          }, bt.regexp_eatUncapturingGroup = function (t) {
            var e = t.pos;
            if (t.eat(40)) {
              if (t.eat(63) && t.eat(58)) {
                if (this.regexp_disjunction(t), t.eat(41)) return !0;
                t.raise("Unterminated group");
              }
              t.pos = e;
            }
            return !1;
          }, bt.regexp_eatCapturingGroup = function (t) {
            if (t.eat(40)) {
              if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(t) : 63 === t.current() && t.raise("Invalid group"), this.regexp_disjunction(t), t.eat(41)) return t.numCapturingParens += 1, !0;
              t.raise("Unterminated group");
            }
            return !1;
          }, bt.regexp_eatExtendedAtom = function (t) {
            return t.eat(46) || this.regexp_eatReverseSolidusAtomEscape(t) || this.regexp_eatCharacterClass(t) || this.regexp_eatUncapturingGroup(t) || this.regexp_eatCapturingGroup(t) || this.regexp_eatInvalidBracedQuantifier(t) || this.regexp_eatExtendedPatternCharacter(t);
          }, bt.regexp_eatInvalidBracedQuantifier = function (t) {
            return this.regexp_eatBracedQuantifier(t, !0) && t.raise("Nothing to repeat"), !1;
          }, bt.regexp_eatSyntaxCharacter = function (t) {
            var e = t.current();
            return !!St(e) && (t.lastIntValue = e, t.advance(), !0);
          }, bt.regexp_eatPatternCharacters = function (t) {
            for (var e = t.pos, i = 0; -1 !== (i = t.current()) && !St(i);) t.advance();
            return t.pos !== e;
          }, bt.regexp_eatExtendedPatternCharacter = function (t) {
            var e = t.current();
            return !(-1 === e || 36 === e || e >= 40 && e <= 43 || 46 === e || 63 === e || 91 === e || 94 === e || 124 === e) && (t.advance(), !0);
          }, bt.regexp_groupSpecifier = function (t) {
            if (t.eat(63)) {
              if (this.regexp_eatGroupName(t)) return -1 !== t.groupNames.indexOf(t.lastStringValue) && t.raise("Duplicate capture group name"), void t.groupNames.push(t.lastStringValue);
              t.raise("Invalid group");
            }
          }, bt.regexp_eatGroupName = function (t) {
            if (t.lastStringValue = "", t.eat(60)) {
              if (this.regexp_eatRegExpIdentifierName(t) && t.eat(62)) return !0;
              t.raise("Invalid capture group name");
            }
            return !1;
          }, bt.regexp_eatRegExpIdentifierName = function (t) {
            if (t.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(t)) {
              for (t.lastStringValue += kt(t.lastIntValue); this.regexp_eatRegExpIdentifierPart(t);) t.lastStringValue += kt(t.lastIntValue);
              return !0;
            }
            return !1;
          }, bt.regexp_eatRegExpIdentifierStart = function (t) {
            var e = t.pos,
              i = this.options.ecmaVersion >= 11,
              s = t.current(i);
            return t.advance(i), 92 === s && this.regexp_eatRegExpUnicodeEscapeSequence(t, i) && (s = t.lastIntValue), function (t) {
              return f(t, !0) || 36 === t || 95 === t;
            }(s) ? (t.lastIntValue = s, !0) : (t.pos = e, !1);
          }, bt.regexp_eatRegExpIdentifierPart = function (t) {
            var e = t.pos,
              i = this.options.ecmaVersion >= 11,
              s = t.current(i);
            return t.advance(i), 92 === s && this.regexp_eatRegExpUnicodeEscapeSequence(t, i) && (s = t.lastIntValue), function (t) {
              return m(t, !0) || 36 === t || 95 === t || 8204 === t || 8205 === t;
            }(s) ? (t.lastIntValue = s, !0) : (t.pos = e, !1);
          }, bt.regexp_eatAtomEscape = function (t) {
            return !!(this.regexp_eatBackReference(t) || this.regexp_eatCharacterClassEscape(t) || this.regexp_eatCharacterEscape(t) || t.switchN && this.regexp_eatKGroupName(t)) || (t.switchU && (99 === t.current() && t.raise("Invalid unicode escape"), t.raise("Invalid escape")), !1);
          }, bt.regexp_eatBackReference = function (t) {
            var e = t.pos;
            if (this.regexp_eatDecimalEscape(t)) {
              var i = t.lastIntValue;
              if (t.switchU) return i > t.maxBackReference && (t.maxBackReference = i), !0;
              if (i <= t.numCapturingParens) return !0;
              t.pos = e;
            }
            return !1;
          }, bt.regexp_eatKGroupName = function (t) {
            if (t.eat(107)) {
              if (this.regexp_eatGroupName(t)) return t.backReferenceNames.push(t.lastStringValue), !0;
              t.raise("Invalid named reference");
            }
            return !1;
          }, bt.regexp_eatCharacterEscape = function (t) {
            return this.regexp_eatControlEscape(t) || this.regexp_eatCControlLetter(t) || this.regexp_eatZero(t) || this.regexp_eatHexEscapeSequence(t) || this.regexp_eatRegExpUnicodeEscapeSequence(t, !1) || !t.switchU && this.regexp_eatLegacyOctalEscapeSequence(t) || this.regexp_eatIdentityEscape(t);
          }, bt.regexp_eatCControlLetter = function (t) {
            var e = t.pos;
            if (t.eat(99)) {
              if (this.regexp_eatControlLetter(t)) return !0;
              t.pos = e;
            }
            return !1;
          }, bt.regexp_eatZero = function (t) {
            return 48 === t.current() && !At(t.lookahead()) && (t.lastIntValue = 0, t.advance(), !0);
          }, bt.regexp_eatControlEscape = function (t) {
            var e = t.current();
            return 116 === e ? (t.lastIntValue = 9, t.advance(), !0) : 110 === e ? (t.lastIntValue = 10, t.advance(), !0) : 118 === e ? (t.lastIntValue = 11, t.advance(), !0) : 102 === e ? (t.lastIntValue = 12, t.advance(), !0) : 114 === e && (t.lastIntValue = 13, t.advance(), !0);
          }, bt.regexp_eatControlLetter = function (t) {
            var e = t.current();
            return !!wt(e) && (t.lastIntValue = e % 32, t.advance(), !0);
          }, bt.regexp_eatRegExpUnicodeEscapeSequence = function (t, e) {
            void 0 === e && (e = !1);
            var i,
              s = t.pos,
              r = e || t.switchU;
            if (t.eat(117)) {
              if (this.regexp_eatFixedHexDigits(t, 4)) {
                var a = t.lastIntValue;
                if (r && a >= 55296 && a <= 56319) {
                  var n = t.pos;
                  if (t.eat(92) && t.eat(117) && this.regexp_eatFixedHexDigits(t, 4)) {
                    var o = t.lastIntValue;
                    if (o >= 56320 && o <= 57343) return t.lastIntValue = 1024 * (a - 55296) + (o - 56320) + 65536, !0;
                  }
                  t.pos = n, t.lastIntValue = a;
                }
                return !0;
              }
              if (r && t.eat(123) && this.regexp_eatHexDigits(t) && t.eat(125) && (i = t.lastIntValue) >= 0 && i <= 1114111) return !0;
              r && t.raise("Invalid unicode escape"), t.pos = s;
            }
            return !1;
          }, bt.regexp_eatIdentityEscape = function (t) {
            if (t.switchU) return !!this.regexp_eatSyntaxCharacter(t) || !!t.eat(47) && (t.lastIntValue = 47, !0);
            var e = t.current();
            return !(99 === e || t.switchN && 107 === e) && (t.lastIntValue = e, t.advance(), !0);
          }, bt.regexp_eatDecimalEscape = function (t) {
            t.lastIntValue = 0;
            var e = t.current();
            if (e >= 49 && e <= 57) {
              do {
                t.lastIntValue = 10 * t.lastIntValue + (e - 48), t.advance();
              } while ((e = t.current()) >= 48 && e <= 57);
              return !0;
            }
            return !1;
          }, bt.regexp_eatCharacterClassEscape = function (t) {
            var e = t.current();
            if (function (t) {
              return 100 === t || 68 === t || 115 === t || 83 === t || 119 === t || 87 === t;
            }(e)) return t.lastIntValue = -1, t.advance(), !0;
            if (t.switchU && this.options.ecmaVersion >= 9 && (80 === e || 112 === e)) {
              if (t.lastIntValue = -1, t.advance(), t.eat(123) && this.regexp_eatUnicodePropertyValueExpression(t) && t.eat(125)) return !0;
              t.raise("Invalid property name");
            }
            return !1;
          }, bt.regexp_eatUnicodePropertyValueExpression = function (t) {
            var e = t.pos;
            if (this.regexp_eatUnicodePropertyName(t) && t.eat(61)) {
              var i = t.lastStringValue;
              if (this.regexp_eatUnicodePropertyValue(t)) {
                var s = t.lastStringValue;
                return this.regexp_validateUnicodePropertyNameAndValue(t, i, s), !0;
              }
            }
            if (t.pos = e, this.regexp_eatLoneUnicodePropertyNameOrValue(t)) {
              var r = t.lastStringValue;
              return this.regexp_validateUnicodePropertyNameOrValue(t, r), !0;
            }
            return !1;
          }, bt.regexp_validateUnicodePropertyNameAndValue = function (t, e, i) {
            N(t.unicodeProperties.nonBinary, e) || t.raise("Invalid property name"), t.unicodeProperties.nonBinary[e].test(i) || t.raise("Invalid property value");
          }, bt.regexp_validateUnicodePropertyNameOrValue = function (t, e) {
            t.unicodeProperties.binary.test(e) || t.raise("Invalid property name");
          }, bt.regexp_eatUnicodePropertyName = function (t) {
            var e = 0;
            for (t.lastStringValue = ""; Ct(e = t.current());) t.lastStringValue += kt(e), t.advance();
            return "" !== t.lastStringValue;
          }, bt.regexp_eatUnicodePropertyValue = function (t) {
            var e = 0;
            for (t.lastStringValue = ""; Et(e = t.current());) t.lastStringValue += kt(e), t.advance();
            return "" !== t.lastStringValue;
          }, bt.regexp_eatLoneUnicodePropertyNameOrValue = function (t) {
            return this.regexp_eatUnicodePropertyValue(t);
          }, bt.regexp_eatCharacterClass = function (t) {
            if (t.eat(91)) {
              if (t.eat(94), this.regexp_classRanges(t), t.eat(93)) return !0;
              t.raise("Unterminated character class");
            }
            return !1;
          }, bt.regexp_classRanges = function (t) {
            for (; this.regexp_eatClassAtom(t);) {
              var e = t.lastIntValue;
              if (t.eat(45) && this.regexp_eatClassAtom(t)) {
                var i = t.lastIntValue;
                !t.switchU || -1 !== e && -1 !== i || t.raise("Invalid character class"), -1 !== e && -1 !== i && e > i && t.raise("Range out of order in character class");
              }
            }
          }, bt.regexp_eatClassAtom = function (t) {
            var e = t.pos;
            if (t.eat(92)) {
              if (this.regexp_eatClassEscape(t)) return !0;
              if (t.switchU) {
                var i = t.current();
                (99 === i || Tt(i)) && t.raise("Invalid class escape"), t.raise("Invalid escape");
              }
              t.pos = e;
            }
            var s = t.current();
            return 93 !== s && (t.lastIntValue = s, t.advance(), !0);
          }, bt.regexp_eatClassEscape = function (t) {
            var e = t.pos;
            if (t.eat(98)) return t.lastIntValue = 8, !0;
            if (t.switchU && t.eat(45)) return t.lastIntValue = 45, !0;
            if (!t.switchU && t.eat(99)) {
              if (this.regexp_eatClassControlLetter(t)) return !0;
              t.pos = e;
            }
            return this.regexp_eatCharacterClassEscape(t) || this.regexp_eatCharacterEscape(t);
          }, bt.regexp_eatClassControlLetter = function (t) {
            var e = t.current();
            return !(!At(e) && 95 !== e) && (t.lastIntValue = e % 32, t.advance(), !0);
          }, bt.regexp_eatHexEscapeSequence = function (t) {
            var e = t.pos;
            if (t.eat(120)) {
              if (this.regexp_eatFixedHexDigits(t, 2)) return !0;
              t.switchU && t.raise("Invalid escape"), t.pos = e;
            }
            return !1;
          }, bt.regexp_eatDecimalDigits = function (t) {
            var e = t.pos,
              i = 0;
            for (t.lastIntValue = 0; At(i = t.current());) t.lastIntValue = 10 * t.lastIntValue + (i - 48), t.advance();
            return t.pos !== e;
          }, bt.regexp_eatHexDigits = function (t) {
            var e = t.pos,
              i = 0;
            for (t.lastIntValue = 0; It(i = t.current());) t.lastIntValue = 16 * t.lastIntValue + Pt(i), t.advance();
            return t.pos !== e;
          }, bt.regexp_eatLegacyOctalEscapeSequence = function (t) {
            if (this.regexp_eatOctalDigit(t)) {
              var e = t.lastIntValue;
              if (this.regexp_eatOctalDigit(t)) {
                var i = t.lastIntValue;
                e <= 3 && this.regexp_eatOctalDigit(t) ? t.lastIntValue = 64 * e + 8 * i + t.lastIntValue : t.lastIntValue = 8 * e + i;
              } else t.lastIntValue = e;
              return !0;
            }
            return !1;
          }, bt.regexp_eatOctalDigit = function (t) {
            var e = t.current();
            return Tt(e) ? (t.lastIntValue = e - 48, t.advance(), !0) : (t.lastIntValue = 0, !1);
          }, bt.regexp_eatFixedHexDigits = function (t, e) {
            var i = t.pos;
            t.lastIntValue = 0;
            for (var s = 0; s < e; ++s) {
              var r = t.current();
              if (!It(r)) return t.pos = i, !1;
              t.lastIntValue = 16 * t.lastIntValue + Pt(r), t.advance();
            }
            return !0;
          };
          var Nt = function (t) {
              this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, t.options.locations && (this.loc = new R(t, t.startLoc, t.endLoc)), t.options.ranges && (this.range = [t.start, t.end]);
            },
            Lt = F.prototype;
          function Vt(t) {
            return "function" != typeof BigInt ? null : BigInt(t.replace(/_/g, ""));
          }
          function Ot(t) {
            return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode(55296 + (t >> 10), 56320 + (1023 & t)));
          }
          Lt.next = function (t) {
            !t && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new Nt(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
          }, Lt.getToken = function () {
            return this.next(), new Nt(this);
          }, "undefined" != typeof Symbol && (Lt[Symbol.iterator] = function () {
            var t = this;
            return {
              next: function () {
                var e = t.getToken();
                return {
                  done: e.type === k.eof,
                  value: e
                };
              }
            };
          }), Lt.curContext = function () {
            return this.context[this.context.length - 1];
          }, Lt.nextToken = function () {
            var t = this.curContext();
            return t && t.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(k.eof) : t.override ? t.override(this) : void this.readToken(this.fullCharCodeAtPos());
          }, Lt.readToken = function (t) {
            return f(t, this.options.ecmaVersion >= 6) || 92 === t ? this.readWord() : this.getTokenFromCode(t);
          }, Lt.fullCharCodeAtPos = function () {
            var t = this.input.charCodeAt(this.pos);
            return t <= 55295 || t >= 57344 ? t : (t << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
          }, Lt.skipBlockComment = function () {
            var t,
              e = this.options.onComment && this.curPosition(),
              i = this.pos,
              s = this.input.indexOf("*/", this.pos += 2);
            if (-1 === s && this.raise(this.pos - 2, "Unterminated comment"), this.pos = s + 2, this.options.locations) for (w.lastIndex = i; (t = w.exec(this.input)) && t.index < this.pos;) ++this.curLine, this.lineStart = t.index + t[0].length;
            this.options.onComment && this.options.onComment(!0, this.input.slice(i + 2, s), i, this.pos, e, this.curPosition());
          }, Lt.skipLineComment = function (t) {
            for (var e = this.pos, i = this.options.onComment && this.curPosition(), s = this.input.charCodeAt(this.pos += t); this.pos < this.input.length && !C(s);) s = this.input.charCodeAt(++this.pos);
            this.options.onComment && this.options.onComment(!1, this.input.slice(e + t, this.pos), e, this.pos, i, this.curPosition());
          }, Lt.skipSpace = function () {
            t: for (; this.pos < this.input.length;) {
              var t = this.input.charCodeAt(this.pos);
              switch (t) {
                case 32:
                case 160:
                  ++this.pos;
                  break;
                case 13:
                  10 === this.input.charCodeAt(this.pos + 1) && ++this.pos;
                case 10:
                case 8232:
                case 8233:
                  ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                  break;
                case 47:
                  switch (this.input.charCodeAt(this.pos + 1)) {
                    case 42:
                      this.skipBlockComment();
                      break;
                    case 47:
                      this.skipLineComment(2);
                      break;
                    default:
                      break t;
                  }
                  break;
                default:
                  if (!(t > 8 && t < 14 || t >= 5760 && E.test(String.fromCharCode(t)))) break t;
                  ++this.pos;
              }
            }
          }, Lt.finishToken = function (t, e) {
            this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
            var i = this.type;
            this.type = t, this.value = e, this.updateContext(i);
          }, Lt.readToken_dot = function () {
            var t = this.input.charCodeAt(this.pos + 1);
            if (t >= 48 && t <= 57) return this.readNumber(!0);
            var e = this.input.charCodeAt(this.pos + 2);
            return this.options.ecmaVersion >= 6 && 46 === t && 46 === e ? (this.pos += 3, this.finishToken(k.ellipsis)) : (++this.pos, this.finishToken(k.dot));
          }, Lt.readToken_slash = function () {
            var t = this.input.charCodeAt(this.pos + 1);
            return this.exprAllowed ? (++this.pos, this.readRegexp()) : 61 === t ? this.finishOp(k.assign, 2) : this.finishOp(k.slash, 1);
          }, Lt.readToken_mult_modulo_exp = function (t) {
            var e = this.input.charCodeAt(this.pos + 1),
              i = 1,
              s = 42 === t ? k.star : k.modulo;
            return this.options.ecmaVersion >= 7 && 42 === t && 42 === e && (++i, s = k.starstar, e = this.input.charCodeAt(this.pos + 2)), 61 === e ? this.finishOp(k.assign, i + 1) : this.finishOp(s, i);
          }, Lt.readToken_pipe_amp = function (t) {
            var e = this.input.charCodeAt(this.pos + 1);
            if (e === t) {
              if (this.options.ecmaVersion >= 12) if (61 === this.input.charCodeAt(this.pos + 2)) return this.finishOp(k.assign, 3);
              return this.finishOp(124 === t ? k.logicalOR : k.logicalAND, 2);
            }
            return 61 === e ? this.finishOp(k.assign, 2) : this.finishOp(124 === t ? k.bitwiseOR : k.bitwiseAND, 1);
          }, Lt.readToken_caret = function () {
            return 61 === this.input.charCodeAt(this.pos + 1) ? this.finishOp(k.assign, 2) : this.finishOp(k.bitwiseXOR, 1);
          }, Lt.readToken_plus_min = function (t) {
            var e = this.input.charCodeAt(this.pos + 1);
            return e === t ? 45 !== e || this.inModule || 62 !== this.input.charCodeAt(this.pos + 2) || 0 !== this.lastTokEnd && !S.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(k.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : 61 === e ? this.finishOp(k.assign, 2) : this.finishOp(k.plusMin, 1);
          }, Lt.readToken_lt_gt = function (t) {
            var e = this.input.charCodeAt(this.pos + 1),
              i = 1;
            return e === t ? (i = 62 === t && 62 === this.input.charCodeAt(this.pos + 2) ? 3 : 2, 61 === this.input.charCodeAt(this.pos + i) ? this.finishOp(k.assign, i + 1) : this.finishOp(k.bitShift, i)) : 33 !== e || 60 !== t || this.inModule || 45 !== this.input.charCodeAt(this.pos + 2) || 45 !== this.input.charCodeAt(this.pos + 3) ? (61 === e && (i = 2), this.finishOp(k.relational, i)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
          }, Lt.readToken_eq_excl = function (t) {
            var e = this.input.charCodeAt(this.pos + 1);
            return 61 === e ? this.finishOp(k.equality, 61 === this.input.charCodeAt(this.pos + 2) ? 3 : 2) : 61 === t && 62 === e && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(k.arrow)) : this.finishOp(61 === t ? k.eq : k.prefix, 1);
          }, Lt.readToken_question = function () {
            var t = this.options.ecmaVersion;
            if (t >= 11) {
              var e = this.input.charCodeAt(this.pos + 1);
              if (46 === e) {
                var i = this.input.charCodeAt(this.pos + 2);
                if (i < 48 || i > 57) return this.finishOp(k.questionDot, 2);
              }
              if (63 === e) {
                if (t >= 12) if (61 === this.input.charCodeAt(this.pos + 2)) return this.finishOp(k.assign, 3);
                return this.finishOp(k.coalesce, 2);
              }
            }
            return this.finishOp(k.question, 1);
          }, Lt.getTokenFromCode = function (t) {
            switch (t) {
              case 46:
                return this.readToken_dot();
              case 40:
                return ++this.pos, this.finishToken(k.parenL);
              case 41:
                return ++this.pos, this.finishToken(k.parenR);
              case 59:
                return ++this.pos, this.finishToken(k.semi);
              case 44:
                return ++this.pos, this.finishToken(k.comma);
              case 91:
                return ++this.pos, this.finishToken(k.bracketL);
              case 93:
                return ++this.pos, this.finishToken(k.bracketR);
              case 123:
                return ++this.pos, this.finishToken(k.braceL);
              case 125:
                return ++this.pos, this.finishToken(k.braceR);
              case 58:
                return ++this.pos, this.finishToken(k.colon);
              case 96:
                if (this.options.ecmaVersion < 6) break;
                return ++this.pos, this.finishToken(k.backQuote);
              case 48:
                var e = this.input.charCodeAt(this.pos + 1);
                if (120 === e || 88 === e) return this.readRadixNumber(16);
                if (this.options.ecmaVersion >= 6) {
                  if (111 === e || 79 === e) return this.readRadixNumber(8);
                  if (98 === e || 66 === e) return this.readRadixNumber(2);
                }
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return this.readNumber(!1);
              case 34:
              case 39:
                return this.readString(t);
              case 47:
                return this.readToken_slash();
              case 37:
              case 42:
                return this.readToken_mult_modulo_exp(t);
              case 124:
              case 38:
                return this.readToken_pipe_amp(t);
              case 94:
                return this.readToken_caret();
              case 43:
              case 45:
                return this.readToken_plus_min(t);
              case 60:
              case 62:
                return this.readToken_lt_gt(t);
              case 61:
              case 33:
                return this.readToken_eq_excl(t);
              case 63:
                return this.readToken_question();
              case 126:
                return this.finishOp(k.prefix, 1);
            }
            this.raise(this.pos, "Unexpected character '" + Ot(t) + "'");
          }, Lt.finishOp = function (t, e) {
            var i = this.input.slice(this.pos, this.pos + e);
            return this.pos += e, this.finishToken(t, i);
          }, Lt.readRegexp = function () {
            for (var t, e, i = this.pos;;) {
              this.pos >= this.input.length && this.raise(i, "Unterminated regular expression");
              var s = this.input.charAt(this.pos);
              if (S.test(s) && this.raise(i, "Unterminated regular expression"), t) t = !1;else {
                if ("[" === s) e = !0;else if ("]" === s && e) e = !1;else if ("/" === s && !e) break;
                t = "\\" === s;
              }
              ++this.pos;
            }
            var r = this.input.slice(i, this.pos);
            ++this.pos;
            var a = this.pos,
              n = this.readWord1();
            this.containsEsc && this.unexpected(a);
            var o = this.regexpState || (this.regexpState = new _t(this));
            o.reset(i, r, n), this.validateRegExpFlags(o), this.validateRegExpPattern(o);
            var h = null;
            try {
              h = new RegExp(r, n);
            } catch (t) {}
            return this.finishToken(k.regexp, {
              pattern: r,
              flags: n,
              value: h
            });
          }, Lt.readInt = function (t, e, i) {
            for (var s = this.options.ecmaVersion >= 12 && void 0 === e, r = i && 48 === this.input.charCodeAt(this.pos), a = this.pos, n = 0, o = 0, h = 0, p = null == e ? 1 / 0 : e; h < p; ++h, ++this.pos) {
              var c = this.input.charCodeAt(this.pos),
                l = void 0;
              if (s && 95 === c) r && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), 95 === o && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), 0 === h && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), o = c;else {
                if ((l = c >= 97 ? c - 97 + 10 : c >= 65 ? c - 65 + 10 : c >= 48 && c <= 57 ? c - 48 : 1 / 0) >= t) break;
                o = c, n = n * t + l;
              }
            }
            return s && 95 === o && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === a || null != e && this.pos - a !== e ? null : n;
          }, Lt.readRadixNumber = function (t) {
            var e = this.pos;
            this.pos += 2;
            var i = this.readInt(t);
            return null == i && this.raise(this.start + 2, "Expected number in radix " + t), this.options.ecmaVersion >= 11 && 110 === this.input.charCodeAt(this.pos) ? (i = Vt(this.input.slice(e, this.pos)), ++this.pos) : f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(k.num, i);
          }, Lt.readNumber = function (t) {
            var e = this.pos;
            t || null !== this.readInt(10, void 0, !0) || this.raise(e, "Invalid number");
            var i = this.pos - e >= 2 && 48 === this.input.charCodeAt(e);
            i && this.strict && this.raise(e, "Invalid number");
            var s = this.input.charCodeAt(this.pos);
            if (!i && !t && this.options.ecmaVersion >= 11 && 110 === s) {
              var r = Vt(this.input.slice(e, this.pos));
              return ++this.pos, f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(k.num, r);
            }
            i && /[89]/.test(this.input.slice(e, this.pos)) && (i = !1), 46 !== s || i || (++this.pos, this.readInt(10), s = this.input.charCodeAt(this.pos)), 69 !== s && 101 !== s || i || (43 !== (s = this.input.charCodeAt(++this.pos)) && 45 !== s || ++this.pos, null === this.readInt(10) && this.raise(e, "Invalid number")), f(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
            var a,
              n = (a = this.input.slice(e, this.pos), i ? parseInt(a, 8) : parseFloat(a.replace(/_/g, "")));
            return this.finishToken(k.num, n);
          }, Lt.readCodePoint = function () {
            var t;
            if (123 === this.input.charCodeAt(this.pos)) {
              this.options.ecmaVersion < 6 && this.unexpected();
              var e = ++this.pos;
              t = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, t > 1114111 && this.invalidStringToken(e, "Code point out of bounds");
            } else t = this.readHexChar(4);
            return t;
          }, Lt.readString = function (t) {
            for (var e = "", i = ++this.pos;;) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
              var s = this.input.charCodeAt(this.pos);
              if (s === t) break;
              92 === s ? (e += this.input.slice(i, this.pos), e += this.readEscapedChar(!1), i = this.pos) : (C(s, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
            }
            return e += this.input.slice(i, this.pos++), this.finishToken(k.string, e);
          };
          var Rt = {};
          Lt.tryReadTemplateToken = function () {
            this.inTemplateElement = !0;
            try {
              this.readTmplToken();
            } catch (t) {
              if (t !== Rt) throw t;
              this.readInvalidTemplateToken();
            }
            this.inTemplateElement = !1;
          }, Lt.invalidStringToken = function (t, e) {
            if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw Rt;
            this.raise(t, e);
          }, Lt.readTmplToken = function () {
            for (var t = "", e = this.pos;;) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
              var i = this.input.charCodeAt(this.pos);
              if (96 === i || 36 === i && 123 === this.input.charCodeAt(this.pos + 1)) return this.pos !== this.start || this.type !== k.template && this.type !== k.invalidTemplate ? (t += this.input.slice(e, this.pos), this.finishToken(k.template, t)) : 36 === i ? (this.pos += 2, this.finishToken(k.dollarBraceL)) : (++this.pos, this.finishToken(k.backQuote));
              if (92 === i) t += this.input.slice(e, this.pos), t += this.readEscapedChar(!0), e = this.pos;else if (C(i)) {
                switch (t += this.input.slice(e, this.pos), ++this.pos, i) {
                  case 13:
                    10 === this.input.charCodeAt(this.pos) && ++this.pos;
                  case 10:
                    t += "\n";
                    break;
                  default:
                    t += String.fromCharCode(i);
                }
                this.options.locations && (++this.curLine, this.lineStart = this.pos), e = this.pos;
              } else ++this.pos;
            }
          }, Lt.readInvalidTemplateToken = function () {
            for (; this.pos < this.input.length; this.pos++) switch (this.input[this.pos]) {
              case "\\":
                ++this.pos;
                break;
              case "$":
                if ("{" !== this.input[this.pos + 1]) break;
              case "`":
                return this.finishToken(k.invalidTemplate, this.input.slice(this.start, this.pos));
            }
            this.raise(this.start, "Unterminated template");
          }, Lt.readEscapedChar = function (t) {
            var e = this.input.charCodeAt(++this.pos);
            switch (++this.pos, e) {
              case 110:
                return "\n";
              case 114:
                return "\r";
              case 120:
                return String.fromCharCode(this.readHexChar(2));
              case 117:
                return Ot(this.readCodePoint());
              case 116:
                return "\t";
              case 98:
                return "\b";
              case 118:
                return "\v";
              case 102:
                return "\f";
              case 13:
                10 === this.input.charCodeAt(this.pos) && ++this.pos;
              case 10:
                return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
              case 56:
              case 57:
                if (this.strict && this.invalidStringToken(this.pos - 1, "Invalid escape sequence"), t) {
                  var i = this.pos - 1;
                  return this.invalidStringToken(i, "Invalid escape sequence in template string"), null;
                }
              default:
                if (e >= 48 && e <= 55) {
                  var s = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0],
                    r = parseInt(s, 8);
                  return r > 255 && (s = s.slice(0, -1), r = parseInt(s, 8)), this.pos += s.length - 1, e = this.input.charCodeAt(this.pos), "0" === s && 56 !== e && 57 !== e || !this.strict && !t || this.invalidStringToken(this.pos - 1 - s.length, t ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(r);
                }
                return C(e) ? "" : String.fromCharCode(e);
            }
          }, Lt.readHexChar = function (t) {
            var e = this.pos,
              i = this.readInt(16, t);
            return null === i && this.invalidStringToken(e, "Bad character escape sequence"), i;
          }, Lt.readWord1 = function () {
            this.containsEsc = !1;
            for (var t = "", e = !0, i = this.pos, s = this.options.ecmaVersion >= 6; this.pos < this.input.length;) {
              var r = this.fullCharCodeAtPos();
              if (m(r, s)) this.pos += r <= 65535 ? 1 : 2;else {
                if (92 !== r) break;
                this.containsEsc = !0, t += this.input.slice(i, this.pos);
                var a = this.pos;
                117 !== this.input.charCodeAt(++this.pos) && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
                var n = this.readCodePoint();
                (e ? f : m)(n, s) || this.invalidStringToken(a, "Invalid Unicode escape"), t += Ot(n), i = this.pos;
              }
              e = !1;
            }
            return t + this.input.slice(i, this.pos);
          }, Lt.readWord = function () {
            var t = this.readWord1(),
              e = k.name;
            return this.keywords.test(t) && (e = b[t]), this.finishToken(e, t);
          };
          F.acorn = {
            Parser: F,
            version: "8.0.5",
            defaultOptions: B,
            Position: O,
            SourceLocation: R,
            getLineInfo: M,
            Node: rt,
            TokenType: g,
            tokTypes: k,
            keywordTypes: b,
            TokContext: ot,
            tokContexts: ht,
            isIdentifierChar: m,
            isIdentifierStart: f,
            Token: Nt,
            isNewLine: C,
            lineBreak: S,
            lineBreakG: w,
            nonASCIIwhitespace: E
          };
          var Mt = i(977),
            Bt = i.n(Mt),
            Dt = i(297),
            jt = i.n(Dt);
          const Ut = {
            class: "className",
            for: "htmlFor",
            maxlength: "maxLength",
            colspan: "colSpan",
            rowspan: "rowSpan"
          };
          var Ft = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"],
            qt = ["table", "tbody", "tfoot", "thead", "tr"];
          function Gt(t) {
            return -1 === Ft.indexOf(t.toLowerCase());
          }
          function Ht(t) {
            return -1 !== qt.indexOf(t.toLowerCase());
          }
          var Wt = function () {
            return function () {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16,
                e = String(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ""),
                i = 0;
              return e.split("").forEach(function (t) {
                i = (i << 5) - i + t.charCodeAt(0), i &= i;
              }), Math.abs(i).toString(t);
            }(Math.random().toString());
          };
          function zt(t, e) {
            var i = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
              var s = Object.getOwnPropertySymbols(t);
              e && (s = s.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })), i.push.apply(i, s);
            }
            return i;
          }
          function Kt(t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = null != arguments[e] ? arguments[e] : {};
              e % 2 ? zt(Object(i), !0).forEach(function (e) {
                Xt(t, e, i[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : zt(Object(i)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
              });
            }
            return t;
          }
          function Xt(t, e, i) {
            return e in t ? Object.defineProperty(t, e, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = i, t;
          }
          function Qt(t) {
            return (Qt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
          }
          var Jt = function (t) {
            switch (Qt(t)) {
              case "string":
                return t.split(";").filter(function (t) {
                  return t;
                }).reduce(function (t, e) {
                  var i = e.slice(0, e.indexOf(":")).trim(),
                    s = e.slice(e.indexOf(":") + 1).trim();
                  return Kt(Kt({}, t), {}, Xt({}, i.replace(/([A-Z])([A-Z])/g, "$1 $2").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[^a-zA-Z\u00C0-\u00ff]/g, " ").toLowerCase().split(" ").filter(function (t) {
                    return t;
                  }).map(function (t, e) {
                    return e > 0 ? t[0].toUpperCase() + t.slice(1) : t;
                  }).join(""), s));
                }, {});
              case "object":
                return t;
              default:
                return;
            }
          };
          function Yt(t) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
            }(t) || function (t, e) {
              if (!t) return;
              if ("string" == typeof t) return Zt(t, e);
              var i = Object.prototype.toString.call(t).slice(8, -1);
              "Object" === i && t.constructor && (i = t.constructor.name);
              if ("Map" === i || "Set" === i) return Array.from(t);
              if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return Zt(t, e);
            }(t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function Zt(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var i = 0, s = new Array(e); i < e; i++) s[i] = t[i];
            return s;
          }
          var $t = function t(e, i) {
              var s = Yt(i),
                r = s[0],
                a = s.slice(1);
              if (null != e && null != r) return 0 === a.length ? e[r] : t(e[r], a);
            },
            te = function (t, e) {
              return $t(t, function (t) {
                return null == t || "" === t ? [] : t.split(".");
              }(e));
            };
          function ee(t) {
            return (ee = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
          }
          function ie(t, e) {
            var i = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
              var s = Object.getOwnPropertySymbols(t);
              e && (s = s.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })), i.push.apply(i, s);
            }
            return i;
          }
          function se(t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = null != arguments[e] ? arguments[e] : {};
              e % 2 ? ie(Object(i), !0).forEach(function (e) {
                fe(t, e, i[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : ie(Object(i)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
              });
            }
            return t;
          }
          function re(t, e) {
            return function (t) {
              if (Array.isArray(t)) return t;
            }(t) || function (t, e) {
              if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
              var i = [],
                s = !0,
                r = !1,
                a = void 0;
              try {
                for (var n, o = t[Symbol.iterator](); !(s = (n = o.next()).done) && (i.push(n.value), !e || i.length !== e); s = !0);
              } catch (t) {
                r = !0, a = t;
              } finally {
                try {
                  s || null == o.return || o.return();
                } finally {
                  if (r) throw a;
                }
              }
              return i;
            }(t, e) || ne(t, e) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function ae(t) {
            return function (t) {
              if (Array.isArray(t)) return oe(t);
            }(t) || function (t) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
            }(t) || ne(t) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function ne(t, e) {
            if (t) {
              if ("string" == typeof t) return oe(t, e);
              var i = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? oe(t, e) : void 0;
            }
          }
          function oe(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var i = 0, s = new Array(e); i < e; i++) s[i] = t[i];
            return s;
          }
          function he(t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }
          function pe(t, e) {
            return (pe = Object.setPrototypeOf || function (t, e) {
              return t.__proto__ = e, t;
            })(t, e);
          }
          function ce(t) {
            var e = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
              } catch (t) {
                return !1;
              }
            }();
            return function () {
              var i,
                s = de(t);
              if (e) {
                var r = de(this).constructor;
                i = Reflect.construct(s, arguments, r);
              } else i = s.apply(this, arguments);
              return le(this, i);
            };
          }
          function le(t, e) {
            return !e || "object" !== ee(e) && "function" != typeof e ? ue(t) : e;
          }
          function ue(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
          }
          function de(t) {
            return (de = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
          }
          function fe(t, e, i) {
            return e in t ? Object.defineProperty(t, e, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[e] = i, t;
          }
          function me(t, e) {
            var i = e.get(t);
            if (!i) throw new TypeError("attempted to get private field on non-instance");
            return i.get ? i.get.call(t) : i.value;
          }
          var ge = new WeakMap(),
            xe = new WeakMap(),
            ye = new WeakMap(),
            ve = new WeakMap(),
            be = new WeakMap(),
            _e = function (t) {
              !function (t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                  constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                  }
                }), e && pe(t, e);
              }(i, t);
              var e = ce(i);
              function i() {
                var t;
                he(this, i);
                for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++) r[a] = arguments[a];
                return fe(ue(t = e.call.apply(e, [this].concat(r))), "ParsedChildren", null), ge.set(ue(t), {
                  writable: !0,
                  value: function (e) {
                    var i = F.extend(Bt()({
                        autoCloseVoidElements: t.props.autoCloseVoidElements
                      })),
                      s = "<root>".concat(e, "</root>"),
                      r = [];
                    try {
                      r = (r = i.parse(s, {
                        ecmaVersion: "latest"
                      })).body[0].expression.children || [];
                    } catch (e) {
                      return t.props.showWarnings && console.warn(e), t.props.onError && t.props.onError(e), t.props.renderError ? t.props.renderError({
                        error: String(e)
                      }) : null;
                    }
                    return r.map(function (e) {
                      return me(ue(t), xe).call(ue(t), e);
                    }).filter(Boolean);
                  }
                }), xe.set(ue(t), {
                  writable: !0,
                  value: function (e, i) {
                    switch (e.type) {
                      case "JSXAttribute":
                        return null === e.value || me(ue(t), xe).call(ue(t), e.value, i);
                      case "JSXElement":
                      case "JSXFragment":
                        return me(ue(t), be).call(ue(t), e, i);
                      case "JSXExpressionContainer":
                        return me(ue(t), xe).call(ue(t), e.expression, i);
                      case "JSXText":
                        var s = t.props.disableKeyGeneration ? void 0 : Wt();
                        return t.props.disableFragments ? e.value : jt().createElement(Dt.Fragment, {
                          key: s
                        }, e.value);
                      case "ArrayExpression":
                        return e.elements.map(function (e) {
                          return me(ue(t), xe).call(ue(t), e, i);
                        });
                      case "BinaryExpression":
                        switch (e.operator) {
                          case "-":
                            return me(ue(t), xe).call(ue(t), e.left) - me(ue(t), xe).call(ue(t), e.right);
                          case "!=":
                            return me(ue(t), xe).call(ue(t), e.left) != me(ue(t), xe).call(ue(t), e.right);
                          case "!==":
                            return me(ue(t), xe).call(ue(t), e.left) !== me(ue(t), xe).call(ue(t), e.right);
                          case "*":
                            return me(ue(t), xe).call(ue(t), e.left) * me(ue(t), xe).call(ue(t), e.right);
                          case "**":
                            return Math.pow(me(ue(t), xe).call(ue(t), e.left), me(ue(t), xe).call(ue(t), e.right));
                          case "/":
                            return me(ue(t), xe).call(ue(t), e.left) / me(ue(t), xe).call(ue(t), e.right);
                          case "%":
                            return me(ue(t), xe).call(ue(t), e.left) % me(ue(t), xe).call(ue(t), e.right);
                          case "+":
                            return me(ue(t), xe).call(ue(t), e.left) + me(ue(t), xe).call(ue(t), e.right);
                          case "<":
                            return me(ue(t), xe).call(ue(t), e.left) < me(ue(t), xe).call(ue(t), e.right);
                          case "<=":
                            return me(ue(t), xe).call(ue(t), e.left) <= me(ue(t), xe).call(ue(t), e.right);
                          case "==":
                            return me(ue(t), xe).call(ue(t), e.left) == me(ue(t), xe).call(ue(t), e.right);
                          case "===":
                            return me(ue(t), xe).call(ue(t), e.left) === me(ue(t), xe).call(ue(t), e.right);
                          case ">":
                            return me(ue(t), xe).call(ue(t), e.left) > me(ue(t), xe).call(ue(t), e.right);
                          case ">=":
                            return me(ue(t), xe).call(ue(t), e.left) >= me(ue(t), xe).call(ue(t), e.right);
                        }
                        return;
                      case "CallExpression":
                        var r = me(ue(t), xe).call(ue(t), e.callee);
                        return void 0 === r ? void t.props.onError(new Error("The expression '".concat(e.callee, "' could not be resolved, resulting in an undefined return value."))) : r.apply(void 0, ae(e.arguments.map(function (i) {
                          return me(ue(t), xe).call(ue(t), i, e.callee);
                        })));
                      case "ConditionalExpression":
                        return me(ue(t), xe).call(ue(t), e.test) ? me(ue(t), xe).call(ue(t), e.consequent) : me(ue(t), xe).call(ue(t), e.alternate);
                      case "ExpressionStatement":
                        return me(ue(t), xe).call(ue(t), e.expression);
                      case "Identifier":
                        return i && e.name in i ? i[e.name] : (t.props.bindings || {})[e.name];
                      case "Literal":
                        return e.value;
                      case "LogicalExpression":
                        var a = me(ue(t), xe).call(ue(t), e.left);
                        return "||" === e.operator && a ? a : !!("&&" === e.operator && a || "||" === e.operator && !a) && me(ue(t), xe).call(ue(t), e.right);
                      case "MemberExpression":
                        return me(ue(t), ye).call(ue(t), e, i);
                      case "ObjectExpression":
                        var n = {};
                        return e.properties.forEach(function (e) {
                          n[e.key.name || e.key.value] = me(ue(t), xe).call(ue(t), e.value);
                        }), n;
                      case "TemplateElement":
                        return e.value.cooked;
                      case "TemplateLiteral":
                        return [].concat(ae(e.expressions), ae(e.quasis)).sort(function (t, e) {
                          return t.start < e.start ? -1 : 1;
                        }).map(function (e) {
                          return me(ue(t), xe).call(ue(t), e);
                        }).join("");
                      case "UnaryExpression":
                        switch (e.operator) {
                          case "+":
                            return e.argument.value;
                          case "-":
                            return -e.argument.value;
                          case "!":
                            return !e.argument.value;
                        }
                        return;
                      case "ArrowFunctionExpression":
                        var o, h;
                        if (e.async || e.generator) null === (o = (h = t.props).onError) || void 0 === o || o.call(h, new Error("Async and generator arrow functions are not supported."));
                        return function () {
                          for (var i = arguments.length, s = new Array(i), r = 0; r < i; r++) s[r] = arguments[r];
                          var a = {};
                          return e.params.forEach(function (t, e) {
                            a[t.name] = s[e];
                          }), me(ue(t), xe).call(ue(t), e.body, a);
                        };
                    }
                  }
                }), ye.set(ue(t), {
                  writable: !0,
                  value: function (e, i) {
                    var s,
                      r,
                      a,
                      n,
                      o = e.object,
                      h = [null !== (s = null === (r = e.property) || void 0 === r ? void 0 : r.name) && void 0 !== s ? s : JSON.parse(null !== (a = null === (n = e.property) || void 0 === n ? void 0 : n.raw) && void 0 !== a ? a : '""')];
                    if ("Literal" !== e.object.type) for (; o && ["MemberExpression", "Literal"].includes(null === (p = o) || void 0 === p ? void 0 : p.type);) {
                      var p,
                        c,
                        l,
                        u = o.property;
                      if (o.computed) h.unshift(me(ue(t), xe).call(ue(t), u, i));else h.unshift(null !== (c = null == u ? void 0 : u.name) && void 0 !== c ? c : JSON.parse(null !== (l = null == u ? void 0 : u.raw) && void 0 !== l ? l : '""'));
                      o = o.object;
                    }
                    var d = me(ue(t), xe).call(ue(t), o, i);
                    try {
                      var f = d,
                        m = h.reduce(function (t, e) {
                          return f = t, t[e];
                        }, d);
                      return "function" == typeof m ? m.bind(f) : m;
                    } catch (e) {
                      var g,
                        x = (null === (g = o) || void 0 === g ? void 0 : g.name) || "unknown";
                      t.props.onError(new Error("Unable to parse ".concat(x, '["').concat(h.join('"]["'), '"]}')));
                    }
                  }
                }), ve.set(ue(t), {
                  writable: !0,
                  value: function (e) {
                    return "JSXIdentifier" === e.type ? e.name : "".concat(me(ue(t), ve).call(ue(t), e.object), ".").concat(me(ue(t), ve).call(ue(t), e.property));
                  }
                }), be.set(ue(t), {
                  writable: !0,
                  value: function (e, i) {
                    var s = t.props,
                      r = s.allowUnknownElements,
                      a = s.components,
                      n = s.componentsOnly,
                      o = s.onError,
                      h = e.children,
                      p = void 0 === h ? [] : h,
                      c = "JSXElement" === e.type ? e.openingElement : e.openingFragment,
                      l = c.attributes,
                      u = void 0 === l ? [] : l,
                      d = "JSXElement" === e.type ? me(ue(t), ve).call(ue(t), c.name) : "",
                      f = (t.props.blacklistedAttrs || []).map(function (t) {
                        return t instanceof RegExp ? t : new RegExp(t, "i");
                      }),
                      m = (t.props.blacklistedTags || []).map(function (t) {
                        return t.trim().toLowerCase();
                      }).filter(Boolean);
                    if (/^(html|head|body)$/i.test(d)) return p.map(function (e) {
                      return me(ue(t), be).call(ue(t), e, i);
                    });
                    var g,
                      x = d.trim().toLowerCase();
                    if (-1 !== m.indexOf(x)) return o(new Error("The tag <".concat(d, "> is blacklisted, and will not be rendered."))), null;
                    if ("" !== d && !te(a, d)) {
                      if (n) return o(new Error("The component <".concat(d, "> is unrecognized, and will not be rendered."))), t.props.renderUnrecognized(d);
                      if (!r && document.createElement(d) instanceof HTMLUnknownElement) return o(new Error("The tag <".concat(d, "> is unrecognized in this browser, and will not be rendered."))), t.props.renderUnrecognized(d);
                    }
                    var y = "JSXElement" === e.type ? te(a, d) : Dt.Fragment;
                    if (y || Gt(d)) if (g = p.map(function (e) {
                      return me(ue(t), xe).call(ue(t), e, i);
                    }), y || Ht(d) || (g = g.filter(function (t) {
                      return "string" != typeof t || !/^\s*$/.test(t);
                    })), 0 === g.length) g = void 0;else if (1 === g.length) {
                      g = re(g, 1)[0];
                    } else g.length > 1 && !t.props.disableKeyGeneration && (g = g.map(function (t, e) {
                      return null == t || !t.type || null != t && t.key ? t : se(se({}, t), {}, {
                        key: t.key || e
                      });
                    }));
                    var v = {
                      key: t.props.disableKeyGeneration ? void 0 : Wt()
                    };
                    u.forEach(function (e) {
                      if ("JSXAttribute" === e.type) {
                        var s = e.name.name,
                          r = Ut[s] || s,
                          a = me(ue(t), xe).call(ue(t), e, i);
                        0 === f.filter(function (t) {
                          return t.test(r);
                        }).length && (v[r] = a);
                      } else if ("JSXSpreadAttribute" === e.type && "Identifier" === e.argument.type || "MemberExpression" === e.argument.type) {
                        var n = me(ue(t), xe).call(ue(t), e.argument, i);
                        "object" === ee(n) && Object.keys(n).forEach(function (t) {
                          var e = Ut[t] || t;
                          0 === f.filter(function (t) {
                            return t.test(e);
                          }).length && (v[e] = n[t]);
                        });
                      }
                    }), "string" == typeof v.style && (v.style = Jt(v.style));
                    var b = d.toLowerCase();
                    return "option" === b && (g = g.props.children), jt().createElement(y || b, v, g);
                  }
                }), fe(ue(t), "render", function () {
                  var e = (t.props.jsx || "").trim().replace(/<!DOCTYPE([^>]*)>/g, "");
                  t.ParsedChildren = me(ue(t), ge).call(ue(t), e);
                  var i = ae(new Set(["jsx-parser"].concat(ae(String(t.props.className).split(" "))))).filter(Boolean).join(" ");
                  return t.props.renderInWrapper ? jt().createElement("div", {
                    className: i
                  }, t.ParsedChildren) : jt().createElement(jt().Fragment, null, t.ParsedChildren);
                }), t;
              }
              return i;
            }(jt().Component);
          fe(_e, "displayName", "JsxParser"), fe(_e, "defaultProps", {
            allowUnknownElements: !0,
            autoCloseVoidElements: !1,
            bindings: {},
            blacklistedAttrs: [/^on.+/i],
            blacklistedTags: ["script"],
            className: "",
            components: {},
            componentsOnly: !1,
            disableFragments: !1,
            disableKeyGeneration: !1,
            jsx: "",
            onError: function () {},
            showWarnings: !1,
            renderError: void 0,
            renderInWrapper: !0,
            renderUnrecognized: function () {
              return null;
            }
          });
        },
        297: e => {
          "use strict";

          e.exports = t;
        }
      },
      i = {};
    function s(t) {
      if (i[t]) return i[t].exports;
      var r = i[t] = {
        exports: {}
      };
      return e[t].call(r.exports, r, r.exports, s), r.exports;
    }
    return s.n = t => {
      var e = t && t.__esModule ? () => t.default : () => t;
      return s.d(e, {
        a: e
      }), e;
    }, s.d = (t, e) => {
      for (var i in e) s.o(e, i) && !s.o(t, i) && Object.defineProperty(t, i, {
        enumerable: !0,
        get: e[i]
      });
    }, s.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), s.r = t => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, s(272);
  })();
});